import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from './network/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type AddAdvisorConversationMessageInputDto = {
  content: Scalars['String'];
  proposalId: Scalars['String'];
};

export type AddNavigationToSearchQueryInputDto = {
  fromMap?: InputMaybe<Scalars['Boolean']>;
  navigationParams: NavigationParamsInputDto;
  searchId: Scalars['String'];
  sessionId: Scalars['String'];
};

export type AddProjectAdditionToSearchQueryInputDto = {
  fromMap?: InputMaybe<Scalars['Boolean']>;
  projectAdditionParams: ProjectAdditionParamsInputDto;
  searchId: Scalars['String'];
  sessionId: Scalars['String'];
};

export type AddQueryToSearchSessionInputDto = {
  fromMap?: InputMaybe<Scalars['Boolean']>;
  origin: Scalars['String'];
  resultIds?: InputMaybe<Array<Scalars['String']>>;
  runningInfo: DataRunningInfoInputDto;
  searchParams: HouseSearchInputDto;
  sessionId?: InputMaybe<Scalars['String']>;
};

export type AddQueryToSearchSessionOutputDto = {
  __typename?: 'AddQueryToSearchSessionOutputDto';
  searchId: Scalars['String'];
  sessionId: Scalars['String'];
};

export type AddressContext = {
  __typename?: 'AddressContext';
  city?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Array<Scalars['Float']>>;
  country?: Maybe<Scalars['String']>;
  countryIsoCode?: Maybe<Iso3166Alpha2Enum>;
  department?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  placeId?: Maybe<Scalars['String']>;
  placeLabel?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type AddressDepartmentMostBookedDataOutputDto = {
  __typename?: 'AddressDepartmentMostBookedDataOutputDto';
  bookingsNumber: Scalars['Float'];
  housesNumber: Scalars['Float'];
  mostBookedHouseId?: Maybe<Scalars['String']>;
};

export type AddressDepartmentOutputDto = {
  __typename?: 'AddressDepartmentOutputDto';
  _id: Scalars['String'];
  countHouses?: Maybe<Scalars['Int']>;
  countryIsoCode: Iso3166Alpha2Enum;
  departmentNumber: Scalars['String'];
  label: Scalars['String'];
  mostBookedData: AddressDepartmentMostBookedDataOutputDto;
  picture: Scalars['String'];
  placeId: Scalars['String'];
};

export type AdminLightOutputDto = {
  __typename?: 'AdminLightOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminModel = {
  __typename?: 'AdminModel';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  hashedRt: Array<Scalars['String']>;
  hubspot?: Maybe<Scalars['String']>;
  hubspotInternal?: Maybe<Scalars['String']>;
  hubspotMeetingUrl?: Maybe<Scalars['String']>;
  lastConnect: Scalars['DateTime'];
  lastname: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture: Scalars['String'];
  slackUserId?: Maybe<Scalars['String']>;
  teamsMeetingUrl?: Maybe<Scalars['String']>;
  travelCity?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminOutputDto = {
  __typename?: 'AdminOutputDto';
  _id: Scalars['ID'];
  billingEntity: BillingEntityEnum;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  featureFlags: Array<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  hubspot?: Maybe<Scalars['String']>;
  hubspotInternal?: Maybe<Scalars['String']>;
  hubspotMeetingUrl?: Maybe<Scalars['String']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  lastConnect?: Maybe<Scalars['DateTime']>;
  lastname?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  role?: Maybe<AdminRoleOutputDto>;
  roleId?: Maybe<Scalars['String']>;
  slackUserId?: Maybe<Scalars['String']>;
  teamsMeetingUrl?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum AdminPageEnum {
  ALGO_YODAI = 'ALGO_YODAI',
  BLACKLISTED_EMAILS = 'BLACKLISTED_EMAILS',
  CONSOLE = 'CONSOLE',
  CONTENT_ARTICLES = 'CONTENT_ARTICLES',
  CONTENT_EQUIPMENTS = 'CONTENT_EQUIPMENTS',
  CONTENT_TAGS = 'CONTENT_TAGS',
  DASHBOARD_FINANCE = 'DASHBOARD_FINANCE',
  GENERATOR_BILLING_TRANSFER = 'GENERATOR_BILLING_TRANSFER',
  GENERATOR_CLIENT_REQUESTS = 'GENERATOR_CLIENT_REQUESTS',
  LIST_COMPANIES = 'LIST_COMPANIES',
  LIST_HOUSES = 'LIST_HOUSES',
  LIST_MARKETPLACE = 'LIST_MARKETPLACE',
  LIST_OWNERS = 'LIST_OWNERS',
  LIST_SERVICE_OWNERS = 'LIST_SERVICE_OWNERS',
  LIST_SERVICE_PROVIDERS = 'LIST_SERVICE_PROVIDERS',
  LIST_USERS = 'LIST_USERS',
  OFFICE_ADMINS = 'OFFICE_ADMINS',
  OFFICE_LOGS = 'OFFICE_LOGS',
  OFFICE_ROLES = 'OFFICE_ROLES',
  SEARCH = 'SEARCH'
}

export enum AdminPermissionTypeEnum {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type AdminRoleInputDto = {
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<AdminRoleInputPermissionDto>>;
};

export type AdminRoleInputPermissionDto = {
  page: AdminPageEnum;
  permission: AdminPermissionTypeEnum;
};

export type AdminRoleOutputDto = {
  __typename?: 'AdminRoleOutputDto';
  _id: Scalars['ID'];
  countAdmins?: Maybe<Scalars['Float']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  permissions: Array<AdminRolePermissionOutputDto>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminRolePermissionOutputDto = {
  __typename?: 'AdminRolePermissionOutputDto';
  page: AdminPageEnum;
  permission: AdminPermissionTypeEnum;
};

export type AdminWordInputDto = {
  description: Scalars['String'];
  descriptionTitle: Scalars['String'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['String'];
  title: Scalars['String'];
};

export type AdvisorConversationAdminMessageOutputDto = {
  __typename?: 'AdvisorConversationAdminMessageOutputDto';
  admin: AdminOutputDto;
  adminId: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sentAt: Scalars['DateTime'];
};

export type AdvisorConversationContactMessageOutputDto = {
  __typename?: 'AdvisorConversationContactMessageOutputDto';
  contact: UserOutputDto;
  contactId: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sentAt: Scalars['DateTime'];
};

export type AdvisorConversationMessageOutputDto = AdvisorConversationAdminMessageOutputDto | AdvisorConversationContactMessageOutputDto;

export type AdvisorConversationNotificationsByClientRequestOutputDto = {
  __typename?: 'AdvisorConversationNotificationsByClientRequestOutputDto';
  messageIds: Array<Scalars['String']>;
  proposalId: Scalars['String'];
};

export type AdvisorConversationNotificationsByContactOutputDto = {
  __typename?: 'AdvisorConversationNotificationsByContactOutputDto';
  clientRequestId: Scalars['String'];
  messageIds: Array<Scalars['String']>;
  proposalId: Scalars['String'];
};

export type AdvisorConversationOutputDto = {
  __typename?: 'AdvisorConversationOutputDto';
  admins: Array<AdminOutputDto>;
  messages: Array<AdvisorConversationMessageOutputDto>;
  users: Array<UserOutputDto>;
};

export enum AirConditioningEnum {
  NO = 'NO',
  YES = 'YES'
}

export enum AmbianceEnum {
  BEACH = 'BEACH',
  COUNTRYSIDE = 'COUNTRYSIDE',
  MOUNTAIN = 'MOUNTAIN',
  URBAN = 'URBAN'
}

export type ArrivalDepartureHours = {
  arrivalHour?: InputMaybe<Scalars['String']>;
  departureHour?: InputMaybe<Scalars['String']>;
};

export enum ArrivalEnum {
  BEFORE_LUNCH = 'BEFORE_LUNCH',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}

export enum ArticleCategoryEnum {
  ALL = 'ALL',
  FUTURE_OF_WORK = 'FUTURE_OF_WORK',
  GUIDE = 'GUIDE',
  SEMINAR = 'SEMINAR',
  TEAM_BUILDING = 'TEAM_BUILDING',
  TESTIMONIES = 'TESTIMONIES'
}

export type ArticleIllustrationInputDto = {
  informations?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ArticleIllustrationOutputDto = {
  __typename?: 'ArticleIllustrationOutputDto';
  informations?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ArticleOuputDto = {
  __typename?: 'ArticleOuputDto';
  _id: Scalars['ID'];
  abstractContent?: Maybe<Scalars['String']>;
  author?: Maybe<AdminOutputDto>;
  authorId?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<ArticleCategoryEnum>>;
  content?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  illustration?: Maybe<ArticleIllustrationOutputDto>;
  pathname?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  status?: Maybe<ArticleStatusEnum>;
  title: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ArticleStatusEnum {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type AuthDto = {
  domain?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  isMiceUser?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  provider?: InputMaybe<UserProviderTypeEnum>;
};

export type AuthRegistrationDto = {
  domain?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstname?: InputMaybe<Scalars['String']>;
  fullUrl?: InputMaybe<Scalars['String']>;
  gclid?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<UserProviderTypeEnum>;
  search?: InputMaybe<FilterSearchDto>;
  threadId?: InputMaybe<Scalars['String']>;
};

export type BackwardPaginationInputDto = {
  before?: InputMaybe<Scalars['String']>;
  last: Scalars['Int'];
};

export enum BedTypeEnum {
  BUNK_BED = 'BUNK_BED',
  DOUBLE = 'DOUBLE',
  DOUBLE_140 = 'DOUBLE_140',
  DOUBLE_160 = 'DOUBLE_160',
  DOUBLE_180 = 'DOUBLE_180',
  FLEXIBLE = 'FLEXIBLE',
  FLEXIBLE_140 = 'FLEXIBLE_140',
  FLEXIBLE_160 = 'FLEXIBLE_160',
  FLEXIBLE_180 = 'FLEXIBLE_180',
  SINGLE = 'SINGLE',
  SOFA = 'SOFA',
  TRUCKLE_BED = 'TRUCKLE_BED'
}

export type BedroomDto = {
  _id: Scalars['String'];
  beds?: InputMaybe<Array<BedTypeEnum>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  hasBathroom: Scalars['Boolean'];
  hasWorkingSpace: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  pictures: Array<UpdateHousePictureDto>;
  position: Scalars['Float'];
};

export enum BillingEntityEnum {
  BIZMEETING = 'BIZMEETING',
  NABOO = 'NABOO'
}

export type BillingTransferAdminPaginatedInputDto = {
  filters?: InputMaybe<BillingTransferFilterAdminInputDto>;
  paginationArgsBackward?: InputMaybe<BackwardPaginationInputDto>;
  paginationArgsForward?: InputMaybe<ForwardPaginationInputDto>;
};

export type BillingTransferAppPaginatedInputDto = {
  paginationArgsBackward?: InputMaybe<BackwardPaginationInputDto>;
  paginationArgsForward?: InputMaybe<ForwardPaginationInputDto>;
};

export type BillingTransferBillInformationInputDto = {
  iban?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  placeId: Scalars['String'];
  siret?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type BillingTransferBillInformationOutputDto = {
  __typename?: 'BillingTransferBillInformationOutputDto';
  address?: Maybe<AddressContext>;
  iban?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  siret?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type BillingTransferFilterAdminInputDto = {
  q?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BillingTransferStatusEnum>;
};

export type BillingTransferIssuerOutputDto = {
  __typename?: 'BillingTransferIssuerOutputDto';
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type BillingTransferNabooDocumentInputDto = {
  filename: Scalars['String'];
  priceWithVat: Scalars['Float'];
  priceWithoutVat: Scalars['Float'];
  url: Scalars['String'];
};

export type BillingTransferNabooDocumentOutputDto = {
  __typename?: 'BillingTransferNabooDocumentOutputDto';
  filename: Scalars['String'];
  priceWithVat: Scalars['Float'];
  priceWithoutVat: Scalars['Float'];
  url: Scalars['String'];
};

export type BillingTransferOutputDto = {
  __typename?: 'BillingTransferOutputDto';
  _id: Scalars['ID'];
  adminFinance: CompanyOutputDto;
  adminFinanceId?: Maybe<Scalars['String']>;
  adminSales: CompanyOutputDto;
  adminSalesId?: Maybe<Scalars['String']>;
  billingInformation?: Maybe<BillingTransferBillInformationOutputDto>;
  clientDocuments: Array<DocumentOutputDto>;
  company: CompanyOutputDto;
  companyId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  issuer: BillingTransferIssuerOutputDto;
  nabooCancelDocument?: Maybe<DocumentOutputDto>;
  nabooDocument?: Maybe<BillingTransferNabooDocumentOutputDto>;
  readableId: Scalars['String'];
  status: BillingTransferStatusEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserOutputDto;
  userId: Scalars['String'];
};

export type BillingTransferOutputDtoEdge = {
  __typename?: 'BillingTransferOutputDtoEdge';
  cursor: Scalars['String'];
  node: BillingTransferOutputDto;
};

export type BillingTransferOutputDtoPageInfo = {
  __typename?: 'BillingTransferOutputDtoPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export enum BillingTransferStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  CONFIRMED = 'CONFIRMED'
}

export type BlacklistedEmailOutputDto = {
  __typename?: 'BlacklistedEmailOutputDto';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  domain: Scalars['String'];
  lastAttemptAt?: Maybe<Scalars['DateTime']>;
  nbAttempts: Scalars['Int'];
};

export type BlacklistedEmailPaginationInputDto = {
  filters?: InputMaybe<BlacklistedEmailSearchFiltersInputDto>;
  pagination?: InputMaybe<PaginationDto>;
};

export type BlacklistedEmailSearchFiltersInputDto = {
  q?: InputMaybe<Scalars['String']>;
};

export enum BookableDaysEnum {
  BETWEEN_100_AND_200 = 'BETWEEN_100_AND_200',
  LESS_THAN_100 = 'LESS_THAN_100',
  MORE_THAN_200 = 'MORE_THAN_200'
}

export type BookingPrice = {
  __typename?: 'BookingPrice';
  fees?: Maybe<BookingPriceFees>;
  feesWithDiscount?: Maybe<BookingPriceFees>;
  feesWithDiscountByVatRates?: Maybe<Array<BookingPriceFees>>;
  housePrice?: Maybe<PriceObjectOutputDto>;
  marginRate?: Maybe<ComputedPrice>;
  priceItems?: Maybe<Array<ClientPricingItemOutputDto>>;
  quotationDifference?: Maybe<QuotationDifferenceOutputDto>;
  totalActivity?: Maybe<PriceObjectOutputDto>;
  totalOwner?: Maybe<PriceObjectOutputDto>;
  totalPerVatRates?: Maybe<Array<PriceObjectOutputDto>>;
  totalRestauration?: Maybe<PriceObjectOutputDto>;
  totalTransport?: Maybe<PriceObjectOutputDto>;
  totalUser?: Maybe<PriceObjectOutputDto>;
  totalUserWithoutFeesAdjustments?: Maybe<PriceObjectOutputDto>;
  totalVat0?: Maybe<PriceObjectOutputDto>;
  totalVat10?: Maybe<PriceObjectOutputDto>;
  totalVat20?: Maybe<PriceObjectOutputDto>;
};

export type BookingPriceFees = {
  __typename?: 'BookingPriceFees';
  owner?: Maybe<ComputedPrice>;
  total?: Maybe<ComputedPrice>;
  user?: Maybe<ComputedPrice>;
};

export type BudgetByTravelTypeInputDto = {
  corporateEveningEvent?: InputMaybe<Array<TravelPoliciesBudgetInputDto>>;
  dailyTrip?: InputMaybe<Array<TravelPoliciesBudgetInputDto>>;
  nightlyTrip?: InputMaybe<Array<TravelPoliciesBudgetInputDto>>;
};

export type BudgetByTravelTypeOutputDto = {
  __typename?: 'BudgetByTravelTypeOutputDto';
  corporateEveningEvent?: Maybe<Array<TravelPoliciesBudgetOutputDto>>;
  dailyTrip?: Maybe<Array<TravelPoliciesBudgetOutputDto>>;
  nightlyTrip?: Maybe<Array<TravelPoliciesBudgetOutputDto>>;
};

export type BudgetContext = {
  __typename?: 'BudgetContext';
  datesPrice?: Maybe<Scalars['Float']>;
  highSeasonPrice?: Maybe<Scalars['Float']>;
  lowSeasonPrice?: Maybe<Scalars['Float']>;
};

export type BudgetMinMaxRequested = {
  __typename?: 'BudgetMinMaxRequested';
  budget?: Maybe<Scalars['Float']>;
  budgetMax?: Maybe<Scalars['Float']>;
  budgetMin?: Maybe<Scalars['Float']>;
};

export type BudgetParticipantsContext = {
  __typename?: 'BudgetParticipantsContext';
  dayTripPackage?: Maybe<Scalars['Float']>;
  singlePackage?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  twinPackage?: Maybe<Scalars['Float']>;
};

export type BudgetRequestedContext = {
  __typename?: 'BudgetRequestedContext';
  amountPerPersonPerDay?: Maybe<BudgetMinMaxRequested>;
  amountTotal?: Maybe<BudgetMinMaxRequested>;
  canUseNumberOfParticipants: Scalars['Boolean'];
  filterBudgetType: FilterBudgetTypeEnum;
  numberOfParticipantsSingle?: Maybe<Scalars['Float']>;
  numberOfParticipantsTwin?: Maybe<Scalars['Float']>;
};

export type BudgetSuggestionContext = {
  __typename?: 'BudgetSuggestionContext';
  budgets?: Maybe<BudgetsContext>;
  numberOfParticipants?: Maybe<BudgetParticipantsContext>;
};

export type BudgetsContext = {
  __typename?: 'BudgetsContext';
  allInclusiveBudget?: Maybe<BudgetContext>;
  dayBudget?: Maybe<BudgetContext>;
  houseBudget?: Maybe<BudgetContext>;
};

export type CancellationDataOutputDto = {
  __typename?: 'CancellationDataOutputDto';
  cancellationFeesCommissionRate: Scalars['Int'];
  cancellationFeesRate: Scalars['Int'];
  cancellationFeesVatRate: Scalars['Int'];
};

export type CarbonEmissionsOutputDto = {
  __typename?: 'CarbonEmissionsOutputDto';
  accommodationEmissionsCount?: Maybe<Scalars['Float']>;
  activitiesEmissionsCount?: Maybe<Scalars['Float']>;
  cateringEmissionsCount?: Maybe<Scalars['Float']>;
  totalEmissionsCount?: Maybe<Scalars['Float']>;
  transportEmissionsCount?: Maybe<Scalars['Float']>;
};

export type CityType = {
  __typename?: 'CityType';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  maxDistanceInMeters?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type ClientCarbonFootprintDepartureCityInputDto = {
  description: Scalars['String'];
  distanceInMeters: Scalars['Int'];
  placeId: Scalars['String'];
};

export type ClientCarbonFootprintDepartureCityOutputDto = {
  __typename?: 'ClientCarbonFootprintDepartureCityOutputDto';
  description: Scalars['String'];
  distanceInMeters: Scalars['Int'];
  placeId: Scalars['String'];
};

export type ClientCarbonFootprintInputDto = {
  departureCity: ClientCarbonFootprintDepartureCityInputDto;
  lastKmsTransport: LastKmsTransportEnum;
  mealsType: MealsTypeEnum;
  transport: TransportEnum;
};

export type ClientCarbonFootprintOutputDto = {
  __typename?: 'ClientCarbonFootprintOutputDto';
  carbonEmissions?: Maybe<CarbonEmissionsOutputDto>;
  departureCity?: Maybe<ClientCarbonFootprintDepartureCityOutputDto>;
  isDataManual: Scalars['Boolean'];
  lastKmsTransport?: Maybe<LastKmsTransportEnum>;
  mealsType?: Maybe<MealsTypeEnum>;
  transport?: Maybe<TransportEnum>;
};

export enum ClientFeelingEnum {
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
  LOVE = 'LOVE',
  NONE = 'NONE'
}

export enum ClientPricingItemAdjustmentStatusEnum {
  ADDED = 'ADDED',
  REMOVED = 'REMOVED'
}

export enum ClientPricingItemDepositStatusEnum {
  FINAL = 'FINAL',
  INITIAL = 'INITIAL',
  POST_FINAL = 'POST_FINAL'
}

export type ClientPricingItemFromMenuInputDto = {
  objectId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  type: ClientPricingItemTypeEnum;
};

export type ClientPricingItemInputDto = {
  _id?: InputMaybe<Scalars['String']>;
  category: ServiceProviderCategoryEnum;
  isSavedWithVat?: InputMaybe<Scalars['Boolean']>;
  isSelectedHostOption?: InputMaybe<Scalars['Boolean']>;
  objectData?: InputMaybe<ClientPricingItemObjectDataInputDto>;
  option: ClientPricingItemOptionInputDto;
  priceOption: PriceObjectOptionInputDto;
  taxIdentifier?: InputMaybe<TaxIdentifierEnum>;
  type: ClientPricingItemTypeEnum;
  unitPrice?: InputMaybe<PriceObjectInputDto>;
};

export type ClientPricingItemObjectDataInputDto = {
  currencyArea?: InputMaybe<CurrencyAreaInputDto>;
  description?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  nestedItemsObjectData?: InputMaybe<Array<NestedItemObjectDataInputDto>>;
  prices: Array<ClientPricingItemObjectDataPriceInputDto>;
  recommended?: InputMaybe<Scalars['Boolean']>;
  serviceOwnerId?: InputMaybe<Scalars['String']>;
  serviceProvisionEnvironments?: InputMaybe<Array<ServiceProvisionEnvironmentEnum>>;
  serviceProvisionMainPicture?: InputMaybe<ServiceProvisionPictureInputDto>;
  serviceProvisionTakePlaces?: InputMaybe<Array<ServiceProvisionTakePlaceEnum>>;
  serviceProvisionTravelTypes?: InputMaybe<Array<TravelTypeEnum>>;
  serviceProvisionType?: InputMaybe<ServiceProvisionTypeEnum>;
  serviceProvisionWithCulteryDishesGlass?: InputMaybe<Scalars['Boolean']>;
  serviceProvisionWithService?: InputMaybe<Scalars['Boolean']>;
  taxIdentifier?: InputMaybe<TaxIdentifierEnum>;
};

export type ClientPricingItemObjectDataOutputDto = {
  __typename?: 'ClientPricingItemObjectDataOutputDto';
  currencyArea: CurrencyAreaOutputDto;
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  nestedItemsObjectData?: Maybe<Array<NestedItemObjectDataOutputDto>>;
  prices: Array<ClientPricingItemObjectDataPriceOutputDto>;
  recommended?: Maybe<Scalars['Boolean']>;
  seasonPrices?: Maybe<ClientPricingItemSeasonPricesOutputDto>;
  serviceOwnerId?: Maybe<Scalars['String']>;
  serviceProvisionEnvironments?: Maybe<Array<ServiceProvisionEnvironmentEnum>>;
  serviceProvisionMainPicture?: Maybe<ServiceProvisionPictureOutputDto>;
  serviceProvisionTakePlaces?: Maybe<Array<ServiceProvisionTakePlaceEnum>>;
  serviceProvisionTravelTypes?: Maybe<Array<TravelTypeEnum>>;
  serviceProvisionType?: Maybe<ServiceProvisionTypeEnum>;
  serviceProvisionWithCulteryDishesGlass?: Maybe<Scalars['Boolean']>;
  serviceProvisionWithService?: Maybe<Scalars['Boolean']>;
  startingFees?: Maybe<ClientPricingItemObjectDataPriceOutputDto>;
  taxIdentifier: TaxIdentifierEnum;
};

export type ClientPricingItemObjectDataPriceInputDto = {
  _id: Scalars['ID'];
  maxAdults?: InputMaybe<Scalars['Int']>;
  minAdults?: InputMaybe<Scalars['Int']>;
  unit: ServiceProvisionUnitEnum;
  vatPrices: Array<ComputedPriceDto>;
};

export type ClientPricingItemObjectDataPriceOutputDto = {
  __typename?: 'ClientPricingItemObjectDataPriceOutputDto';
  _id: Scalars['ID'];
  maxAdults?: Maybe<Scalars['Int']>;
  minAdults?: Maybe<Scalars['Int']>;
  price: PriceObjectOutputDto;
  season?: Maybe<SeasonEnum>;
  unit: ServiceProvisionUnitEnum;
  vatPrices: Array<ComputedPrice>;
};

export type ClientPricingItemOptionInputDto = {
  objectId?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
};

export type ClientPricingItemOptionOutputDto = {
  __typename?: 'ClientPricingItemOptionOutputDto';
  objectId?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
};

export type ClientPricingItemOutputDto = {
  __typename?: 'ClientPricingItemOutputDto';
  _id: Scalars['ID'];
  adjustmentStatus?: Maybe<ClientPricingItemAdjustmentStatusEnum>;
  cancellationData?: Maybe<CancellationDataOutputDto>;
  category: ServiceProviderCategoryEnum;
  clientPricingItemDuplicateId?: Maybe<Scalars['String']>;
  clientProposalId?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  depositStatus?: Maybe<ClientPricingItemDepositStatusEnum>;
  hostModifiedItem?: Maybe<HostModifiedItemOutputDto>;
  isSavedWithVat?: Maybe<Scalars['Boolean']>;
  isSelectedHostOption?: Maybe<Scalars['Boolean']>;
  minUserFeesRate?: Maybe<Scalars['Float']>;
  nabooRating?: Maybe<NabooRatingModel>;
  objectData: ClientPricingItemObjectDataOutputDto;
  option: ClientPricingItemOptionOutputDto;
  planning?: Maybe<Array<ClientPricingItemPlanningOutputDto>>;
  position?: Maybe<Scalars['Int']>;
  priceOption: PriceOptionOutputDto;
  priceUnit?: Maybe<ServiceProvisionUnitEnum>;
  pricesBeforeOwnerUpdatedQuotation?: Maybe<PricesBeforeOwnerUpdatedQuotationOutputDto>;
  season?: Maybe<SeasonEnum>;
  serviceName?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<PriceObjectOutputDto>;
  type: ClientPricingItemTypeEnum;
  unitPrice?: Maybe<PriceObjectOutputDto>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientPricingItemPlanningOutputDto = {
  __typename?: 'ClientPricingItemPlanningOutputDto';
  _id: Scalars['ID'];
  clientPricingItem: ClientPricingItemOutputDto;
  clientPricingItemId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  position: Scalars['Float'];
  quantity: Scalars['Float'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientPricingItemSeasonPricesOutputDto = {
  __typename?: 'ClientPricingItemSeasonPricesOutputDto';
  HIGH?: Maybe<PriceObjectOutputDto>;
  LOW?: Maybe<PriceObjectOutputDto>;
  MEDIUM?: Maybe<PriceObjectOutputDto>;
};

export enum ClientPricingItemTypeEnum {
  AD_HOC = 'AD_HOC',
  CLEANING = 'CLEANING',
  DAY_PACKAGE = 'DAY_PACKAGE',
  EARLY_CHECKIN = 'EARLY_CHECKIN',
  FEES_ADJUSTMENTS = 'FEES_ADJUSTMENTS',
  HALF_DAY_PACKAGE = 'HALF_DAY_PACKAGE',
  HOUSE_PRICE = 'HOUSE_PRICE',
  INDIVIDUAL_BEDROOMS = 'INDIVIDUAL_BEDROOMS',
  LATE_CHECKOUT = 'LATE_CHECKOUT',
  LAUNDRY = 'LAUNDRY',
  RESIDENTIAL_SEMINAR = 'RESIDENTIAL_SEMINAR',
  SERVICE_PROVISION = 'SERVICE_PROVISION',
  SHARED_BEDROOMS = 'SHARED_BEDROOMS',
  TAXES = 'TAXES',
  TOTAL = 'TOTAL'
}

export type ClientPricingMenuItemMultiSeasonPricesOutputDto = {
  __typename?: 'ClientPricingMenuItemMultiSeasonPricesOutputDto';
  HIGH?: Maybe<Array<ClientPricingMenuItemSeasonPriceOutputDto>>;
  LOW?: Maybe<Array<ClientPricingMenuItemSeasonPriceOutputDto>>;
  MEDIUM?: Maybe<Array<ClientPricingMenuItemSeasonPriceOutputDto>>;
};

export type ClientPricingMenuItemSeasonPriceOutputDto = {
  __typename?: 'ClientPricingMenuItemSeasonPriceOutputDto';
  maxAdults?: Maybe<Scalars['Float']>;
  minAdults?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  unit?: Maybe<ServiceProvisionUnitEnum>;
};

export type ClientPricingMenuItemsWithSeasonPricesOutputDto = {
  __typename?: 'ClientPricingMenuItemsWithSeasonPricesOutputDto';
  multiSeasonPrices: ClientPricingMenuItemMultiSeasonPricesOutputDto;
};

export type ClientPricingMenuOutputDto = {
  __typename?: 'ClientPricingMenuOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  nestedItems: Array<NestedItemObjectDataOutputDto>;
  quantity: Scalars['Float'];
  serviceProviderId?: Maybe<Scalars['ID']>;
  type: ClientPricingMenuTypeEnum;
  unit: ServiceProvisionUnitEnum;
  unitMenu: BookingPrice;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ClientPricingMenuTypeEnum {
  ACTIVITY_MENU = 'ACTIVITY_MENU',
  DAY_MENU = 'DAY_MENU',
  EVENING_MENU = 'EVENING_MENU',
  HOUSE_MENU = 'HOUSE_MENU',
  NIGHT_MENU = 'NIGHT_MENU',
  WORKSPACE_MENU = 'WORKSPACE_MENU'
}

export type ClientProposalCancellationDataOutputDto = {
  __typename?: 'ClientProposalCancellationDataOutputDto';
  adminCancelledAt: Scalars['DateTime'];
  feesAdjustment: Scalars['Int'];
  serviceProviderCancellationData: Array<ClientProposalServiceProviderCancellationDataOutputDto>;
};

export type ClientProposalCheckMultiVatRatesValidityInputDto = {
  isSavedWithVat: Scalars['Boolean'];
  quantity: Scalars['Int'];
  totalPrice: Scalars['Int'];
  unitPrice: Scalars['Int'];
  vatRates: Array<Scalars['Int']>;
};

export type ClientProposalCreateQuoteProvisionInputDto = {
  category: ServiceProviderCategoryEnum;
  description: Scalars['String'];
  isDuplicated?: InputMaybe<Scalars['Boolean']>;
  isSavedWithVat: Scalars['Boolean'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  totalPrice?: InputMaybe<Scalars['Int']>;
  unit: ServiceProvisionUnitEnum;
  unitPrice: Scalars['Int'];
  vatRates: Array<Scalars['Int']>;
};

export type ClientProposalDatesInputDto = {
  clientProposalId: Scalars['String'];
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export enum ClientProposalHostFiltersEnum {
  BOOKING_ASKED = 'BOOKING_ASKED',
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  CLOSED = 'CLOSED',
  DECLINED_BY_HOST = 'DECLINED_BY_HOST',
  LOST = 'LOST',
  QUOTE_ASKED = 'QUOTE_ASKED',
  QUOTE_SUBMITTED = 'QUOTE_SUBMITTED'
}

export type ClientProposalInputDto = {
  adults: Scalars['Float'];
  arrivalHour?: InputMaybe<Scalars['String']>;
  clientPricingItems: Array<ClientPricingItemInputDto>;
  clientProposalId: Scalars['String'];
  departureHour?: InputMaybe<Scalars['String']>;
  depositRate?: InputMaybe<Scalars['Float']>;
  endDate: Scalars['DateTime'];
  planning?: InputMaybe<Array<CreatePlanningItemInputDto>>;
  settings?: InputMaybe<ProposalSettingInputDto>;
  startDate: Scalars['DateTime'];
  status?: InputMaybe<ProposalStatusEnum>;
  type: TravelTypeEnum;
};

export enum ClientProposalKindEnum {
  HOUSE = 'HOUSE',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER'
}

export enum ClientProposalNudgeStateEnum {
  OTHER_PROPOSALS = 'OTHER_PROPOSALS',
  SIMULTANEOUS_OFFERS = 'SIMULTANEOUS_OFFERS'
}

export type ClientProposalNudgeStateOutputDto = {
  __typename?: 'ClientProposalNudgeStateOutputDto';
  type: ClientProposalNudgeStateEnum;
  value?: Maybe<Scalars['Int']>;
};

export type ClientProposalOutputDto = {
  __typename?: 'ClientProposalOutputDto';
  _id: Scalars['ID'];
  adjustmentPrices?: Maybe<Array<ClientPricingItemOutputDto>>;
  adminConfirmedPostBalanceAdjustmentsAt?: Maybe<Scalars['DateTime']>;
  adminSkippedBalancePaymentAt?: Maybe<Scalars['DateTime']>;
  adminSkippedDepositPaymentAt?: Maybe<Scalars['DateTime']>;
  adults?: Maybe<Scalars['Int']>;
  advisorConversation: AdvisorConversationOutputDto;
  arrivalHour?: Maybe<Scalars['String']>;
  briefOwner: Scalars['String'];
  cancellationData?: Maybe<ClientProposalCancellationDataOutputDto>;
  carbonFootprint?: Maybe<ClientCarbonFootprintOutputDto>;
  clientFeedbackDate?: Maybe<Scalars['DateTime']>;
  clientPricingItems?: Maybe<Array<ClientPricingItemOutputDto>>;
  clientRequest?: Maybe<ClientRequestOutputDto>;
  clientRequestId: Scalars['String'];
  companyTravelPolicies?: Maybe<CompanyTravelPoliciesOutputDto>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  departureHour?: Maybe<Scalars['String']>;
  deposit?: Maybe<ClientRequestPaymentOutputDto>;
  depositRate?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['DateTime']>;
  gbvGap?: Maybe<ComputedPrice>;
  hidePrices?: Maybe<Scalars['Boolean']>;
  house?: Maybe<HouseContext>;
  houseBookingType?: Maybe<HouseBookingTypeEnum>;
  houseId?: Maybe<Scalars['String']>;
  isAutonomous: Scalars['Boolean'];
  isClientProposalCancelled: Scalars['Boolean'];
  isDeclinedByOwner?: Maybe<Scalars['Boolean']>;
  isLocked: Scalars['Boolean'];
  isNonCompliantBudget?: Maybe<Scalars['Boolean']>;
  isNonCompliantHouse?: Maybe<Scalars['Boolean']>;
  marginGap?: Maybe<ComputedPrice>;
  messageId?: Maybe<Scalars['String']>;
  negativeVoteCount: Scalars['Int'];
  nudgeState?: Maybe<ClientProposalNudgeStateOutputDto>;
  ownerAskedAdjustmentsModificationAt?: Maybe<Scalars['DateTime']>;
  ownerConfirmedAdjustmentsAt?: Maybe<Scalars['DateTime']>;
  ownerConfirmedBookingAt?: Maybe<Scalars['DateTime']>;
  ownerCurrentAction?: Maybe<ClientProposalOwnerActionEnum>;
  ownerDeclinedBookingAt?: Maybe<Scalars['DateTime']>;
  ownerUploadedQuotation?: Maybe<ClientProposalOwnerUploadedQuotationOutputDto>;
  ownerWatchedProposalAt?: Maybe<Scalars['DateTime']>;
  permissions: ClientProposalPermissionsOutputDto;
  planning?: Maybe<Array<PlanningItemsByDate>>;
  position: Scalars['Int'];
  positiveVoteCount: Scalars['Int'];
  price?: Maybe<BookingPrice>;
  privatizationStatus?: Maybe<PrivatizationStatusEnum>;
  privatizationStatusOverride?: Maybe<PrivatizationStatusEnum>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedDate?: Maybe<Scalars['DateTime']>;
  quotationConfirmedAt?: Maybe<Scalars['DateTime']>;
  readByOwner: Scalars['Boolean'];
  readByUserAt?: Maybe<Scalars['DateTime']>;
  selectedServiceProviders?: Maybe<Array<ServiceProviderOutputDto>>;
  selectedServiceProvidersCount?: Maybe<Scalars['Float']>;
  serviceProvider?: Maybe<ServiceProviderOutputDto>;
  serviceProviderId?: Maybe<Scalars['String']>;
  serviceProviders?: Maybe<Array<ServiceProviderOutputDto>>;
  serviceProvidersCounts?: Maybe<ServiceProviderCountsOutputDto>;
  specialConditions: ClientProposalUploadFileDataOutputDto;
  startDate?: Maybe<Scalars['DateTime']>;
  state?: Maybe<ClientProposalStateOutputDto>;
  status: ProposalStatusEnum;
  type: TravelTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAdminDeclinedBooking?: Maybe<ClientProposalUserAdminDeclinedBookingOutputDto>;
  userAskedQuotationAt?: Maybe<Scalars['DateTime']>;
  userConfirmedAdjustmentsAt?: Maybe<Scalars['DateTime']>;
  userConfirmedBookingAt?: Maybe<Scalars['DateTime']>;
  userCurrentAction?: Maybe<ClientProposalUserActionEnum>;
  userFeesVatRateOverride?: Maybe<Scalars['Int']>;
  userPaidBalanceAt?: Maybe<Scalars['DateTime']>;
  userPaidDepositAt?: Maybe<Scalars['DateTime']>;
  userPaidPostBalanceAt?: Maybe<Scalars['DateTime']>;
  userRequestedUserAdminApproval?: Maybe<ClientProposalUserRequestedUserAdminApprovalOutputDto>;
  userVote?: Maybe<ClientProposalVoteEnum>;
  userWatchedProposalAt?: Maybe<Scalars['DateTime']>;
  voteForEmail?: Maybe<ClientProposalVoteEnum>;
};


export type ClientProposalOutputDtoAdjustmentPricesArgs = {
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientProposalOutputDtoClientPricingItemsArgs = {
  depositStatus?: InputMaybe<ClientPricingItemDepositStatusEnum>;
  isClient?: InputMaybe<Scalars['Boolean']>;
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientProposalOutputDtoDepositArgs = {
  isClient?: InputMaybe<Scalars['Boolean']>;
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientProposalOutputDtoGbvGapArgs = {
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientProposalOutputDtoMarginGapArgs = {
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientProposalOutputDtoPlanningArgs = {
  isClient?: InputMaybe<Scalars['Boolean']>;
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientProposalOutputDtoPriceArgs = {
  adults?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<ServiceProviderCategoryEnum>;
  depositStatus?: InputMaybe<ClientPricingItemDepositStatusEnum>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  includeDefaultClientPricingItems?: InputMaybe<Scalars['Boolean']>;
  isClient?: InputMaybe<Scalars['Boolean']>;
  onlyClientPricingItemsWithQuantity?: InputMaybe<Scalars['Boolean']>;
  serviceOwnerId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type ClientProposalOutputDtoServiceProvidersArgs = {
  category?: InputMaybe<ServiceProviderCategoryEnum>;
  onlyClientPricingItemsWithQuantity?: InputMaybe<Scalars['Boolean']>;
};


export type ClientProposalOutputDtoVoteForEmailArgs = {
  email: Scalars['String'];
};

export enum ClientProposalOwnerActionEnum {
  ADJUSTMENTS_CONFIRMED = 'ADJUSTMENTS_CONFIRMED',
  BOOKING_DECLINED_BY_HOST = 'BOOKING_DECLINED_BY_HOST',
  BOOKING_DECLINED_BY_USER_ADMIN = 'BOOKING_DECLINED_BY_USER_ADMIN',
  CAN_CONFIRM_ADJUSTMENTS = 'CAN_CONFIRM_ADJUSTMENTS',
  CAN_CONFIRM_BOOKING = 'CAN_CONFIRM_BOOKING',
  CAN_CONFIRM_QUOTATION = 'CAN_CONFIRM_QUOTATION',
  CAN_CONTACT_ADMIN = 'CAN_CONTACT_ADMIN',
  CAN_RE_UPLOAD_QUOTATION = 'CAN_RE_UPLOAD_QUOTATION',
  CAN_SEND_FEEDBACK = 'CAN_SEND_FEEDBACK',
  CAN_UPLOAD_QUOTATION = 'CAN_UPLOAD_QUOTATION',
  CLIENT_REQUEST_CANCELLED = 'CLIENT_REQUEST_CANCELLED',
  DEPOSIT_PAID = 'DEPOSIT_PAID',
  LOST = 'LOST',
  WAITING_USER_BOOKING_CONFIRMATION = 'WAITING_USER_BOOKING_CONFIRMATION',
  WAITING_USER_PAY_DEPOSIT = 'WAITING_USER_PAY_DEPOSIT'
}

export type ClientProposalOwnerConfirmedQuotationInputDto = {
  depositRate: Scalars['Float'];
  specialConditions: ClientProposalUploadFileInputDto;
};

export type ClientProposalOwnerListInputDto = {
  ownerStatus?: InputMaybe<ClientProposalStateOwnerStatusEnum>;
  q?: InputMaybe<Scalars['String']>;
};

export type ClientProposalOwnerUploadedQuotationInputDto = {
  depositRate: Scalars['Float'];
  quotationFile: ClientProposalUploadFileInputDto;
  specialConditionsFile: ClientProposalUploadFileInputDto;
  totalAmountHT: Scalars['Int'];
  totalAmountTTC: Scalars['Int'];
};

export type ClientProposalOwnerUploadedQuotationOutputDto = {
  __typename?: 'ClientProposalOwnerUploadedQuotationOutputDto';
  at: Scalars['DateTime'];
  quotationFileHistory: Array<ClientProposalQuotationFileOutputDto>;
  specialConditionsFileHistory: Array<ClientProposalQuotationFileOutputDto>;
  totalAmountHT: Scalars['Float'];
  totalAmountTTC: Scalars['Float'];
};

export type ClientProposalPermissionsOutputDto = {
  __typename?: 'ClientProposalPermissionsOutputDto';
  canCancelStepSeven: Scalars['Boolean'];
  canCancelUserConfirmedBooking: Scalars['Boolean'];
  canEditPricingItems: Scalars['Boolean'];
  canOverrideUserFeesVatRate: Scalars['Boolean'];
  canReadBriefOwner: Scalars['Boolean'];
  canUpdateProposal: Scalars['Boolean'];
  canValidateStepFiveWithoutBalancePayment: Scalars['Boolean'];
  canValidateStepThreeWithoutDepositPayment: Scalars['Boolean'];
};

export type ClientProposalProvisionOutputDto = {
  __typename?: 'ClientProposalProvisionOutputDto';
  _id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price: ClientProposalProvisionPriceOutputDto;
  userFees: Scalars['Int'];
};

export type ClientProposalProvisionPriceOutputDto = {
  __typename?: 'ClientProposalProvisionPriceOutputDto';
  price: ClientPricingItemOutputDto;
  unit: ServiceProvisionUnitEnum;
};

export type ClientProposalQuotationFileOutputDto = {
  __typename?: 'ClientProposalQuotationFileOutputDto';
  uploadedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type ClientProposalServiceOwnerOutputDto = {
  __typename?: 'ClientProposalServiceOwnerOutputDto';
  balance?: Maybe<ClientRequestPaymentOutputDto>;
  balancePostFinal?: Maybe<ClientRequestPaymentOutputDto>;
  bookingPrice?: Maybe<BookingPrice>;
  deposit?: Maybe<ClientRequestPaymentOutputDto>;
  serviceOwnerId?: Maybe<Scalars['String']>;
  serviceOwnerName?: Maybe<Scalars['String']>;
};

export type ClientProposalServiceProviderCancellationDataOutputDto = {
  __typename?: 'ClientProposalServiceProviderCancellationDataOutputDto';
  cancellationData: CancellationDataOutputDto;
  serviceProviderId: Scalars['String'];
};

export type ClientProposalStateOutputDto = {
  __typename?: 'ClientProposalStateOutputDto';
  isVisibleByOwner?: Maybe<Scalars['DateTime']>;
  ownerAction?: Maybe<ClientProposalStateOwnerActionEnum>;
  ownerStatus?: Maybe<ClientProposalStateOwnerStatusEnum>;
};

export enum ClientProposalStateOwnerActionEnum {
  CAN_CONFIRM_ADJUSTMENTS = 'CAN_CONFIRM_ADJUSTMENTS',
  CAN_CONFIRM_BOOKING = 'CAN_CONFIRM_BOOKING',
  CAN_CONFIRM_QUOTATION = 'CAN_CONFIRM_QUOTATION',
  CAN_UPLOAD_QUOTATION = 'CAN_UPLOAD_QUOTATION',
  NONE = 'NONE',
  WAIT_CLIENT_ACTION = 'WAIT_CLIENT_ACTION',
  WAIT_CLIENT_BALANCE = 'WAIT_CLIENT_BALANCE',
  WAIT_CLIENT_BALANCE_POST_FINAL = 'WAIT_CLIENT_BALANCE_POST_FINAL',
  WAIT_CLIENT_DEPOSIT = 'WAIT_CLIENT_DEPOSIT'
}

export enum ClientProposalStateOwnerStatusEnum {
  CONFIRMED = 'CONFIRMED',
  FINISHED = 'FINISHED',
  REFUSED = 'REFUSED',
  UNREAD = 'UNREAD',
  WAITING = 'WAITING'
}

export type ClientProposalUpdateQuoteProvisionInputDto = {
  _id: Scalars['String'];
  category: ServiceProviderCategoryEnum;
  description: Scalars['String'];
  isDuplicated?: InputMaybe<Scalars['Boolean']>;
  isSavedWithVat: Scalars['Boolean'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  totalPrice?: InputMaybe<Scalars['Int']>;
  unit: ServiceProvisionUnitEnum;
  unitPrice: Scalars['Int'];
  vatRates: Array<Scalars['Int']>;
};

export type ClientProposalUploadFileDataOutputDto = {
  __typename?: 'ClientProposalUploadFileDataOutputDto';
  fileName: Scalars['String'];
  uploadedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type ClientProposalUploadFileInputDto = {
  fileName: Scalars['String'];
  url: Scalars['String'];
};

export enum ClientProposalUserActionEnum {
  BALANCE_PAID = 'BALANCE_PAID',
  BOOKING_DECLINED_BY_HOST = 'BOOKING_DECLINED_BY_HOST',
  BOOKING_DECLINED_BY_USER_ADMIN = 'BOOKING_DECLINED_BY_USER_ADMIN',
  CAN_ASK_QUOTATION = 'CAN_ASK_QUOTATION',
  CAN_ASK_USER_ADMIN_APPROVAL = 'CAN_ASK_USER_ADMIN_APPROVAL',
  CAN_CONFIRM_ADJUSTMENTS = 'CAN_CONFIRM_ADJUSTMENTS',
  CAN_CONFIRM_BOOKING = 'CAN_CONFIRM_BOOKING',
  CAN_PAY_BALANCE = 'CAN_PAY_BALANCE',
  CAN_PAY_DEPOSIT = 'CAN_PAY_DEPOSIT',
  CAN_PAY_POST_BALANCE = 'CAN_PAY_POST_BALANCE',
  CLIENT_REQUEST_CANCELLED = 'CLIENT_REQUEST_CANCELLED',
  DEPOSIT_PAID = 'DEPOSIT_PAID',
  POST_BALANCE_PAID = 'POST_BALANCE_PAID',
  WAITING_HOST_ADJUSTMENTS_CONFIRMATION = 'WAITING_HOST_ADJUSTMENTS_CONFIRMATION',
  WAITING_HOST_BOOKING_CONFIRMATION = 'WAITING_HOST_BOOKING_CONFIRMATION',
  WAITING_HOST_QUOTATION = 'WAITING_HOST_QUOTATION',
  WAITING_USER_ADMIN_CONFIRMATION = 'WAITING_USER_ADMIN_CONFIRMATION'
}

export type ClientProposalUserAdminDeclinedBookingOutputDto = {
  __typename?: 'ClientProposalUserAdminDeclinedBookingOutputDto';
  at: Scalars['DateTime'];
  comment?: Maybe<Scalars['String']>;
};

export enum ClientProposalUserDecliningReasonEnum {
  AVAILABILITY_DATES_NOT_MATCHING = 'AVAILABILITY_DATES_NOT_MATCHING',
  EQUIPEMENTS_OR_SERVICE_AVAILABLE_TOO_LOW = 'EQUIPEMENTS_OR_SERVICE_AVAILABLE_TOO_LOW',
  GRADES_OR_REPUTATION_TOO_LOW = 'GRADES_OR_REPUTATION_TOO_LOW',
  LOCALISATION_NOT_MATCHING = 'LOCALISATION_NOT_MATCHING',
  OTHERS = 'OTHERS',
  PRICE_TOO_HIGH = 'PRICE_TOO_HIGH'
}

export type ClientProposalUserRequestedUserAdminApprovalOutputDto = {
  __typename?: 'ClientProposalUserRequestedUserAdminApprovalOutputDto';
  at: Scalars['DateTime'];
  comment?: Maybe<Scalars['String']>;
};

export enum ClientProposalVoteEnum {
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE'
}

export type ClientRequestAnonymousVisitedLogDto = {
  clientRequestId: Scalars['String'];
  type: LogTypeEnum;
  visitorEmail: Scalars['String'];
};

export type ClientRequestBriefContactInputDto = {
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  mail?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export enum ClientRequestClientStatusEnum {
  ACTIVE = 'ACTIVE',
  APPROVAL = 'APPROVAL',
  CANCELED = 'CANCELED',
  CLOSED = 'CLOSED',
  CONFIRMED = 'CONFIRMED'
}

export type ClientRequestConfirmationDataOutputDto = {
  __typename?: 'ClientRequestConfirmationDataOutputDto';
  cancelationClientProposalId?: Maybe<Scalars['String']>;
  cancelationDate?: Maybe<Scalars['DateTime']>;
  confirmationDate?: Maybe<Scalars['DateTime']>;
  confirmedByOwner?: Maybe<Scalars['DateTime']>;
  confirmedByUser?: Maybe<Scalars['DateTime']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
};

export type ClientRequestContactOutputDto = {
  __typename?: 'ClientRequestContactOutputDto';
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  mail?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  user?: Maybe<UserOutputDto>;
  userId?: Maybe<Scalars['String']>;
};

export type ClientRequestFinanceDocumentOutputDto = {
  __typename?: 'ClientRequestFinanceDocumentOutputDto';
  createdAt: Scalars['DateTime'];
  pdfType: PdfTypeEnum;
  url: Scalars['String'];
};

export type ClientRequestMailParamsInputDto = {
  disableOwnerEmails: Scalars['Boolean'];
  disableUserEmails: Scalars['Boolean'];
  shouldSendPaymentReminder: Scalars['Boolean'];
};

export type ClientRequestMailParamsOutputDto = {
  __typename?: 'ClientRequestMailParamsOutputDto';
  disableOwnerEmails?: Maybe<Scalars['Boolean']>;
  disableUserEmails?: Maybe<Scalars['Boolean']>;
  shouldSendPaymentReminder?: Maybe<Scalars['Boolean']>;
};

export type ClientRequestMiceFilterInputDto = {
  companiesId?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  q?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ClientRequestMiceReservationInputDto = {
  filters?: InputMaybe<ClientRequestMiceFilterInputDto>;
  paginationArgsBackward?: InputMaybe<BackwardPaginationInputDto>;
  paginationArgsForward?: InputMaybe<ForwardPaginationInputDto>;
};

export type ClientRequestOutputDto = {
  __typename?: 'ClientRequestOutputDto';
  _id: Scalars['ID'];
  adminCsm?: Maybe<AdminOutputDto>;
  adminCsmId?: Maybe<Scalars['String']>;
  adminFinance?: Maybe<AdminOutputDto>;
  adminFinanceId?: Maybe<Scalars['String']>;
  adminSales?: Maybe<AdminOutputDto>;
  adminSalesId?: Maybe<Scalars['String']>;
  balance?: Maybe<ClientRequestPaymentOutputDto>;
  balancePostFinal?: Maybe<ClientRequestPaymentOutputDto>;
  balancePostFinalStatus?: Maybe<ClientRequestPaymentStatusEnum>;
  balanceStatus?: Maybe<ClientRequestPaymentStatusEnum>;
  billingEntity: BillingEntityEnum;
  briefDescription?: Maybe<Scalars['String']>;
  briefOwner?: Maybe<Scalars['String']>;
  briefTitle?: Maybe<Scalars['String']>;
  cashed?: Maybe<Scalars['Float']>;
  clientProposal?: Maybe<ClientProposalOutputDto>;
  clientProposals?: Maybe<Array<ClientProposalOutputDto>>;
  clientProposalsCount?: Maybe<Scalars['Int']>;
  clientStatus: ClientRequestClientStatusEnum;
  company?: Maybe<CompanyOutputDto>;
  companyId?: Maybe<Scalars['String']>;
  confirmationData?: Maybe<ClientRequestConfirmationDataOutputDto>;
  contact?: Maybe<ClientRequestContactOutputDto>;
  contactLastConnect?: Maybe<Scalars['DateTime']>;
  countUnreadClientProposals?: Maybe<Scalars['Int']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  currentUserIsContact: Scalars['Boolean'];
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  deposit?: Maybe<ClientRequestPaymentOutputDto>;
  depositStatus?: Maybe<ClientRequestPaymentStatusEnum>;
  freeFieldPdf?: Maybe<Scalars['String']>;
  gbv?: Maybe<Scalars['Float']>;
  glideLink?: Maybe<Scalars['String']>;
  hubspotNumber?: Maybe<Scalars['String']>;
  isCompanyHidden?: Maybe<Scalars['Boolean']>;
  mailParams?: Maybe<ClientRequestMailParamsOutputDto>;
  mainPictures?: Maybe<Array<HousePictureContext>>;
  memo?: Maybe<Scalars['String']>;
  pdfOwnerDocumentType?: Maybe<Array<PdfTypeEnum>>;
  pdfUserDocumentType?: Maybe<Array<PdfTypeEnum>>;
  permissions: ClientRequestPermissionsOutputDto;
  proposalsSortedManually?: Maybe<Scalars['Boolean']>;
  purchaseOrder?: Maybe<Scalars['String']>;
  purchasedOrderUrl?: Maybe<Scalars['String']>;
  readableId: Scalars['String'];
  review?: Maybe<ClientRequestReviewDto>;
  selectedProposal?: Maybe<ClientProposalOutputDto>;
  selectedProposalId?: Maybe<Scalars['String']>;
  shouldGenerateDocuments?: Maybe<Array<PdfTypeEnum>>;
  status?: Maybe<ClientRequestStatusEnum>;
  stepOwner?: Maybe<ClientRequestStepOutputDto>;
  stepUser?: Maybe<ClientRequestStepOutputDto>;
  threadId?: Maybe<Scalars['String']>;
  totalPriceByServiceOwners?: Maybe<Array<ClientProposalServiceOwnerOutputDto>>;
  totalSavedWithFeesReductionAndDiscounts: Scalars['Float'];
  type: TravelTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ClientRequestOutputDtoBalanceArgs = {
  isClient?: InputMaybe<Scalars['Boolean']>;
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientRequestOutputDtoBalancePostFinalArgs = {
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientRequestOutputDtoClientProposalArgs = {
  clientProposalId?: InputMaybe<Scalars['String']>;
};


export type ClientRequestOutputDtoClientProposalsArgs = {
  sortedForSuggestions?: InputMaybe<Scalars['Boolean']>;
};


export type ClientRequestOutputDtoCompanyArgs = {
  clientProposalId?: InputMaybe<Scalars['String']>;
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientRequestOutputDtoContactArgs = {
  clientProposalId?: InputMaybe<Scalars['String']>;
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientRequestOutputDtoDepositArgs = {
  isClient?: InputMaybe<Scalars['Boolean']>;
  serviceOwnerId?: InputMaybe<Scalars['String']>;
};


export type ClientRequestOutputDtoPdfOwnerDocumentTypeArgs = {
  clientProposalId?: InputMaybe<Scalars['String']>;
};

export type ClientRequestOutputDtoEdge = {
  __typename?: 'ClientRequestOutputDtoEdge';
  cursor: Scalars['String'];
  node: ClientRequestOutputDto;
};

export type ClientRequestOutputDtoPageInfo = {
  __typename?: 'ClientRequestOutputDtoPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ClientRequestPaymentOutputDto = {
  __typename?: 'ClientRequestPaymentOutputDto';
  date?: Maybe<Scalars['DateTime']>;
  depositRate?: Maybe<Scalars['Int']>;
  price?: Maybe<BookingPrice>;
  status?: Maybe<ClientRequestPaymentStatusEnum>;
};

export enum ClientRequestPaymentStatusEnum {
  DONE = 'DONE',
  PENDING = 'PENDING',
  TO_DO = 'TO_DO'
}

export type ClientRequestPermissionsOutputDto = {
  __typename?: 'ClientRequestPermissionsOutputDto';
  canDelete: Scalars['Boolean'];
  canEdit: Scalars['Boolean'];
  canSeeGlideLink?: Maybe<Scalars['Boolean']>;
  canVote: Scalars['Boolean'];
};

export type ClientRequestReviewDto = {
  __typename?: 'ClientRequestReviewDto';
  comment?: Maybe<Scalars['String']>;
  feedbacks?: Maybe<Array<FeedbackOutputDto>>;
  globalNote?: Maybe<Scalars['Float']>;
  nabooRecommandation?: Maybe<Scalars['Float']>;
  nabooRecommandationComment?: Maybe<Scalars['String']>;
  nextSeminarEstimation?: Maybe<Array<NextSeminarEstimationEnum>>;
};

export type ClientRequestReviewInputDto = {
  comment?: InputMaybe<Scalars['String']>;
  feedbacks?: InputMaybe<Array<FeedbackInputDto>>;
  globalNote?: InputMaybe<Scalars['Float']>;
  nabooRecommandation?: InputMaybe<Scalars['Float']>;
  nabooRecommandationComment?: InputMaybe<Scalars['String']>;
  nextSeminarEstimation?: InputMaybe<Array<NextSeminarEstimationEnum>>;
};

export enum ClientRequestStatusEnum {
  ACCEPTED = 'ACCEPTED',
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  PROSPECTION = 'PROSPECTION',
  REFUSED = 'REFUSED'
}

export type ClientRequestStepOutputDto = {
  __typename?: 'ClientRequestStepOutputDto';
  stepNumber: Scalars['Int'];
  stepState?: Maybe<ClientRequestStepStateEnum>;
  stepsUpdatedAt?: Maybe<Array<StepUpdatedAtOutputDto>>;
};

export enum ClientRequestStepStateEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type ClientRequestsByAdminInputDto = {
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
};

export type ClientRequestsReviewOutputDto = {
  __typename?: 'ClientRequestsReviewOutputDto';
  clientRequestId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  houseId?: Maybe<Scalars['String']>;
  logoURL?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['Float']>;
  readableId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
};

export type CompanyBillingTransferInputDto = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  fees?: InputMaybe<Scalars['Int']>;
};

export type CompanyBillingTransferOutputDto = {
  __typename?: 'CompanyBillingTransferOutputDto';
  enabledAt?: Maybe<Scalars['DateTime']>;
  fees?: Maybe<Scalars['Int']>;
};

export type CompanyClientRequestsInputDto = {
  datesBooking?: InputMaybe<FilterDatesDto>;
  datesClientRequest?: InputMaybe<FilterDatesDto>;
  filterPastFuture?: FilterPastFutureEnum;
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
};

export type CompanyContractInputDto = {
  documents?: InputMaybe<Array<Scalars['String']>>;
  serviceFeesMilestones?: InputMaybe<Array<ServiceFeesMilestonesInputDto>>;
};

export type CompanyContractOutputDto = {
  __typename?: 'CompanyContractOutputDto';
  documents?: Maybe<Array<Scalars['String']>>;
  serviceFeesMilestones?: Maybe<Array<ServiceFeesMilestonesOutputDto>>;
  totalPaidByCompanyAndChildren?: Maybe<Scalars['Float']>;
};

export type CompanyListDto = {
  filters?: InputMaybe<CompanySearchFilters>;
  pagination?: InputMaybe<PaginationDto>;
};

export type CompanyOutputDto = {
  __typename?: 'CompanyOutputDto';
  _id: Scalars['ID'];
  accountingAddress?: Maybe<Scalars['String']>;
  address?: Maybe<AddressContext>;
  admin?: Maybe<AdminOutputDto>;
  adminLinkedId?: Maybe<Scalars['String']>;
  billingTransfer?: Maybe<CompanyBillingTransferOutputDto>;
  blacklistedInLanding?: Maybe<Scalars['Boolean']>;
  contactFirstname?: Maybe<Scalars['String']>;
  contactLastname?: Maybe<Scalars['String']>;
  contract?: Maybe<CompanyContractOutputDto>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  extension: Scalars['String'];
  lastConnect?: Maybe<Scalars['DateTime']>;
  logoURL: Scalars['String'];
  name: Scalars['String'];
  numberOfChildrenCompanies: Scalars['Float'];
  numberOfEmployees: Scalars['Float'];
  numberOfEmployeesWithSubsidiaryCompanies: Scalars['Float'];
  parentCompanyId?: Maybe<Scalars['String']>;
  siret?: Maybe<Scalars['String']>;
  subsidiaryCompanies: Array<CompanyOutputDto>;
  totalPaidByCompanyAndChildren: Array<TotalByCurrencyOutputDto>;
  travelPolicies?: Maybe<CompanyTravelPoliciesOutputDto>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export enum CompanyRoleEnum {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export type CompanySearchFilters = {
  billingTransfer?: InputMaybe<CompanyBillingTransferInputDto>;
  q?: InputMaybe<Scalars['String']>;
};

export type CompanyTravelPoliciesOutputDto = {
  __typename?: 'CompanyTravelPoliciesOutputDto';
  authorizedHouseTypes: Array<HouseTypeEnum>;
  budget: BudgetByTravelTypeOutputDto;
};

export type ComputedPrice = {
  __typename?: 'ComputedPrice';
  priceWithVat: Scalars['Float'];
  priceWithoutVat: Scalars['Float'];
  vat: Scalars['Float'];
  vatRate?: Maybe<Scalars['Int']>;
};

export type ComputedPriceDto = {
  priceWithVat?: InputMaybe<Scalars['Float']>;
  priceWithoutVat?: InputMaybe<Scalars['Float']>;
  vat?: InputMaybe<Scalars['Float']>;
  vatRate?: InputMaybe<Scalars['Int']>;
};

export type ConsumableTokenOutputDto = {
  __typename?: 'ConsumableTokenOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  token: Scalars['String'];
  type: ConsumableTokenTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export enum ConsumableTokenTypeEnum {
  ADMIN_FORGOT = 'ADMIN_FORGOT',
  CLIENT_PROPOSAL_DISPONIBILITY_AVAILABLE = 'CLIENT_PROPOSAL_DISPONIBILITY_AVAILABLE',
  CLIENT_PROPOSAL_DISPONIBILITY_NOT_AVAILABLE = 'CLIENT_PROPOSAL_DISPONIBILITY_NOT_AVAILABLE',
  DIGITS_VERIFICATION_CODE = 'DIGITS_VERIFICATION_CODE',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  OWNER_ACCESS_APP = 'OWNER_ACCESS_APP',
  OWNER_AUTHENTICATION = 'OWNER_AUTHENTICATION',
  OWNER_FORGOT = 'OWNER_FORGOT',
  OWNER_INVITATION = 'OWNER_INVITATION'
}

export type CreateAdminInputDto = {
  billingEntity: BillingEntityEnum;
  email: Scalars['String'];
  firstname: Scalars['String'];
  hubspotInternal?: InputMaybe<Scalars['String']>;
  hubspotMeetingUrl?: InputMaybe<Scalars['String']>;
  lastname: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  profilePicture: Scalars['String'];
  roleId?: InputMaybe<Scalars['String']>;
  slackUserId?: InputMaybe<Scalars['String']>;
  teamsMeetingUrl?: InputMaybe<Scalars['String']>;
};

export type CreateArticleInputDto = {
  position?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CreateAutonomousClientProposalInputDto = {
  adults: Scalars['Float'];
  arrival?: InputMaybe<ArrivalEnum>;
  briefTitle?: InputMaybe<Scalars['String']>;
  clientRequestId?: InputMaybe<Scalars['String']>;
  dates: StartEndDates;
  departure?: InputMaybe<DepartureEnum>;
  fromMap?: InputMaybe<Scalars['Boolean']>;
  hours?: InputMaybe<ArrivalDepartureHours>;
  houseId: Scalars['String'];
  indexInResults?: InputMaybe<Scalars['Float']>;
  individualBedroomAdults?: InputMaybe<Scalars['Float']>;
  isAutonomousBookingAvailable: Scalars['Boolean'];
  restauration?: InputMaybe<Scalars['Boolean']>;
  resultScores?: InputMaybe<ResultScoreSearchSessionInputDto>;
  searchId?: InputMaybe<Scalars['String']>;
  selectedClientPricingItemsMenu: Array<ClientPricingItemFromMenuInputDto>;
  sessionId?: InputMaybe<Scalars['String']>;
  sharedBedroomAdults?: InputMaybe<Scalars['Float']>;
  threadId?: InputMaybe<Scalars['String']>;
  travelType: TravelTypeEnum;
};

export type CreateBillingTransferAdminInputDto = {
  clientDocuments: Array<DocumentInputDto>;
  companyId: Scalars['String'];
  userId: Scalars['String'];
};

export type CreateBillingTransferAppInputDto = {
  clientDocuments: Array<DocumentInputDto>;
};

export type CreateBillingTransferPaymentInputDto = {
  date: Scalars['DateTime'];
  effectivePayment: Scalars['Float'];
};

export type CreateBlacklistedEmailInputDto = {
  domain: Scalars['String'];
};

export type CreateClientProposalAndUpdateClientPricingItemsInputDto = {
  adults?: InputMaybe<Scalars['Float']>;
  clientRequestId: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  houseId: Scalars['String'];
  messageId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  type: TravelTypeEnum;
};

export type CreateClientRequestInputDto = {
  adminSalesId: Scalars['String'];
  briefTitle: Scalars['String'];
  companyId: Scalars['String'];
  hubspotNumber?: InputMaybe<Scalars['String']>;
  type: TravelTypeEnum;
  userId: Scalars['String'];
};

export type CreateClientRequestPurchaseOrderUrlInputDto = {
  clientProposalId: Scalars['String'];
  clientRequestId: Scalars['String'];
  fileName: Scalars['String'];
  purchasedOrderUrl: Scalars['String'];
};

export type CreateCompanyAdminInputDto = {
  accountingAddress?: InputMaybe<Scalars['String']>;
  billingTransfer?: InputMaybe<CompanyBillingTransferInputDto>;
  contactFirstname?: InputMaybe<Scalars['String']>;
  contactLastname?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<CompanyContractInputDto>;
  extension: Scalars['String'];
  logoURL: Scalars['String'];
  name: Scalars['String'];
  placeId: Scalars['String'];
  siret?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type CreateCustomHouseFaqInputDto = {
  answer?: InputMaybe<Scalars['String']>;
  isVisible: Scalars['Boolean'];
  position: Scalars['Float'];
  question: Scalars['String'];
};

export type CreateDefaultHouseFaqInputDto = {
  answer?: InputMaybe<Scalars['String']>;
  isVisible: Scalars['Boolean'];
  position: Scalars['Float'];
  questionType: QuestionTypeEnum;
};

export type CreateEquipmentInputDto = {
  category: EquipmentCategoryEnum;
  filters: Array<FiltersEnum>;
  icon: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  labelIntl: IntlInputDto;
  position: Scalars['Float'];
};

export type CreateHouseAdminDto = {
  houseType: HouseTypeEnum;
  hubspot?: InputMaybe<Scalars['String']>;
  placeId: Scalars['String'];
  priceType: HousePriceTypeEnum;
  title: Scalars['String'];
};

export type CreateHouseEquipmentInputDto = {
  equipmentId: Scalars['String'];
};

export type CreateHouseOwnerDuplicateOutputDto = {
  __typename?: 'CreateHouseOwnerDuplicateOutputDto';
  duplicate: Scalars['String'];
};

export type CreateHouseOwnerOutputDto = CreateHouseOwnerDuplicateOutputDto | HouseOwnerOutputDto;

export type CreateLogResponse = {
  __typename?: 'CreateLogResponse';
  error?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateNetworkAdminDto = {
  houseId: Scalars['String'];
  operator?: InputMaybe<OperatorEnum>;
  speed: Scalars['Int'];
  type: NetworkTypeEnum;
  wifiType?: InputMaybe<WifiTypeEnum>;
};

export type CreateOrUpdatePaymentInputDto = {
  _id?: InputMaybe<Scalars['String']>;
  date: Scalars['DateTime'];
  effectivePayment: Scalars['Float'];
  type: Payment_Type;
};

export type CreateOwnerAdminInputDto = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  hubspot?: InputMaybe<Scalars['String']>;
  lastname: Scalars['String'];
  phone: Scalars['String'];
  placeId: Scalars['String'];
  siret?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type CreatePlanningItemInputDto = {
  clientPricingItemId: Scalars['ID'];
  date: Scalars['DateTime'];
  position: Scalars['Int'];
  quantity: Scalars['Float'];
};

export type CreateProposalInputDto = {
  adults?: InputMaybe<Scalars['Float']>;
  arrivalHour?: InputMaybe<Scalars['String']>;
  clientRequestId: Scalars['String'];
  departureHour?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  houseId?: InputMaybe<Scalars['String']>;
  messageId?: InputMaybe<Scalars['String']>;
  serviceProviderId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type CreateServiceOwnerInputDto = {
  companyName: Scalars['String'];
  hubspot: Scalars['String'];
  placeId: Scalars['String'];
};

export type CreateServiceProviderAdminInputDto = {
  category: ServiceProviderCategoryEnum;
  hubspot: Scalars['String'];
  placeId: Scalars['String'];
  status?: InputMaybe<ServiceProviderStatusEnum>;
  title: Scalars['String'];
};

export type CreateServiceProviderPictureInputDto = {
  uri: Scalars['String'];
};

export type CreateTagInputDto = {
  category: TagCategoryEnum;
  filters: Array<FiltersEnum>;
  icon: Scalars['String'];
  labelIntl: IntlInputDto;
  position: Scalars['Float'];
};

export type CreateUserAdminInputDto = {
  _id: Scalars['String'];
  companyId: Scalars['String'];
  email: Scalars['String'];
  firstname: Scalars['String'];
  isManager: Scalars['Boolean'];
  lastname: Scalars['String'];
  password: Scalars['String'];
  profilePicture: Scalars['String'];
};

export type CurrencyAreaInputDto = {
  currency: CurrencyEnum;
  vatRates: Array<Scalars['Int']>;
};

export type CurrencyAreaOutputDto = {
  __typename?: 'CurrencyAreaOutputDto';
  currency: CurrencyEnum;
  feesVatRate?: Maybe<Scalars['Int']>;
  multiVatRates?: Maybe<Array<Array<Scalars['Int']>>>;
  vatRates: Array<Scalars['Int']>;
};

export enum CurrencyEnum {
  CHF = 'CHF',
  CZK = 'CZK',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  NOK = 'NOK',
  PLN = 'PLN',
  SEK = 'SEK'
}

export type DataRunningInfoInputDto = {
  nbResults?: InputMaybe<Scalars['Int']>;
  runningTimeMs?: InputMaybe<Scalars['Float']>;
};

export enum DataSortEnum {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  PERTINENT = 'PERTINENT'
}

export type DeleteAdvisorConversationMessageInputDto = {
  messageId: Scalars['String'];
  proposalId: Scalars['String'];
};

export type DeleteBlacklistedEmailInputDto = {
  _id: Scalars['String'];
};

export enum DepartureEnum {
  AFTER_LUNCH = 'AFTER_LUNCH',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}

export type DeployCustomDomainInputDto = {
  domain: Scalars['String'];
  name: Scalars['String'];
};

export type DeployCustomDomainOutputDto = {
  __typename?: 'DeployCustomDomainOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  domain: Scalars['String'];
  name: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DocumentInputDto = {
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type DocumentOutputDto = {
  __typename?: 'DocumentOutputDto';
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type EditorialVideoInputDto = {
  coverPictureUrl: Scalars['String'];
  url: Scalars['String'];
};

export type EmailPayload = {
  __typename?: 'EmailPayload';
  email: Scalars['String'];
};

export enum EquipmentCategoryEnum {
  HOBBY = 'HOBBY',
  OTHER = 'OTHER',
  RULES_OF_PROCEDURE = 'RULES_OF_PROCEDURE',
  WORK = 'WORK'
}

export type EquipmentFilter = {
  __typename?: 'EquipmentFilter';
  labelIntl?: Maybe<IntlLocalesOutputDto>;
};

export type EquipmentOutputDto = {
  __typename?: 'EquipmentOutputDto';
  _id: Scalars['ID'];
  category: EquipmentCategoryEnum;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  filters: Array<FiltersEnum>;
  icon: Scalars['String'];
  label: Scalars['String'];
  labelIntl: IntlLocalesOutputDto;
  position: Scalars['Int'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EquipmentRequested = {
  __typename?: 'EquipmentRequested';
  label?: Maybe<Scalars['String']>;
  matchEquipments?: Maybe<Array<MatchEquipementsType>>;
};

export enum EquipmentSpecialTypeEnum {
  POOL = 'POOL',
  SPA = 'SPA'
}

export enum ExportTypeEnum {
  CLIENT_BILLING = 'CLIENT_BILLING',
  CLIENT_REQUESTS = 'CLIENT_REQUESTS',
  HOUSES = 'HOUSES',
  PAYMENTS = 'PAYMENTS',
  PROVISIONS = 'PROVISIONS',
  SERVICE_OWNER_BILLING = 'SERVICE_OWNER_BILLING'
}

export type FeedbackInputDto = {
  comment?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  houseId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['Float']>;
  serviceId?: InputMaybe<Scalars['String']>;
};

export type FeedbackOutputDto = {
  __typename?: 'FeedbackOutputDto';
  comment?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  houseId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['Float']>;
  serviceId?: Maybe<Scalars['String']>;
  serviceProvisionNames?: Maybe<Array<Scalars['String']>>;
};

export enum FilterBudgetTypeEnum {
  ALL = 'ALL',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  DRY_LOCATION = 'DRY_LOCATION'
}

export type FilterDatesDto = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type FilterDatesObj = {
  __typename?: 'FilterDatesObj';
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type FilterLocationDto = {
  label?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
};

export type FilterLocationObj = {
  __typename?: 'FilterLocationObj';
  label?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
};

export type FilterMatchsDto = {
  ambiance?: InputMaybe<Array<AmbianceEnum>>;
  bedrooms?: InputMaybe<Scalars['Int']>;
  beds?: InputMaybe<Scalars['Int']>;
  equipments?: InputMaybe<Array<Scalars['String']>>;
  forcedDefaultTravelCity?: InputMaybe<Scalars['Boolean']>;
  houseId?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<Array<HouseTypeEnum>>;
  isAutonomousBookingAvailable?: InputMaybe<Scalars['Boolean']>;
  prices?: InputMaybe<Array<HousePriceRange>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  travelType?: InputMaybe<TravelTypeEnum>;
  traveltime?: InputMaybe<FilterTransportTime>;
};

export type FilterMatchsObj = {
  __typename?: 'FilterMatchsObj';
  ambiance?: Maybe<Array<AmbianceEnum>>;
  bedrooms?: Maybe<Array<Scalars['Int']>>;
  beds?: Maybe<Array<Scalars['Int']>>;
  earlyCheckin?: Maybe<Scalars['Boolean']>;
  equipments?: Maybe<Array<EquipmentFilter>>;
  forcedDefaultTravelCity?: Maybe<Scalars['Boolean']>;
  houseId?: Maybe<Scalars['String']>;
  houseType?: Maybe<Array<HouseTypeEnum>>;
  lateCheckout?: Maybe<Scalars['Boolean']>;
  prices?: Maybe<Scalars['String']>;
  transportTime?: Maybe<TransportTimeRange>;
};

export enum FilterPastFutureEnum {
  CURRENT_YEAR = 'CURRENT_YEAR',
  FUTURE = 'FUTURE',
  PAST = 'PAST'
}

export type FilterSearchDto = {
  adults?: InputMaybe<Scalars['Int']>;
  dates?: InputMaybe<FilterDatesDto>;
  houseCanBePrivatised?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<FilterLocationDto>;
  prompt?: InputMaybe<Scalars['String']>;
  travelType?: InputMaybe<TravelTypeEnum>;
};

export type FilterSearchObj = {
  __typename?: 'FilterSearchObj';
  adults?: Maybe<Scalars['Int']>;
  dates?: Maybe<FilterDatesObj>;
  location?: Maybe<FilterLocationObj>;
  travelType?: Maybe<TravelTypeEnum>;
};

export type FilterTransportTime = {
  transportTime: TransportTimeRange;
  transportType: Transport_Type;
};

export enum FiltersEnum {
  AUTONOMOUS_BOOKING = 'AUTONOMOUS_BOOKING',
  BARBECUE = 'BARBECUE',
  BICYCLES = 'BICYCLES',
  EQUIPPED_KITCHEN = 'EQUIPPED_KITCHEN',
  EXECUTIVE = 'EXECUTIVE',
  FIBER_CONNECTION = 'FIBER_CONNECTION',
  FIREPLACE = 'FIREPLACE',
  LESS_THAN_15_MIN_FROM_TRAIN_STATION = 'LESS_THAN_15_MIN_FROM_TRAIN_STATION',
  MEETING_ROOM = 'MEETING_ROOM',
  PETANQUE_OR_MOLKY = 'PETANQUE_OR_MOLKY',
  PETS_ALLOWED = 'PETS_ALLOWED',
  SPA = 'SPA',
  SWIMMING_POOL = 'SWIMMING_POOL',
  TABLE_TENNIS = 'TABLE_TENNIS',
  TENNIS_COURT = 'TENNIS_COURT',
  UNUSUAL = 'UNUSUAL',
  WALKING_DISTANCE_FROM_TRAIN_STATION = 'WALKING_DISTANCE_FROM_TRAIN_STATION'
}

export type FinalizeAccountInputDto = {
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
};

export type FinanceClientRequestDto = {
  __typename?: 'FinanceClientRequestDto';
  _id: Scalars['String'];
  adults: Scalars['Float'];
  bookingDate?: Maybe<Scalars['DateTime']>;
  bookingPrice: BookingPrice;
  cashed: Scalars['Float'];
  clientRequestDemandNumber: Scalars['String'];
  companyName: Scalars['String'];
  currencyArea: CurrencyAreaOutputDto;
  depositDate?: Maybe<Scalars['DateTime']>;
  endDate: Scalars['DateTime'];
  houseId?: Maybe<Scalars['String']>;
  houseReadableId?: Maybe<Scalars['String']>;
  marginGap?: Maybe<ComputedPrice>;
  serviceProviderId?: Maybe<Scalars['String']>;
  serviceProviderReadableId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  status: ClientRequestStatusEnum;
  step: Scalars['Int'];
  toCash: Scalars['Float'];
};

export type FinanceClientRequestsCount = {
  __typename?: 'FinanceClientRequestsCount';
  clientRequestIds: Array<Scalars['String']>;
  count: Scalars['Int'];
};

export type ForgotPasswordDto = {
  email: Scalars['String'];
};

export type ForwardPaginationInputDto = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};

export type GetAdvisorConversationClientRequestNotificationsInputDto = {
  clientRequestId: Scalars['String'];
};

export type GetAdvisorConversationContactNotificationsInputDto = {
  contactId: Scalars['String'];
};

export type GetHouseClientProposalsInputDto = {
  hostFilter: ClientProposalHostFiltersEnum;
  houseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type GetMarketplacesInputDto = {
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
};

export type GetSiteLastEventsInputDto = {
  siteId: Scalars['String'];
};

export type GetTop10SiteDestinationsInputDto = {
  siteId: Scalars['String'];
};

export type GetUsersAdminInputDto = {
  companyId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<UnrestrictedPaginationDto>;
  q?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatusEnum>;
};

export type GoogleRatingOutputDto = {
  __typename?: 'GoogleRatingOutputDto';
  rating?: Maybe<Scalars['Float']>;
  userRatingsTotal?: Maybe<Scalars['Int']>;
};

export enum HeatTypeEnum {
  ELECTRIC = 'ELECTRIC',
  FUEL_OIL = 'FUEL_OIL',
  HEAT_NETWORK = 'HEAT_NETWORK',
  HEAT_PUMP = 'HEAT_PUMP',
  OTHERS = 'OTHERS',
  PELLET_STOVE = 'PELLET_STOVE',
  WOOD_STOVE = 'WOOD_STOVE'
}

export type HostModifiedItemOutputDto = {
  __typename?: 'HostModifiedItemOutputDto';
  canceledSuppresionAt?: Maybe<Array<Scalars['DateTime']>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Array<Scalars['DateTime']>>;
  duplicatedAt?: Maybe<Scalars['DateTime']>;
  editedAt?: Maybe<Array<Scalars['DateTime']>>;
  updatedPositionAt?: Maybe<Array<Scalars['DateTime']>>;
};

export type HostOutputDto = {
  __typename?: 'HostOutputDto';
  _id: Scalars['ID'];
  address?: Maybe<AddressContext>;
  companyName?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  houses: Array<HouseContext>;
  hubspot?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  lastConnect?: Maybe<Scalars['DateTime']>;
  lastname: Scalars['String'];
  locale: IntlLocales;
  notifications?: Maybe<Scalars['Float']>;
  phone: Scalars['String'];
  readableId?: Maybe<Scalars['String']>;
  siret?: Maybe<Scalars['String']>;
  status: HouseOwnerStatusEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type HouseAlertContext = {
  __typename?: 'HouseAlertContext';
  activeOwnerSpace: Scalars['Boolean'];
  iCal: Scalars['Boolean'];
  seasonPricesAvailable: Scalars['Boolean'];
  wifi: Scalars['Boolean'];
};

export type HouseAndRestaurationClientPricingMenuInputDto = {
  adults: Scalars['Float'];
  arrival?: InputMaybe<ArrivalEnum>;
  clientProposalId?: InputMaybe<Scalars['String']>;
  departure?: InputMaybe<DepartureEnum>;
  endDate: Scalars['DateTime'];
  houseId: Scalars['String'];
  individualBedroomAdults?: InputMaybe<Scalars['Float']>;
  restauration?: InputMaybe<Scalars['Boolean']>;
  sharedBedroomAdults?: InputMaybe<Scalars['Float']>;
  startDate: Scalars['DateTime'];
  travelType: TravelTypeEnum;
};

export type HouseAvailabilityGetFromToInputDto = {
  from: Scalars['DateTime'];
  houseId: Scalars['String'];
  to: Scalars['DateTime'];
};

export type HouseAvailabilityGlobalCorporateEveningInputDto = {
  isEnabled: Scalars['Boolean'];
};

export type HouseAvailabilityGlobalCorporateEveningOutputDto = {
  __typename?: 'HouseAvailabilityGlobalCorporateEveningOutputDto';
  isEnabled: Scalars['Boolean'];
  state: HouseAvailabilityGlobalStateEnum;
};

export type HouseAvailabilityGlobalInputDto = {
  corporateEvening: HouseAvailabilityGlobalCorporateEveningInputDto;
  date: Scalars['DateTime'];
  houseId: Scalars['String'];
  nightlyTrip: HouseAvailabilityGlobalNightlyTripInputDto;
  studyDay: HouseAvailabilityGlobalStudyDayInputDto;
};

export type HouseAvailabilityGlobalNightlyTripInputDto = {
  isEnabled: Scalars['Boolean'];
  options?: InputMaybe<HouseAvailabilityGlobalNightlyTripOptionsInputDto>;
};

export type HouseAvailabilityGlobalNightlyTripOptionsInputDto = {
  price?: InputMaybe<Scalars['Int']>;
};

export type HouseAvailabilityGlobalNightlyTripOptionsOutputDto = {
  __typename?: 'HouseAvailabilityGlobalNightlyTripOptionsOutputDto';
  price?: Maybe<Scalars['Int']>;
};

export type HouseAvailabilityGlobalNightlyTripOutputDto = {
  __typename?: 'HouseAvailabilityGlobalNightlyTripOutputDto';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseAvailabilityGlobalNightlyTripOptionsOutputDto>;
  state: HouseAvailabilityGlobalStateEnum;
};

export type HouseAvailabilityGlobalOrIndividualDto = {
  global?: InputMaybe<HouseAvailabilityGlobalInputDto>;
  individual?: InputMaybe<HouseAvailabilityIndividualInputDto>;
};

export type HouseAvailabilityGlobalOrIndividualManyDto = {
  global?: InputMaybe<Array<HouseAvailabilityGlobalInputDto>>;
  individual?: InputMaybe<Array<HouseAvailabilityIndividualInputDto>>;
};

export type HouseAvailabilityGlobalOutputDto = {
  __typename?: 'HouseAvailabilityGlobalOutputDto';
  _id: Scalars['String'];
  corporateEvening: HouseAvailabilityGlobalCorporateEveningOutputDto;
  date: Scalars['DateTime'];
  houseId: Scalars['String'];
  nightlyTrip: HouseAvailabilityGlobalNightlyTripOutputDto;
  studyDay: HouseAvailabilityGlobalStudyDayOutputDto;
};

export enum HouseAvailabilityGlobalStateEnum {
  BOOKED = 'BOOKED',
  FREE = 'FREE',
  LOCKED = 'LOCKED'
}

export type HouseAvailabilityGlobalStudyDayInputDto = {
  isEnabled: Scalars['Boolean'];
  options?: InputMaybe<HouseAvailabilityGlobalStudyDayOptionsInputDto>;
};

export type HouseAvailabilityGlobalStudyDayOptionsInputDto = {
  price?: InputMaybe<Scalars['Int']>;
};

export type HouseAvailabilityGlobalStudyDayOptionsOutputDto = {
  __typename?: 'HouseAvailabilityGlobalStudyDayOptionsOutputDto';
  price?: Maybe<Scalars['Int']>;
};

export type HouseAvailabilityGlobalStudyDayOutputDto = {
  __typename?: 'HouseAvailabilityGlobalStudyDayOutputDto';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseAvailabilityGlobalStudyDayOptionsOutputDto>;
  state: HouseAvailabilityGlobalStateEnum;
};

export type HouseAvailabilityICalendarOutputDto = {
  __typename?: 'HouseAvailabilityICalendarOutputDto';
  _id: Scalars['String'];
  date: Scalars['DateTime'];
  houseId: Scalars['String'];
};

export type HouseAvailabilityIndividualCorporateEveningInputDto = {
  isEnabled: Scalars['Boolean'];
};

export type HouseAvailabilityIndividualCorporateEveningOutputDto = {
  __typename?: 'HouseAvailabilityIndividualCorporateEveningOutputDto';
  isEnabled: Scalars['Boolean'];
};

export type HouseAvailabilityIndividualInputDto = {
  corporateEvening: HouseAvailabilityIndividualCorporateEveningInputDto;
  date: Scalars['DateTime'];
  houseId: Scalars['String'];
  nightlyTrip: HouseAvailabilityIndividualNightlyTripInputDto;
  studyDay: HouseAvailabilityIndividualStudyDayInputDto;
};

export type HouseAvailabilityIndividualNightlyTripInputDto = {
  isEnabled: Scalars['Boolean'];
  options?: InputMaybe<HouseAvailabilityIndividualNightlyTripOptionsInputDto>;
};

export type HouseAvailabilityIndividualNightlyTripOptionsInputDto = {
  sharedBedroomPrice?: InputMaybe<Scalars['Int']>;
  singleBedroomPrice?: InputMaybe<Scalars['Int']>;
};

export type HouseAvailabilityIndividualNightlyTripOptionsOutputDto = {
  __typename?: 'HouseAvailabilityIndividualNightlyTripOptionsOutputDto';
  sharedBedroomPrice?: Maybe<Scalars['Int']>;
  singleBedroomPrice?: Maybe<Scalars['Int']>;
};

export type HouseAvailabilityIndividualNightlyTripOutputDto = {
  __typename?: 'HouseAvailabilityIndividualNightlyTripOutputDto';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseAvailabilityIndividualNightlyTripOptionsOutputDto>;
};

export type HouseAvailabilityIndividualOutputDto = {
  __typename?: 'HouseAvailabilityIndividualOutputDto';
  _id: Scalars['String'];
  corporateEvening: HouseAvailabilityIndividualCorporateEveningOutputDto;
  date: Scalars['DateTime'];
  houseId: Scalars['String'];
  nightlyTrip: HouseAvailabilityIndividualNightlyTripOutputDto;
  studyDay: HouseAvailabilityIndividualStudyDayOutputDto;
};

export type HouseAvailabilityIndividualStudyDayInputDto = {
  isEnabled: Scalars['Boolean'];
  options?: InputMaybe<HouseAvailabilityIndividualStudyDayOptionsInputDto>;
};

export type HouseAvailabilityIndividualStudyDayOptionsInputDto = {
  fullDayPrice?: InputMaybe<Scalars['Int']>;
  halfDayPrice?: InputMaybe<Scalars['Int']>;
  residentialPrice?: InputMaybe<Scalars['Int']>;
};

export type HouseAvailabilityIndividualStudyDayOptionsOutputDto = {
  __typename?: 'HouseAvailabilityIndividualStudyDayOptionsOutputDto';
  fullDayPrice?: Maybe<Scalars['Int']>;
  halfDayPrice?: Maybe<Scalars['Int']>;
  residentialPrice?: Maybe<Scalars['Int']>;
};

export type HouseAvailabilityIndividualStudyDayOutputDto = {
  __typename?: 'HouseAvailabilityIndividualStudyDayOutputDto';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseAvailabilityIndividualStudyDayOptionsOutputDto>;
};

export enum HouseAvailabilityKindEnum {
  GLOBAL = 'GLOBAL',
  ICALENDAR = 'ICALENDAR',
  INDIVIDUAL = 'INDIVIDUAL'
}

export type HouseAvailabilityUnionOutputDto = HouseAvailabilityGlobalOutputDto | HouseAvailabilityICalendarOutputDto | HouseAvailabilityIndividualOutputDto;

export type HouseBedroomContext = {
  __typename?: 'HouseBedroomContext';
  _id: Scalars['ID'];
  beds?: Maybe<Array<BedTypeEnum>>;
  capacity?: Maybe<Scalars['Float']>;
  coverPicture?: Maybe<HousePictureContext>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  hasBathroom: Scalars['Boolean'];
  hasWorkingSpace: Scalars['Boolean'];
  name: Scalars['String'];
  pictures: Array<HousePictureContext>;
  position: Scalars['Float'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum HouseBookingTypeEnum {
  ESTIMATED_PRICE = 'ESTIMATED_PRICE',
  INSTANT_PRICE = 'INSTANT_PRICE',
  QUOTATION = 'QUOTATION'
}

export type HouseBookingsWithActionRequiredOutputDto = {
  __typename?: 'HouseBookingsWithActionRequiredOutputDto';
  canAnswerQuote: Scalars['Int'];
  canConfirmAdjustments: Scalars['Int'];
  canConfirmBooking: Scalars['Int'];
};

export type HouseCapacitiesAndBedrooms = {
  __typename?: 'HouseCapacitiesAndBedrooms';
  bedrooms: Array<HouseBedroomContext>;
  maximumNumberOfTravellers: Scalars['Int'];
  numberOfBathrooms: Scalars['Int'];
  numberOfBedrooms: Scalars['Int'];
  numberOfBeds: Scalars['Int'];
  numberOfTwins: Scalars['Int'];
};

export type HouseCarbonFootprintContext = {
  __typename?: 'HouseCarbonFootprintContext';
  airConditioning?: Maybe<AirConditioningEnum>;
  bookableDays?: Maybe<BookableDaysEnum>;
  heatType?: Maybe<HeatTypeEnum>;
  indoorArea?: Maybe<IndoorAreaEnum>;
  wasteType?: Maybe<WasteTypeEnum>;
};

export type HouseCarbonFootprintDto = {
  airConditioning?: InputMaybe<AirConditioningEnum>;
  bookableDays?: InputMaybe<BookableDaysEnum>;
  heatType?: InputMaybe<HeatTypeEnum>;
  indoorArea?: InputMaybe<IndoorAreaEnum>;
  wasteType?: InputMaybe<WasteTypeEnum>;
};

/** ⭐️ A house on Naboo. */
export type HouseContext = {
  __typename?: 'HouseContext';
  _id: Scalars['ID'];
  address?: Maybe<AddressContext>;
  /** 🔐 Authentication required - must be an admin or an owner */
  admin?: Maybe<AdminOutputDto>;
  alerts?: Maybe<HouseAlertContext>;
  ambiance?: Maybe<AmbianceEnum>;
  arrival: Scalars['String'];
  arrivalCowork: Scalars['String'];
  availabilities?: Maybe<Array<HouseAvailabilityUnionOutputDto>>;
  availableExternalProvisions: Array<HouseServiceProvisionsAdminOutputDto>;
  bedrooms: Array<HouseBedroomContext>;
  capacity: Scalars['Int'];
  carbonFootprint?: Maybe<HouseCarbonFootprintContext>;
  companyLogo?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  corporateEveningEventBookingType: HouseBookingTypeEnum;
  /** 🔐 Authentication required - must be an admin */
  countClientProposals?: Maybe<Scalars['Float']>;
  /** 🔐 Authentication required - must be an admin */
  countConfirmedClientProposals?: Maybe<Scalars['Float']>;
  coverPicture: HousePictureContext;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  currencyArea: CurrencyAreaOutputDto;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  departure: Scalars['String'];
  description: HouseDescriptionOutputDto;
  distancefromServiceProvider?: Maybe<Scalars['Int']>;
  equipments?: Maybe<Array<HouseEquipmentOutputDto>>;
  exclusivityServices?: Maybe<HouseExclusivityServicesContext>;
  faq: Array<HouseQuestionAndAnswerOutputDto>;
  fees?: Maybe<PriceOptionFeesOutputDto>;
  googleRating?: Maybe<GoogleRatingOutputDto>;
  hasBedrooms?: Maybe<Scalars['Boolean']>;
  hasBeds?: Maybe<Scalars['Boolean']>;
  hasCapacity?: Maybe<Scalars['Boolean']>;
  hasOwnerId?: Maybe<Scalars['Boolean']>;
  hasTitle?: Maybe<Scalars['Boolean']>;
  houseType?: Maybe<HouseTypeEnum>;
  hubspot?: Maybe<Scalars['String']>;
  /** 🔐 Authentication required - must be an admin or owner */
  iCalURL?: Maybe<Scalars['String']>;
  iCalendars: HouseICalendarsOutputDto;
  /** Returns true if autonomous booking is available for the current house */
  isAutonomousBookingAvailable?: Maybe<Scalars['Boolean']>;
  isExecutive: Scalars['Boolean'];
  isRecommended?: Maybe<Scalars['Boolean']>;
  isServiceProviderAvailable?: Maybe<Scalars['Boolean']>;
  isServiceProviderExclusive?: Maybe<Scalars['Boolean']>;
  lastEndDate?: Maybe<Scalars['DateTime']>;
  locale: IntlLocales;
  memo: Scalars['String'];
  metaDescription: Scalars['String'];
  nabooRating?: Maybe<NabooRatingModel>;
  nbLinkedServices?: Maybe<Scalars['Int']>;
  networks?: Maybe<Array<HouseNetwork>>;
  numberOfBathrooms: Scalars['Int'];
  numberOfBedrooms: Scalars['Int'];
  numberOfBeds: Scalars['Int'];
  numberOfTwins: Scalars['Int'];
  numberOfWorkspaces: Scalars['Int'];
  /** Returns true if the house has a fiber optic network */
  opticalFiber?: Maybe<Scalars['Boolean']>;
  options: HouseOptions;
  /** 🔐 Authentication required - must be an admin or owner */
  owner?: Maybe<HouseOwnerOutputDto>;
  ownerAnswerRate?: Maybe<Scalars['Float']>;
  ownerAnswerTime?: Maybe<Scalars['Float']>;
  ownerId?: Maybe<Scalars['String']>;
  ownerSpaceMode?: Maybe<OwnerSpaceModeEnum>;
  pathname?: Maybe<Scalars['String']>;
  permissions?: Maybe<HousePermissionsOutputDto>;
  pictures: Array<HousePictureContext>;
  priceType: HousePriceTypeEnum;
  provisions: Array<ServiceProvisionOutputDtoUnion>;
  provisionsClientPricingItems: Array<ClientPricingItemOutputDto>;
  ranking?: Maybe<HouseRankingEnum>;
  /** A short simple unique id to identify the house. */
  readableId?: Maybe<Scalars['String']>;
  residentialBookingType: HouseBookingTypeEnum;
  singleDayBookingType: HouseBookingTypeEnum;
  specialConditions: SpecialConditions;
  startingFees: HouseStartingFees;
  status: HouseStatus;
  suggestion?: Maybe<SuggestionsContext>;
  /** If the query is authenticated as admin, it will also return private tags. */
  tags: Array<TagOutputDto>;
  taxIdentifier: TaxIdentifierEnum;
  title: Scalars['String'];
  trainStation?: Maybe<TrainStation>;
  /** 🔐 Authentication required - or return null */
  travelCity?: Maybe<TravelCityContext>;
  travelTime?: Maybe<Array<TravelTimeContext>>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  website?: Maybe<Scalars['String']>;
  workspaces: Array<HouseWorkspaceOutputDto>;
};


/** ⭐️ A house on Naboo. */
export type HouseContextEquipmentsArgs = {
  category?: InputMaybe<EquipmentCategoryEnum>;
};


/** ⭐️ A house on Naboo. */
export type HouseContextFaqArgs = {
  onlyIsVisible?: Scalars['Boolean'];
};


/** ⭐️ A house on Naboo. */
export type HouseContextIsAutonomousBookingAvailableArgs = {
  travelType?: InputMaybe<TravelTypeEnum>;
};


/** ⭐️ A house on Naboo. */
export type HouseContextIsRecommendedArgs = {
  clientRequestId?: InputMaybe<Scalars['String']>;
};


/** ⭐️ A house on Naboo. */
export type HouseContextPicturesArgs = {
  withBedrooms?: Scalars['Boolean'];
};

export type HouseCorporateEveningDto = {
  global?: InputMaybe<HouseCorporateEveningGlobalDto>;
  individual?: InputMaybe<HouseCorporateEveningIndividualDto>;
};

export type HouseCorporateEveningGlobal = {
  __typename?: 'HouseCorporateEveningGlobal';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseCorporateEveningGlobalOptions>;
};

export type HouseCorporateEveningGlobalDto = {
  isEnabled: Scalars['Boolean'];
  options: HouseCorporateEveningGlobalOptionsDto;
};

export type HouseCorporateEveningGlobalOptions = {
  __typename?: 'HouseCorporateEveningGlobalOptions';
  capacity: HouseOptionsCapacity;
  hours: HouseCorporateEveningOptionsHours;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseCorporateEveningOptionsSeasonalPrices>;
  /** TVA applicable aux soirées d'entreprise */
  vatRate?: Maybe<Scalars['Int']>;
};

export type HouseCorporateEveningGlobalOptionsDto = {
  capacity: HouseOptionsCapacityDto;
  hours: HouseCorporateEveningOptionsHoursDto;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseCorporateEveningOptionsSeasonalPricesDto>;
  /** TVA applicable aux soirées d'entreprise */
  vatRate?: InputMaybe<Scalars['Int']>;
};

export type HouseCorporateEveningIndividual = {
  __typename?: 'HouseCorporateEveningIndividual';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseCorporateEveningIndividualOptions>;
};

export type HouseCorporateEveningIndividualDto = {
  isEnabled: Scalars['Boolean'];
  options: HouseCorporateEveningIndividualOptionsDto;
};

export type HouseCorporateEveningIndividualOptions = {
  __typename?: 'HouseCorporateEveningIndividualOptions';
  capacity: HouseOptionsCapacity;
  hours: HouseCorporateEveningOptionsHours;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseCorporateEveningOptionsSeasonalPrices>;
  /** TVA applicable aux soirées d'entreprise */
  vatRate?: Maybe<Scalars['Int']>;
};

export type HouseCorporateEveningIndividualOptionsDto = {
  capacity: HouseOptionsCapacityDto;
  hours: HouseCorporateEveningOptionsHoursDto;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseCorporateEveningOptionsSeasonalPricesDto>;
  /** TVA applicable aux soirées d'entreprise */
  vatRate?: InputMaybe<Scalars['Int']>;
};

export type HouseCorporateEveningOptionsHours = {
  __typename?: 'HouseCorporateEveningOptionsHours';
  endAt: Scalars['String'];
  overStayMaxAt: Scalars['String'];
  startAt: Scalars['String'];
};

export type HouseCorporateEveningOptionsHoursDto = {
  endAt: Scalars['String'];
  overStayMaxAt: Scalars['String'];
  startAt: Scalars['String'];
};

export type HouseCorporateEveningOptionsSeasonalPrices = {
  __typename?: 'HouseCorporateEveningOptionsSeasonalPrices';
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: Maybe<Scalars['DateTime']>;
  /** Tarif accès aux salles (heure supplémentaire) */
  overStayMax: HouseOptionsSeasonPrice;
  /** Tarif accès aux salles */
  regular: HouseOptionsSeasonPrice;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: Maybe<Scalars['DateTime']>;
};

export type HouseCorporateEveningOptionsSeasonalPricesDto = {
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: InputMaybe<Scalars['DateTime']>;
  /** Tarif accès aux salles (heure supplémentaire) */
  overStayMax: HouseOptionsSeasonPriceDto;
  /** Tarif accès aux salles */
  regular: HouseOptionsSeasonPriceDto;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: InputMaybe<Scalars['DateTime']>;
};

export enum HouseDailyTypeEnum {
  DAY_PACKAGE = 'DAY_PACKAGE',
  HALF_DAY_PACKAGE = 'HALF_DAY_PACKAGE',
  RESIDENTIAL_SEMINAR = 'RESIDENTIAL_SEMINAR'
}

export type HouseDescriptionInputDto = {
  access: Scalars['String'];
  introduction: Scalars['String'];
};

export type HouseDescriptionOutputDto = {
  __typename?: 'HouseDescriptionOutputDto';
  access: IntlOutputDto;
  introduction: IntlOutputDto;
};

export type HouseDisponibilityRequested = {
  __typename?: 'HouseDisponibilityRequested';
  earlyCheckin?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['String']>;
  isNotASpecificDates?: Maybe<Scalars['Boolean']>;
  lateCheckout?: Maybe<Scalars['Boolean']>;
  numberOfDays?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['String']>;
};

export type HouseEquipmentOutputDto = {
  __typename?: 'HouseEquipmentOutputDto';
  _id: Scalars['ID'];
  category: EquipmentCategoryEnum;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  equipmentId: Scalars['String'];
  icon: Scalars['String'];
  label: Scalars['String'];
  labelIntl: IntlLocalesOutputDto;
  specialType?: Maybe<EquipmentSpecialTypeEnum>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HouseExclusivityServicesContext = {
  __typename?: 'HouseExclusivityServicesContext';
  activities: Scalars['Boolean'];
  mobility: Scalars['Boolean'];
  restoration: Scalars['Boolean'];
};

export type HouseFaqCustomOutputDto = {
  __typename?: 'HouseFAQCustomOutputDto';
  _id: Scalars['ID'];
  admin: AdminOutputDto;
  adminId: Scalars['String'];
  answer?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  position: Scalars['Float'];
  question: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HouseFaqDefaultOutputDto = {
  __typename?: 'HouseFAQDefaultOutputDto';
  _id: Scalars['ID'];
  answer?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  position: Scalars['Float'];
  questionType: QuestionTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HouseICalendarUrlsInputDto = {
  urls: Array<Scalars['String']>;
};

export type HouseICalendarsOutputDto = {
  __typename?: 'HouseICalendarsOutputDto';
  urls: Array<Scalars['String']>;
};

export type HouseIsDispoServiceInputDto = {
  _id: Scalars['String'];
  isDispo: Scalars['Boolean'];
};

export type HouseListDto = {
  clientRequestId?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<HouseTypeEnum>;
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
  refSupplyId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<HouseStatus>;
  travelType?: InputMaybe<TravelTypeEnum>;
};

export type HouseMenuItemPrice = {
  __typename?: 'HouseMenuItemPrice';
  HIGH?: Maybe<Scalars['Float']>;
  LOW?: Maybe<Scalars['Float']>;
  MEDIUM?: Maybe<Scalars['Float']>;
};

export type HouseMenuPriceOutputDto = {
  __typename?: 'HouseMenuPriceOutputDto';
  error?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  prices?: Maybe<HouseMenuItemPrice>;
};

export type HouseMenuPricesInputDto = {
  houseId: Scalars['String'];
};

export type HouseNetwork = {
  __typename?: 'HouseNetwork';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  houseId: Scalars['String'];
  operator?: Maybe<OperatorEnum>;
  speed: Scalars['Int'];
  type: NetworkTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  wifiType?: Maybe<WifiTypeEnum>;
};

export enum HouseNightTypeEnum {
  HOUSE_PRICE = 'HOUSE_PRICE',
  INDIVIDUAL_BEDROOMS = 'INDIVIDUAL_BEDROOMS',
  SHARED_BEDROOMS = 'SHARED_BEDROOMS'
}

export type HouseNightlyTripDto = {
  global?: InputMaybe<HouseNightlyTripGlobalDto>;
  individual?: InputMaybe<HouseNightlyTripIndividualDto>;
};

export type HouseNightlyTripGlobal = {
  __typename?: 'HouseNightlyTripGlobal';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseNightlyTripGlobalOptions>;
};

export type HouseNightlyTripGlobalDto = {
  isEnabled: Scalars['Boolean'];
  options: HouseNightlyTripGlobalOptionsDto;
};

export type HouseNightlyTripGlobalOptions = {
  __typename?: 'HouseNightlyTripGlobalOptions';
  /** Flexibilité des horaires */
  flexibleSchedule: HouseNightlyTripGlobalOptionsFlexibleSchedule;
  /** Ménage et linge de maison */
  houseHold?: Maybe<HouseNightlyTripGlobalOptionsHouseHold>;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseNightlyTripGlobalOptionsSeasonalPrices>;
  /** Taxe de séjour */
  touristTaxPrice?: Maybe<Scalars['Int']>;
  /** TVA applicable aux nuitées */
  vatRate?: Maybe<Scalars['Int']>;
};

export type HouseNightlyTripGlobalOptionsDto = {
  /** Flexibilité des horaires */
  flexibleSchedule: HouseNightlyTripGlobalOptionsFlexibleScheduleDto;
  /** Ménage et linge de maison */
  houseHold?: InputMaybe<HouseNightlyTripGlobalOptionsHouseHoldDto>;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseNightlyTripGlobalOptionsSeasonalPricesDto>;
  /** Taxe de séjour */
  touristTaxPrice?: InputMaybe<Scalars['Int']>;
  /** TVA applicable aux nuitées */
  vatRate?: InputMaybe<Scalars['Int']>;
};

export type HouseNightlyTripGlobalOptionsFlexibleSchedule = {
  __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule';
  /** Arrivée ancitipée */
  earlyCheckinPrice?: Maybe<Scalars['Int']>;
  /** Départ tardif */
  lateCheckoutPrice?: Maybe<Scalars['Int']>;
  /** TVA applicable aux suppléments */
  vatRate?: Maybe<Scalars['Int']>;
};

export type HouseNightlyTripGlobalOptionsFlexibleScheduleDto = {
  /** Arrivée ancitipée */
  earlyCheckinPrice?: InputMaybe<Scalars['Int']>;
  /** Départ tardif */
  lateCheckoutPrice?: InputMaybe<Scalars['Int']>;
  /** TVA applicable aux suppléments */
  vatRate?: InputMaybe<Scalars['Int']>;
};

export type HouseNightlyTripGlobalOptionsHouseHold = {
  __typename?: 'HouseNightlyTripGlobalOptionsHouseHold';
  /** Ménage */
  cleaningPrice?: Maybe<Scalars['Int']>;
  /** Linge */
  laundryPrice?: Maybe<Scalars['Int']>;
  /** TVA applicable aux suppléments ménage et linge de maison */
  vatRate?: Maybe<Scalars['Int']>;
};

export type HouseNightlyTripGlobalOptionsHouseHoldDto = {
  /** Ménage */
  cleaningPrice?: InputMaybe<Scalars['Int']>;
  /** Linge */
  laundryPrice?: InputMaybe<Scalars['Int']>;
  /** TVA applicable aux suppléments ménage et linge de maison */
  vatRate?: InputMaybe<Scalars['Int']>;
};

export type HouseNightlyTripGlobalOptionsSeasonalPrices = {
  __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices';
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: Maybe<Scalars['DateTime']>;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: Maybe<Scalars['DateTime']>;
  /** Prix nuitée semaine */
  weekDay: HouseOptionsSeasonPrice;
  /** Prix nuitée week-end */
  weekEnd: HouseOptionsSeasonPrice;
};

export type HouseNightlyTripGlobalOptionsSeasonalPricesDto = {
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: InputMaybe<Scalars['DateTime']>;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: InputMaybe<Scalars['DateTime']>;
  /** Prix nuitée semaine */
  weekDay: HouseOptionsSeasonPriceDto;
  /** Prix nuitée week-end */
  weekEnd: HouseOptionsSeasonPriceDto;
};

export type HouseNightlyTripIndividual = {
  __typename?: 'HouseNightlyTripIndividual';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseNightlyTripIndividualOptions>;
};

export type HouseNightlyTripIndividualDto = {
  isEnabled: Scalars['Boolean'];
  options: HouseNightlyTripIndividualOptionsDto;
};

export type HouseNightlyTripIndividualOptions = {
  __typename?: 'HouseNightlyTripIndividualOptions';
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseNightlyTripIndividualOptionsSeasonalPrices>;
  /** Taxe de séjour */
  touristTaxPrice?: Maybe<Scalars['Int']>;
  /** TVA applicable aux nuitées */
  vatRate?: Maybe<Scalars['Int']>;
};

export type HouseNightlyTripIndividualOptionsDto = {
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseNightlyTripIndividualOptionsSeasonalPricesDto>;
  /** Taxe de séjour */
  touristTaxPrice?: InputMaybe<Scalars['Int']>;
  /** TVA applicable aux nuitées */
  vatRate?: InputMaybe<Scalars['Int']>;
};

export type HouseNightlyTripIndividualOptionsSeasonalPrices = {
  __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices';
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: Maybe<Scalars['DateTime']>;
  /** Prix nuitée en chambre partagée */
  sharedBedroom: HouseOptionsSeasonPrice;
  /** Prix nuitée en chambre individuelle */
  singleBedroom: HouseOptionsSeasonPrice;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: Maybe<Scalars['DateTime']>;
};

export type HouseNightlyTripIndividualOptionsSeasonalPricesDto = {
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: InputMaybe<Scalars['DateTime']>;
  /** Prix nuitée en chambre partagée */
  sharedBedroom: HouseOptionsSeasonPriceDto;
  /** Prix nuitée en chambre individuelle */
  singleBedroom: HouseOptionsSeasonPriceDto;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: InputMaybe<Scalars['DateTime']>;
};

export type HouseOptions = HouseOptionsGlobal | HouseOptionsIndividual;

export type HouseOptionsCapacity = {
  __typename?: 'HouseOptionsCapacity';
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type HouseOptionsCapacityDto = {
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type HouseOptionsGlobal = {
  __typename?: 'HouseOptionsGlobal';
  corporateEvening: HouseCorporateEveningGlobal;
  nightlyTrip: HouseNightlyTripGlobal;
  seasonalBusynessCalendar: Array<HouseSeasonalBusynessCalendar>;
  studyDay: HouseStudyDayGlobal;
};

export type HouseOptionsIndividual = {
  __typename?: 'HouseOptionsIndividual';
  corporateEvening: HouseCorporateEveningIndividual;
  nightlyTrip: HouseNightlyTripIndividual;
  seasonalBusynessCalendar: Array<HouseSeasonalBusynessCalendar>;
  studyDay: HouseStudyDayIndividual;
};

export type HouseOptionsSeasonPrice = {
  __typename?: 'HouseOptionsSeasonPrice';
  /** Prix haute saison */
  highPrice?: Maybe<Scalars['Float']>;
  /** Prix basse saison */
  lowPrice?: Maybe<Scalars['Float']>;
  /** Prix moyenne saison */
  mediumPrice?: Maybe<Scalars['Float']>;
};

export type HouseOptionsSeasonPriceDto = {
  /** Prix haute saison */
  highPrice?: InputMaybe<Scalars['Int']>;
  /** Prix basse saison */
  lowPrice?: InputMaybe<Scalars['Int']>;
  /** Prix moyenne saison */
  mediumPrice?: InputMaybe<Scalars['Int']>;
};

export type HouseOwnerFilterInputDto = {
  q?: InputMaybe<Scalars['String']>;
};

export type HouseOwnerOutputDto = {
  __typename?: 'HouseOwnerOutputDto';
  _id: Scalars['ID'];
  address?: Maybe<AddressContext>;
  companyName?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  hasPassword?: Maybe<Scalars['Boolean']>;
  houses?: Maybe<Array<HouseContext>>;
  hubspot?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  lastConnect?: Maybe<Scalars['DateTime']>;
  lastname?: Maybe<Scalars['String']>;
  notifications?: Maybe<Scalars['Float']>;
  phone?: Maybe<Scalars['String']>;
  readableId?: Maybe<Scalars['String']>;
  siret?: Maybe<Scalars['String']>;
  status?: Maybe<HouseOwnerStatusEnum>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export type HouseOwnerOutputDtoEdge = {
  __typename?: 'HouseOwnerOutputDtoEdge';
  cursor: Scalars['String'];
  node: HouseOwnerOutputDto;
};

export type HouseOwnerOutputDtoPageInfo = {
  __typename?: 'HouseOwnerOutputDtoPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type HouseOwnerSearchInputDto = {
  filters?: InputMaybe<HouseOwnerFilterInputDto>;
  paginationArgsBackward?: InputMaybe<BackwardPaginationInputDto>;
  paginationArgsForward?: InputMaybe<ForwardPaginationInputDto>;
};

export enum HouseOwnerStatusEnum {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  INVITED = 'INVITED'
}

export type HousePermissionsOutputDto = {
  __typename?: 'HousePermissionsOutputDto';
  canUpdatePriceType: Scalars['Boolean'];
};

export type HousePictureByType = {
  __typename?: 'HousePictureByType';
  bedroomId?: Maybe<Scalars['String']>;
  isWorkspace?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  pictures: Array<HousePictureContext>;
  title?: Maybe<Scalars['String']>;
};

export type HousePictureContext = {
  __typename?: 'HousePictureContext';
  _id: Scalars['String'];
  bedroomId?: Maybe<Scalars['String']>;
  position: Scalars['Float'];
  type: HousePictureEnum;
  uri: Scalars['String'];
};

export enum HousePictureEnum {
  BEDROOM = 'BEDROOM',
  CERTIFICATION = 'CERTIFICATION',
  HOUSE = 'HOUSE',
  WORKSPACE = 'WORKSPACE'
}

export enum HousePriceRange {
  LESS_100 = 'LESS_100',
  LESS_300 = 'LESS_300',
  LESS_500 = 'LESS_500'
}

export enum HousePriceTypeEnum {
  GLOBAL = 'GLOBAL',
  INDIVIDUAL = 'INDIVIDUAL'
}

export type HouseQuestionAndAnswerOutputDto = HouseFaqCustomOutputDto | HouseFaqDefaultOutputDto;

export enum HouseRankingEnum {
  TOP10 = 'TOP10',
  TOP20 = 'TOP20',
  TOP100 = 'TOP100'
}

export type HouseSearchInputDto = {
  adults?: InputMaybe<Scalars['Int']>;
  ambiance?: InputMaybe<Array<AmbianceEnum>>;
  budget?: InputMaybe<HousesBudgetFilterDto>;
  dates?: InputMaybe<FilterDatesDto>;
  equipments?: InputMaybe<Array<Scalars['String']>>;
  filters?: InputMaybe<Array<FiltersEnum>>;
  houseCanBePrivatised?: InputMaybe<Scalars['Boolean']>;
  houseIdsToExclude?: Array<Scalars['String']>;
  houseType?: InputMaybe<Array<HouseTypeEnum>>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isAutonomousBookingAvailable?: InputMaybe<Scalars['Boolean']>;
  limit?: Scalars['Int'];
  location?: InputMaybe<FilterLocationDto>;
  numberOfBedrooms?: InputMaybe<NumberOfBedroomsInputDto>;
  numberOfBeds?: InputMaybe<Scalars['Int']>;
  sortBy: DataSortEnum;
  tags?: InputMaybe<Array<Scalars['String']>>;
  travelTime?: InputMaybe<FilterTransportTime>;
  travelType?: InputMaybe<TravelTypeEnum>;
};

export type HouseSeasonalBusynessCalendar = {
  __typename?: 'HouseSeasonalBusynessCalendar';
  /** Fin de la période de saison (null si la saison est en cours) */
  endAt?: Maybe<Scalars['DateTime']>;
  /** Détail de la saisonnalité par mois */
  months: HouseSeasonalBusynessCalendarMonths;
  /** Début de la période de saison (null si la saison est en cours) */
  startAt?: Maybe<Scalars['DateTime']>;
};

export type HouseSeasonalBusynessCalendarDto = {
  /** Fin de la période de saison (null si la saison est en cours) */
  endAt?: InputMaybe<Scalars['DateTime']>;
  /** Détail de la saisonnalité par mois */
  months: HouseSeasonalBusynessCalendarMonthsDto;
  /** Début de la période de saison (null si la saison est en cours) */
  startAt?: InputMaybe<Scalars['DateTime']>;
};

export type HouseSeasonalBusynessCalendarMonth = {
  __typename?: 'HouseSeasonalBusynessCalendarMonth';
  /** Première moitié du mois */
  firstHalf: SeasonEnum;
  /** Seconde moitié du mois */
  secondHalf: SeasonEnum;
};

export type HouseSeasonalBusynessCalendarMonthDto = {
  /** Première moitié du mois */
  firstHalf: SeasonEnum;
  /** Seconde moitié du mois */
  secondHalf: SeasonEnum;
};

export type HouseSeasonalBusynessCalendarMonths = {
  __typename?: 'HouseSeasonalBusynessCalendarMonths';
  april: HouseSeasonalBusynessCalendarMonth;
  august: HouseSeasonalBusynessCalendarMonth;
  december: HouseSeasonalBusynessCalendarMonth;
  february: HouseSeasonalBusynessCalendarMonth;
  january: HouseSeasonalBusynessCalendarMonth;
  july: HouseSeasonalBusynessCalendarMonth;
  june: HouseSeasonalBusynessCalendarMonth;
  march: HouseSeasonalBusynessCalendarMonth;
  may: HouseSeasonalBusynessCalendarMonth;
  november: HouseSeasonalBusynessCalendarMonth;
  october: HouseSeasonalBusynessCalendarMonth;
  september: HouseSeasonalBusynessCalendarMonth;
};

export type HouseSeasonalBusynessCalendarMonthsDto = {
  april: HouseSeasonalBusynessCalendarMonthDto;
  august: HouseSeasonalBusynessCalendarMonthDto;
  december: HouseSeasonalBusynessCalendarMonthDto;
  february: HouseSeasonalBusynessCalendarMonthDto;
  january: HouseSeasonalBusynessCalendarMonthDto;
  july: HouseSeasonalBusynessCalendarMonthDto;
  june: HouseSeasonalBusynessCalendarMonthDto;
  march: HouseSeasonalBusynessCalendarMonthDto;
  may: HouseSeasonalBusynessCalendarMonthDto;
  november: HouseSeasonalBusynessCalendarMonthDto;
  october: HouseSeasonalBusynessCalendarMonthDto;
  september: HouseSeasonalBusynessCalendarMonthDto;
};

export type HouseServiceAdminOutputDto = {
  __typename?: 'HouseServiceAdminOutputDto';
  _id: Scalars['String'];
  associatedHousesNumber: Scalars['Float'];
  category?: Maybe<ServiceProviderCategoryEnum>;
  distance?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  hubspot?: Maybe<Scalars['String']>;
  isDispo?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  mainPicture?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  readableId: Scalars['String'];
  recommended?: Maybe<Scalars['Boolean']>;
  serviceProviderId?: Maybe<Scalars['String']>;
  status?: Maybe<ServiceProviderStatusEnum>;
  title: Scalars['String'];
  websiteURL?: Maybe<Scalars['String']>;
};

export type HouseServiceProvisionsAdminOutputDto = {
  __typename?: 'HouseServiceProvisionsAdminOutputDto';
  _id: Scalars['String'];
  associatedHousesNumber: Scalars['Float'];
  category?: Maybe<ServiceProviderCategoryEnum>;
  distance?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  feesRate?: Maybe<Scalars['Int']>;
  hubspot?: Maybe<Scalars['String']>;
  isDispo?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  mainPicture?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  prices: Array<ServiceProvisionPriceOutputDto>;
  readableId: Scalars['String'];
  recommended?: Maybe<Scalars['Boolean']>;
  serviceProviderId?: Maybe<Scalars['String']>;
  status?: Maybe<ServiceProviderStatusEnum>;
  title: Scalars['String'];
  type?: Maybe<ServiceProvisionTypeEnum>;
  websiteURL?: Maybe<Scalars['String']>;
};

export type HouseServiceProvisionsOutputDto = {
  __typename?: 'HouseServiceProvisionsOutputDto';
  serviceProviders: Array<ServiceProviderOutputDto>;
  serviceProvisions: Array<ServiceProvisionOutputDtoUnion>;
};

export type HouseServicesAdminOutputDto = {
  __typename?: 'HouseServicesAdminOutputDto';
  exclusivity: HouseServicesExclusivityAdminOutputDto;
  services: Array<HouseServiceAdminOutputDto>;
};

export type HouseServicesExclusivityAdminOutputDto = {
  __typename?: 'HouseServicesExclusivityAdminOutputDto';
  activities: Scalars['Boolean'];
  mobility: Scalars['Boolean'];
  restoration: Scalars['Boolean'];
};

export type HouseStartingFees = {
  __typename?: 'HouseStartingFees';
  dailyPrice?: Maybe<Scalars['Int']>;
  minHousePrice?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
};

export enum HouseStatus {
  ARCHIVED_BANNED = 'ARCHIVED_BANNED',
  ARCHIVED_OWNER = 'ARCHIVED_OWNER',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type HouseStudyDayDto = {
  global?: InputMaybe<HouseStudyDayGlobalDto>;
  individual?: InputMaybe<HouseStudyDayIndividualDto>;
};

export type HouseStudyDayGlobal = {
  __typename?: 'HouseStudyDayGlobal';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseStudyDayGlobalOptions>;
};

export type HouseStudyDayGlobalDto = {
  isEnabled: Scalars['Boolean'];
  options: HouseStudyDayGlobalOptionsDto;
};

export type HouseStudyDayGlobalOptions = {
  __typename?: 'HouseStudyDayGlobalOptions';
  capacity: HouseOptionsCapacity;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseStudyDayGlobalOptionsSeasonalPrices>;
  /** TVA applicable aux séjours à la journée */
  vatRate?: Maybe<Scalars['Int']>;
};

export type HouseStudyDayGlobalOptionsDto = {
  capacity: HouseOptionsCapacityDto;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseStudyDayGlobalOptionsSeasonalPricesDto>;
  /** TVA applicable aux séjours à la journée */
  vatRate?: InputMaybe<Scalars['Int']>;
};

export type HouseStudyDayGlobalOptionsSeasonalPrices = {
  __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices';
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: Maybe<Scalars['DateTime']>;
  /** Prix haute saison */
  highPrice?: Maybe<Scalars['Float']>;
  /** Prix basse saison */
  lowPrice?: Maybe<Scalars['Float']>;
  /** Prix moyenne saison */
  mediumPrice?: Maybe<Scalars['Float']>;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: Maybe<Scalars['DateTime']>;
};

export type HouseStudyDayGlobalOptionsSeasonalPricesDto = {
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: InputMaybe<Scalars['DateTime']>;
  /** Prix haute saison */
  highPrice?: InputMaybe<Scalars['Int']>;
  /** Prix basse saison */
  lowPrice?: InputMaybe<Scalars['Int']>;
  /** Prix moyenne saison */
  mediumPrice?: InputMaybe<Scalars['Int']>;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: InputMaybe<Scalars['DateTime']>;
};

export type HouseStudyDayIndividual = {
  __typename?: 'HouseStudyDayIndividual';
  isEnabled: Scalars['Boolean'];
  options?: Maybe<HouseStudyDayIndividualOptions>;
};

export type HouseStudyDayIndividualDto = {
  isEnabled: Scalars['Boolean'];
  options: HouseStudyDayIndividualOptionsDto;
};

export type HouseStudyDayIndividualOptions = {
  __typename?: 'HouseStudyDayIndividualOptions';
  capacity: HouseOptionsCapacity;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseStudyDayIndividualOptionsSeasonalPrices>;
  /** TVA applicable aux séjours à la journée */
  vatRate?: Maybe<Scalars['Int']>;
};

export type HouseStudyDayIndividualOptionsDto = {
  capacity: HouseOptionsCapacityDto;
  /** Prix saisonnalisés */
  seasonalPrices: Array<HouseStudyDayIndividualOptionsSeasonalPricesDto>;
  /** TVA applicable aux séjours à la journée */
  vatRate?: InputMaybe<Scalars['Int']>;
};

export type HouseStudyDayIndividualOptionsSeasonalPrices = {
  __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices';
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: Maybe<Scalars['DateTime']>;
  /** Forfait journée d'étude */
  fullDay: HouseOptionsSeasonPrice;
  /** Forfait 1/2 journée d'étude */
  halfDay: HouseOptionsSeasonPrice;
  /** Forfait séminaire résidentiel */
  residential: HouseOptionsSeasonPrice;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: Maybe<Scalars['DateTime']>;
};

export type HouseStudyDayIndividualOptionsSeasonalPricesDto = {
  /** Fin de la période de prix (null si la période est en cours) */
  endAt?: InputMaybe<Scalars['DateTime']>;
  /** Forfait journée d'étude */
  fullDay: HouseOptionsSeasonPriceDto;
  /** Forfait 1/2 journée d'étude */
  halfDay: HouseOptionsSeasonPriceDto;
  /** Forfait séminaire résidentiel */
  residential: HouseOptionsSeasonPriceDto;
  /** Début de la période de prix (null si la période est en cours) */
  startAt?: InputMaybe<Scalars['DateTime']>;
};

export enum HouseTypeEnum {
  HOTEL = 'HOTEL',
  RECEPTION_HALL = 'RECEPTION_HALL',
  SELF_MANAGED = 'SELF_MANAGED',
  SEMINARS = 'SEMINARS',
  VILLAGE_ECOLODGE = 'VILLAGE_ECOLODGE'
}

export type HouseUrlNotFoundOutputDto = {
  __typename?: 'HouseUrlNotFoundOutputDto';
  notFound: Scalars['Boolean'];
};

export type HouseUrlOutputDto = HouseContext | HouseUrlNotFoundOutputDto | HouseUrlRedirectOutputDto;

export type HouseUrlRedirectOutputDto = {
  __typename?: 'HouseUrlRedirectOutputDto';
  redirectPathname: Scalars['String'];
};

export type HouseWorkspaceCapacityInputDto = {
  board?: InputMaybe<Scalars['Float']>;
  cabaret?: InputMaybe<Scalars['Float']>;
  classroom?: InputMaybe<Scalars['Float']>;
  island?: InputMaybe<Scalars['Float']>;
  theater?: InputMaybe<Scalars['Float']>;
  u?: InputMaybe<Scalars['Float']>;
};

export type HouseWorkspaceCapacityOutputDto = {
  __typename?: 'HouseWorkspaceCapacityOutputDto';
  board?: Maybe<Scalars['Float']>;
  cabaret?: Maybe<Scalars['Float']>;
  classroom?: Maybe<Scalars['Float']>;
  island?: Maybe<Scalars['Float']>;
  theater?: Maybe<Scalars['Float']>;
  u?: Maybe<Scalars['Float']>;
};

export type HouseWorkspaceInputDto = {
  _id?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<HouseWorkspaceCapacityInputDto>;
  hasDayLight: Scalars['Boolean'];
  name: Scalars['String'];
  position: Scalars['Float'];
  surface?: InputMaybe<Scalars['Float']>;
};

export type HouseWorkspaceOutputDto = {
  __typename?: 'HouseWorkspaceOutputDto';
  _id: Scalars['ID'];
  capacity?: Maybe<HouseWorkspaceCapacityOutputDto>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  hasDayLight: Scalars['Boolean'];
  name: Scalars['String'];
  position: Scalars['Float'];
  surface?: Maybe<Scalars['Float']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HousesBudgetFilterDto = {
  budgetMax: Scalars['Int'];
  budgetMin: Scalars['Int'];
  filterBudgetType?: FilterBudgetTypeEnum;
};

export type HousesWithFiltersDto = {
  filter: FilterMatchsDto;
  houseIdsToExclude?: Array<Scalars['String']>;
  search: FilterSearchDto;
};

export enum IndoorAreaEnum {
  BETWEEN_500_AND_1000 = 'BETWEEN_500_AND_1000',
  BETWEEN_1000_AND_2000 = 'BETWEEN_1000_AND_2000',
  BETWEEN_2000_AND_3000 = 'BETWEEN_2000_AND_3000',
  LESS_THAN_500 = 'LESS_THAN_500',
  MORE_THAN_3000 = 'MORE_THAN_3000'
}

export type IntlInputDto = {
  deDE: Scalars['String'];
  enGB: Scalars['String'];
  esES: Scalars['String'];
  frBE: Scalars['String'];
  frFR: Scalars['String'];
  itIT: Scalars['String'];
  nlBE: Scalars['String'];
  nlNL: Scalars['String'];
};

export enum IntlLocales {
  DEDE = 'deDE',
  ENGB = 'enGB',
  ESES = 'esES',
  FRBE = 'frBE',
  FRFR = 'frFR',
  ITIT = 'itIT',
  NLBE = 'nlBE',
  NLNL = 'nlNL'
}

export type IntlLocalesOutputDto = {
  __typename?: 'IntlLocalesOutputDto';
  deDE: Scalars['String'];
  enGB: Scalars['String'];
  esES: Scalars['String'];
  frBE: Scalars['String'];
  frFR: Scalars['String'];
  itIT: Scalars['String'];
  nlBE: Scalars['String'];
  nlNL: Scalars['String'];
};

export type IntlOutputDto = {
  __typename?: 'IntlOutputDto';
  label: Scalars['String'];
  labelIntl: IntlLocalesOutputDto;
};


export type IntlOutputDtoLabelArgs = {
  forcedLocale?: InputMaybe<IntlLocales>;
};

export type IsHouseAvailableForTravelTypeFromTo = {
  from: Scalars['DateTime'];
  houseId: Scalars['String'];
  to: Scalars['DateTime'];
  travelType: TravelTypeEnum;
};

export enum Iso3166Alpha2Enum {
  AT = 'AT',
  BE = 'BE',
  BG = 'BG',
  CH = 'CH',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DK = 'DK',
  EE = 'EE',
  ES = 'ES',
  FI = 'FI',
  FR = 'FR',
  GB = 'GB',
  GR = 'GR',
  HR = 'HR',
  HU = 'HU',
  IE = 'IE',
  IS = 'IS',
  IT = 'IT',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MA = 'MA',
  MC = 'MC',
  ME = 'ME',
  MT = 'MT',
  NL = 'NL',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  SE = 'SE',
  SI = 'SI',
  SK = 'SK',
  TR = 'TR',
  US = 'US'
}

export enum LastKmsTransportEnum {
  BUS = 'BUS',
  ELECTRIC_CAR = 'ELECTRIC_CAR',
  FOOT = 'FOOT',
  NONE = 'NONE',
  THERMAL_CAR = 'THERMAL_CAR'
}

export type LastVisitedHousesOutputDto = {
  __typename?: 'LastVisitedHousesOutputDto';
  house: HouseContext;
  logCreatedAt: Scalars['DateTime'];
};

export type LocationRequired = {
  __typename?: 'LocationRequired';
  city?: Maybe<CityType>;
};

export type LogObj = {
  __typename?: 'LogObj';
  _id: Scalars['String'];
  bookingId?: Maybe<Scalars['String']>;
  children?: Maybe<Array<SingleLogObj>>;
  clientFeeling?: Maybe<ClientFeelingEnum>;
  clientRequest?: Maybe<ClientRequestOutputDto>;
  clientRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  house?: Maybe<HouseContext>;
  houseId?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Scalars['String']>>;
  searchFilters?: Maybe<FilterMatchsObj>;
  searchParams?: Maybe<FilterSearchObj>;
  serviceProvider?: Maybe<ServiceProviderOutputDto>;
  serviceProviderId?: Maybe<Scalars['String']>;
  suggestion?: Maybe<ClientRequestOutputDto>;
  suggestionId?: Maybe<Scalars['String']>;
  threadFinalCriteria?: Maybe<SearchParamsContext>;
  threadId?: Maybe<Scalars['String']>;
  type: LogTypeEnum;
  user?: Maybe<UserOutputDto>;
  userId?: Maybe<Scalars['String']>;
  visitorEmail?: Maybe<Scalars['String']>;
  vote?: Maybe<ClientProposalVoteEnum>;
};

export enum LogTypeEnum {
  ADD_QUOTATION_TO_EXISTING_PROJECT = 'ADD_QUOTATION_TO_EXISTING_PROJECT',
  ADD_QUOTATION_TO_NEW_PROJECT = 'ADD_QUOTATION_TO_NEW_PROJECT',
  BOOKING_CANCELED = 'BOOKING_CANCELED',
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  BOOKING_NOW = 'BOOKING_NOW',
  BOOKING_PENDING = 'BOOKING_PENDING',
  BOOKING_REFUSED = 'BOOKING_REFUSED',
  CHECK_HOUSE_AVAILABILITY = 'CHECK_HOUSE_AVAILABILITY',
  CLICK_ON_ADD_LOCATION = 'CLICK_ON_ADD_LOCATION',
  CLICK_ON_ADD_PROVISION_ACTIVITY = 'CLICK_ON_ADD_PROVISION_ACTIVITY',
  CLICK_ON_ADD_TRANSPORT_PROVISION = 'CLICK_ON_ADD_TRANSPORT_PROVISION',
  CLICK_ON_CHOOSE_THIS_STAY = 'CLICK_ON_CHOOSE_THIS_STAY',
  CLICK_ON_CONFIRM_BOOKING = 'CLICK_ON_CONFIRM_BOOKING',
  CLICK_ON_CONFIRM_PROVISIONS_ADJUSTMENT = 'CLICK_ON_CONFIRM_PROVISIONS_ADJUSTMENT',
  CLICK_ON_DOWNLOAD_ALL_DOCUMENTS = 'CLICK_ON_DOWNLOAD_ALL_DOCUMENTS',
  CLICK_ON_DOWNLOAD_DOCUMENT = 'CLICK_ON_DOWNLOAD_DOCUMENT',
  CLICK_ON_PAYMENT_DEPOSIT_METHOD = 'CLICK_ON_PAYMENT_DEPOSIT_METHOD',
  CLICK_ON_PAY_DEPOSIT = 'CLICK_ON_PAY_DEPOSIT',
  CLIENT_PROPOSAL_VOTE = 'CLIENT_PROPOSAL_VOTE',
  CLIENT_REQUEST_ANONYMOUS_VISITED = 'CLIENT_REQUEST_ANONYMOUS_VISITED',
  CONNECT = 'CONNECT',
  CONNECT_COUNT = 'CONNECT_COUNT',
  COPY_SHARE_LINK = 'COPY_SHARE_LINK',
  CREATE_QUOTATION = 'CREATE_QUOTATION',
  CREATE_THREAD = 'CREATE_THREAD',
  END_DATE = 'END_DATE',
  HOUSE_LINK = 'HOUSE_LINK',
  NUMBER_ADULT = 'NUMBER_ADULT',
  NUMBER_ROOMS = 'NUMBER_ROOMS',
  PROJECT = 'PROJECT',
  PROJECT_NUMBER = 'PROJECT_NUMBER',
  SEARCH = 'SEARCH',
  SEARCH_COUNT = 'SEARCH_COUNT',
  SELECT_QUOTATION_EXTRA = 'SELECT_QUOTATION_EXTRA',
  SELECT_QUOTATION_FORMULA = 'SELECT_QUOTATION_FORMULA',
  SELECT_QUOTATION_OPTIONS = 'SELECT_QUOTATION_OPTIONS',
  START_DATE = 'START_DATE',
  SUGGESTION_CLIENT_FEELING = 'SUGGESTION_CLIENT_FEELING',
  SUGGESTION_SEE_DETAILS = 'SUGGESTION_SEE_DETAILS',
  VISIT_HOUSE_PAGE = 'VISIT_HOUSE_PAGE',
  VISIT_HOUSE_PAGE_COUNT = 'VISIT_HOUSE_PAGE_COUNT',
  VISIT_SUGGESTION_PAGE = 'VISIT_SUGGESTION_PAGE'
}

export type LoginOwnerByTokenOutputDto = {
  __typename?: 'LoginOwnerByTokenOutputDto';
  isAuthenticateTokenExpired: Scalars['Boolean'];
  owner?: Maybe<HouseOwnerOutputDto>;
};

export type MarkAllMessagesAsReadInputDto = {
  proposalId: Scalars['String'];
};

export type MarketplaceOutputDto = {
  __typename?: 'MarketplaceOutputDto';
  _id: Scalars['ID'];
  /** Returns true if all the required fields are filled in the marketplace */
  canActiveMarketplace: Scalars['Boolean'];
  company?: Maybe<CompanyOutputDto>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  domain: Scalars['String'];
  editorial: SiteEditorialOutputDto;
  name: Scalars['String'];
  pictures?: Maybe<MarketplacePictureOutputDto>;
  resources: Array<SiteResourceOutputDto>;
  status: SiteStatusEnum;
  theme?: Maybe<MarketplaceThemeOutputDto>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type MarketplacePictureInputDto = {
  banner?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
};

export type MarketplacePictureOutputDto = {
  __typename?: 'MarketplacePictureOutputDto';
  banner?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
};

export type MarketplaceThemeInputDto = {
  background?: InputMaybe<Scalars['String']>;
  btnTextPrimary?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['String']>;
  secondary?: InputMaybe<Scalars['String']>;
  textPrimary?: InputMaybe<Scalars['String']>;
};

export type MarketplaceThemeOutputDto = {
  __typename?: 'MarketplaceThemeOutputDto';
  background?: Maybe<Scalars['String']>;
  btnTextPrimary?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['String']>;
  secondary?: Maybe<Scalars['String']>;
  textPrimary?: Maybe<Scalars['String']>;
};

export type MatchEquipementsType = {
  __typename?: 'MatchEquipementsType';
  _id?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
};

export enum MealsTypeEnum {
  FISH = 'FISH',
  RED_MEAT = 'RED_MEAT',
  VARIED = 'VARIED',
  VEGAN = 'VEGAN',
  VEGETARIAN = 'VEGETARIAN',
  WHITE_MEAT = 'WHITE_MEAT'
}

export type MiceFuturePaymentFilterInputDto = {
  companiesId?: InputMaybe<Array<Scalars['String']>>;
};

export type MiceFuturePaymentInputDto = {
  filters?: InputMaybe<MiceFuturePaymentFilterInputDto>;
  paginationArgsBackward?: InputMaybe<BackwardPaginationInputDto>;
  paginationArgsForward?: InputMaybe<ForwardPaginationInputDto>;
};

export type MicePassedPaymentFilterDateInputDto = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};

export type MicePassedPaymentFilterInputDto = {
  companiesId?: InputMaybe<Array<Scalars['String']>>;
  date?: InputMaybe<MicePassedPaymentFilterDateInputDto>;
};

export type MicePassedPaymentInputDto = {
  filters?: InputMaybe<MicePassedPaymentFilterInputDto>;
  paginationArgsBackward?: InputMaybe<BackwardPaginationInputDto>;
  paginationArgsForward?: InputMaybe<ForwardPaginationInputDto>;
};

export type MissingServiceProvisionForMenusOutputDto = {
  __typename?: 'MissingServiceProvisionForMenusOutputDto';
  category?: Maybe<ServiceProviderCategoryEnum>;
  substitutes?: Maybe<Array<MissingServiceProvisionForMenusOutputDto>>;
  travelType: TravelTypeEnum;
  type: ServiceProvisionTypeEnum;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateHostAccount: HostOutputDto;
  addAdvisorConversationMessageAdmin: AdvisorConversationMessageOutputDto;
  addAdvisorConversationMessageApp: AdvisorConversationMessageOutputDto;
  addCompaniesToParentCompany: SuccessResponse;
  addNavigationToSearchQuery: Scalars['Boolean'];
  addProjectAdditionToSearchQuery: Scalars['Boolean'];
  addQueryToSearchSession: AddQueryToSearchSessionOutputDto;
  addSiteResource: SiteResourceOutputDto;
  admin?: Maybe<AdminOutputDto>;
  adminAddICalendarUrls: SuccessResponse;
  adminCanceledAdjustmentsConfirmation: SuccessResponse;
  adminCanceledPostBalanceAdjustmentsConfirmation: SuccessResponse;
  adminCanceledUserConfirmedBooking: SuccessResponse;
  adminCancelledClientRequestBeforeConfirmation: SuccessResponse;
  adminConfirmedHostQuotation: SuccessResponse;
  adminConfirmedPostBalanceAdjustments: SuccessResponse;
  adminKeepICalendarUpToDate: SuccessResponse;
  adminSkippedAdjustments: SuccessResponse;
  adminSkippedBalancePayment: SuccessResponse;
  adminSkippedDepositPayment: SuccessResponse;
  adminUpdateHouseCorporateEvening: SuccessResponse;
  adminUpdateHouseNightlyTrip: SuccessResponse;
  adminUpdateHouseSeasonalBusynessCalendar: SuccessResponse;
  adminUpdateHouseStudyDay: SuccessResponse;
  adminUpsertHouseAvailability: SuccessResponse;
  adminUpsertManyHouseAvailabilities: SuccessResponse;
  authWithEmail: SuccessResponse;
  cancelBillingTransfer: Scalars['Boolean'];
  cancelBillingTransferApp: SuccessResponse;
  checkAndDeleteTokenOwnerAccess: Scalars['Boolean'];
  createAdmin: Scalars['String'];
  createAdminRole: AdminRoleOutputDto;
  createArticle: Scalars['String'];
  createAutonomousClientProposal: ClientRequestOutputDto;
  createAutonomousClientProposalAdmin: ClientRequestOutputDto;
  createBillingTransferAdmin: BillingTransferOutputDto;
  createBillingTransferApp: BillingTransferOutputDto;
  createBillingTransferPayments: Array<PaymentBillingTransferOutputDto>;
  createBlacklistedEmail: SuccessResponse;
  createClientProposal: Scalars['String'];
  createClientProposalAndUpdateClientPricingItems: Scalars['Boolean'];
  createClientProposalClientPricingItemAdmin: ClientPricingItemOutputDto;
  createClientRequestAdmin: Scalars['String'];
  createClientRequestAnonymousVisitedLog: CreateLogResponse;
  createClientRequestPurchaseOrderUrl: SuccessResponse;
  createCompanyAdmin: Scalars['String'];
  createCustomHouseFAQ?: Maybe<SuccessResponse>;
  createDefaultHouseFAQ?: Maybe<SuccessResponse>;
  createHouseAdmin: Scalars['String'];
  createHouseOwnerPassword: SuccessResponse;
  createHouseWorkspace: HouseWorkspaceOutputDto;
  createNewEquipment: EquipmentOutputDto;
  createNewTag: TagOutputDto;
  createOrUpdatePaymentsByAdmin: Scalars['Boolean'];
  createOwnerAdmin: CreateHouseOwnerOutputDto;
  createServiceOwner: ServiceOwnerOutputDto;
  createServiceProviderAdmin: Scalars['String'];
  createServiceProviderPictures: Array<ServiceProviderPictureOutputDto>;
  createServiceProvisionsAdmin: Scalars['Boolean'];
  createTokenOwnerAccess: Scalars['String'];
  createUserAdmin: Scalars['String'];
  createUserLog: CreateLogResponse;
  deleteAdmin: SuccessResponse;
  deleteAdminRole: SuccessResponse;
  deleteAdvisorConversationMessageAdmin: AdvisorConversationMessageOutputDto;
  deleteAdvisorConversationMessageApp: AdvisorConversationMessageOutputDto;
  deleteArticle: Scalars['Boolean'];
  deleteBillingTransfer: Scalars['Boolean'];
  deleteBillingTransferPayments: SuccessResponse;
  deleteBlacklistedEmail: SuccessResponse;
  deleteClientPricingItemAdmin: Scalars['Boolean'];
  deleteClientProposal: SuccessResponse;
  deleteClientRequestAdmin: SuccessResponse;
  deleteCompaniesFromParentCompany: SuccessResponse;
  deleteCompanyAdmin: Scalars['Boolean'];
  deleteCustomHouseFAQ?: Maybe<Array<Scalars['String']>>;
  deleteDefaultHouseFAQ?: Maybe<Array<Scalars['String']>>;
  deleteEquipment: SuccessResponse;
  deleteHouse: SuccessResponse;
  deleteHouseBedroomAdmin: Scalars['Boolean'];
  deleteHouseWorkspace: Scalars['Boolean'];
  deleteMarketplace: SuccessResponse;
  deleteOwnerAdmin: Scalars['Boolean'];
  deletePayment: SuccessResponse;
  deletePurchaseOrderUrl: SuccessResponse;
  deleteServiceOwner: Scalars['Boolean'];
  deleteServiceProviderAdmin: Scalars['Boolean'];
  deleteServiceProvisionAdmin: Scalars['Boolean'];
  deleteSiteResource: SiteResourceOutputDto;
  deleteTag: SuccessResponse;
  deleteUserAdmin: Scalars['Boolean'];
  deployCustomDomain: DeployCustomDomainOutputDto;
  finalizeAccount?: Maybe<UserOutputDto>;
  forgotPasswordAdmin: Scalars['Boolean'];
  forgotPasswordHost: Scalars['Boolean'];
  forgotPasswordHouseOwner: Scalars['Boolean'];
  forgotPasswordUser: Scalars['Boolean'];
  generateClientRequestDocuments: Array<PdfOutputDto>;
  getAuthorizationAzureUrl: Scalars['String'];
  getAuthorizationGoogleUrl: Scalars['String'];
  /** @deprecated old authentication system */
  getMeAdmin: AdminOutputDto;
  getPdfsByClientRequestId: Array<PdfOutputDto>;
  handleBalancePayment: Scalars['String'];
  handleBalancePostFinalPayment: Scalars['String'];
  handleDepositPayment: Scalars['String'];
  importJabbaHouse: SuccessReponseJabbaImport;
  logInAdmin: AdminOutputDto;
  loginHost: HostOutputDto;
  loginOwner: HouseOwnerOutputDto;
  loginOwnerByToken: LoginOwnerByTokenOutputDto;
  loginUser: UserOutputDto;
  logoutAdmin: ResponseLogout;
  logoutHost: ResponseLogout;
  logoutHouseOwner: ResponseLogout;
  logoutMiceUser: ResponseLogout;
  logoutUser: ResponseLogout;
  markAllAdvisorMessagesAsRead: Array<Scalars['String']>;
  markAsReadClientProposalsByClientRequestId: Scalars['Int'];
  owner?: Maybe<HouseOwnerOutputDto>;
  ownerAddICalendarUrls: SuccessResponse;
  ownerAskedAdjustmentsModification: SuccessResponse;
  ownerCanceledQuoteProvisionSuppression: SuccessResponse;
  ownerConfirmedAdjustments: Array<PdfTypeEnum>;
  ownerConfirmedBooking: Array<PdfTypeEnum>;
  ownerConfirmedQuotation: SuccessResponse;
  ownerCreatedQuoteProvision: SuccessResponse;
  ownerDeclinedBooking: SuccessResponse;
  ownerDeclinedQuotation: SuccessResponse;
  ownerDeletedQuoteProvision: SuccessResponse;
  ownerExtractQuoteItemsFromPdf: SuccessResponse;
  ownerKeepICalendarUpToDate: SuccessResponse;
  ownerUpdateHouseCorporateEvening: SuccessResponse;
  ownerUpdateHouseNightlyTrip: SuccessResponse;
  ownerUpdateHouseSeasonalBusynessCalendar: SuccessResponse;
  ownerUpdateHouseStudyDay: SuccessResponse;
  ownerUpdatedQuoteProvision: SuccessResponse;
  ownerUpdatedQuoteProvisionsPositions: SuccessResponse;
  ownerUploadedQuotation: SuccessResponse;
  ownerUpsertHouseAvailability: SuccessResponse;
  ownerUpsertManyHouseAvailabilities: SuccessResponse;
  regenerateAuthenticateToken: SuccessResponse;
  removeServiceOwnerOfServiceProvider: Scalars['Boolean'];
  requestNewEmailVerificationCode: SuccessResponse;
  resetHostPassword: HostOutputDto;
  resetPasswordAdmin: EmailPayload;
  resetPasswordHouseOwner: EmailPayload;
  resetPasswordUser: EmailPayload;
  seedDb: SeedingOutputDto;
  sendEmailInvitation: HouseOwnerOutputDto;
  sendSearchSessionSlackNotification: SendSearchSessionSlackNotificationOutputDto;
  setClientCarbonFootprint: ClientProposalOutputDto;
  setClientProposalVote: ClientProposalOutputDto;
  setUserFeatureFlag: UserOutputDto;
  subscribeUser: SuccessResponse;
  successClientRequestPayment: Scalars['Boolean'];
  updateAdmin: Scalars['String'];
  updateAdminHeader: SuccessResponse;
  updateAdminRole: AdminRoleOutputDto;
  updateArticle: Scalars['Boolean'];
  updateBillingTransferHeader: BillingTransferOutputDto;
  updateBillingTransferInformation: BillingTransferOutputDto;
  updateBillingTransferPayments: Array<PaymentBillingTransferOutputDto>;
  updateClientPricingItemById: SuccessResponse;
  updateClientProposalById: Scalars['String'];
  updateClientProposalDates: SuccessResponse;
  updateClientProposalPosition: Scalars['Boolean'];
  updateClientRequestBriefAdmin: Scalars['Boolean'];
  updateClientRequestHeaderAdmin: ClientRequestOutputDto;
  updateClientRequestReview: ClientRequestReviewDto;
  updateClientRequestSettingsAdmin: SuccessResponse;
  updateCompanyInformationsAdmin: Scalars['Boolean'];
  updateCompanySettings: CompanyOutputDto;
  updateCompanyTravelPolicies: Scalars['Boolean'];
  updateCustomHouseFAQ?: Maybe<Array<Scalars['String']>>;
  updateDefaultHouseFAQ?: Maybe<Array<Scalars['String']>>;
  updateEditorial: SiteEditorialOutputDto;
  updateEquipment: EquipmentOutputDto;
  updateHostLocale: HostOutputDto;
  updateHouseBedroomsAdmin: Array<HouseBedroomContext>;
  updateHouseCertificationAdmin: Scalars['Boolean'];
  updateHouseDescriptionAdmin: Scalars['Boolean'];
  updateHouseEquipmentsAdmin: Scalars['Boolean'];
  updateHouseHeaderAdmin: HouseContext;
  updateHouseNumberOfWorkspaces: Scalars['Float'];
  updateHousePictures: Array<HousePictureByType>;
  updateHouseScreenshots: Array<HousePictureContext>;
  updateHouseServicesByHouseIdAdmin: Scalars['Boolean'];
  updateHouseWorkspace: HouseWorkspaceOutputDto;
  updateLinkedHousesServiceAdmin: Scalars['Boolean'];
  updateMarketplace: SuccessResponse;
  updateMarketplaceStatus: SuccessResponse;
  updateOwnerHeaderAdmin: HouseOwnerOutputDto;
  updateOwnerInformationsAdmin: HouseOwnerOutputDto;
  updateSearchQueryResultIds: Scalars['Boolean'];
  updateServiceOwner: ServiceOwnerOutputDto;
  updateServiceOwnerOfServiceProviders: Scalars['Boolean'];
  updateServiceProviderDescriptionAdmin: ServiceProviderOutputDto;
  updateServiceProviderHeaderAdmin: ServiceProviderOutputDto;
  updateServiceProviderInformationsAdmin: ServiceProviderOutputDto;
  updateSiteResource: SiteResourceOutputDto;
  updateTag: TagOutputDto;
  updateUserDeletedValue: Scalars['Boolean'];
  updateUserInformationsAdmin: UserOutputDto;
  updateUserInformationsUser: UserOutputDto;
  updateUserLocale: UserOutputDto;
  updateUserTravelCity: SuccessResponse;
  user?: Maybe<UserOutputDto>;
  userAdminConfirmedBooking: SuccessResponse;
  userAdminDeclinedBooking: SuccessResponse;
  userAskedQuotation: SuccessResponse;
  userAskedUserAdminApproval: SuccessResponse;
  userConfirmedAdjustments: SuccessResponse;
  userConfirmedBooking: Array<PdfTypeEnum>;
  userDeclinedClientProposal: SuccessResponse;
  validateAccountHouseOwner: EmailPayload;
  verifyUserDigitsCode?: Maybe<UserOutputDto>;
};


export type MutationActivateHostAccountArgs = {
  dto: ValidateAccountDto;
};


export type MutationAddAdvisorConversationMessageAdminArgs = {
  input: AddAdvisorConversationMessageInputDto;
};


export type MutationAddAdvisorConversationMessageAppArgs = {
  input: AddAdvisorConversationMessageInputDto;
};


export type MutationAddCompaniesToParentCompanyArgs = {
  addCompaniesToParent: UpdateCompaniesFromParentCompanyInputDto;
};


export type MutationAddNavigationToSearchQueryArgs = {
  inputs: AddNavigationToSearchQueryInputDto;
};


export type MutationAddProjectAdditionToSearchQueryArgs = {
  inputs: AddProjectAdditionToSearchQueryInputDto;
};


export type MutationAddQueryToSearchSessionArgs = {
  inputs: AddQueryToSearchSessionInputDto;
};


export type MutationAddSiteResourceArgs = {
  resource: PutSiteResourceInputDto;
  siteId: Scalars['String'];
};


export type MutationAdminAddICalendarUrlsArgs = {
  houseId: Scalars['String'];
  inputDto: HouseICalendarUrlsInputDto;
};


export type MutationAdminCanceledAdjustmentsConfirmationArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationAdminCanceledPostBalanceAdjustmentsConfirmationArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationAdminCanceledUserConfirmedBookingArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationAdminCancelledClientRequestBeforeConfirmationArgs = {
  clientRequestId: Scalars['String'];
};


export type MutationAdminConfirmedHostQuotationArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationAdminConfirmedPostBalanceAdjustmentsArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationAdminKeepICalendarUpToDateArgs = {
  houseId: Scalars['String'];
};


export type MutationAdminSkippedAdjustmentsArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationAdminSkippedBalancePaymentArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationAdminSkippedDepositPaymentArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationAdminUpdateHouseCorporateEveningArgs = {
  dto: HouseCorporateEveningDto;
  houseId: Scalars['String'];
};


export type MutationAdminUpdateHouseNightlyTripArgs = {
  dto: HouseNightlyTripDto;
  houseId: Scalars['String'];
};


export type MutationAdminUpdateHouseSeasonalBusynessCalendarArgs = {
  dto: Array<HouseSeasonalBusynessCalendarDto>;
  houseId: Scalars['String'];
};


export type MutationAdminUpdateHouseStudyDayArgs = {
  dto: HouseStudyDayDto;
  houseId: Scalars['String'];
};


export type MutationAdminUpsertHouseAvailabilityArgs = {
  houseId: Scalars['String'];
  inputDto: HouseAvailabilityGlobalOrIndividualDto;
};


export type MutationAdminUpsertManyHouseAvailabilitiesArgs = {
  houseId: Scalars['String'];
  inputDtos: HouseAvailabilityGlobalOrIndividualManyDto;
};


export type MutationAuthWithEmailArgs = {
  email: Scalars['String'];
  fullUrl?: InputMaybe<Scalars['String']>;
  gclid?: InputMaybe<Scalars['String']>;
};


export type MutationCancelBillingTransferArgs = {
  billingTransferId: Scalars['String'];
  nabooCancelDocument?: InputMaybe<DocumentInputDto>;
};


export type MutationCancelBillingTransferAppArgs = {
  billingTransferId: Scalars['String'];
};


export type MutationCheckAndDeleteTokenOwnerAccessArgs = {
  token: Scalars['String'];
};


export type MutationCreateAdminArgs = {
  dto: CreateAdminInputDto;
};


export type MutationCreateAdminRoleArgs = {
  dto: AdminRoleInputDto;
};


export type MutationCreateArticleArgs = {
  articleDto: CreateArticleInputDto;
};


export type MutationCreateAutonomousClientProposalArgs = {
  dto: CreateAutonomousClientProposalInputDto;
};


export type MutationCreateAutonomousClientProposalAdminArgs = {
  dto: CreateAutonomousClientProposalInputDto;
};


export type MutationCreateBillingTransferAdminArgs = {
  createAdminBillingTransferDto: CreateBillingTransferAdminInputDto;
};


export type MutationCreateBillingTransferAppArgs = {
  createBillingTransferAppDto: CreateBillingTransferAppInputDto;
};


export type MutationCreateBillingTransferPaymentsArgs = {
  billingTransferId: Scalars['String'];
  dtos: Array<CreateBillingTransferPaymentInputDto>;
};


export type MutationCreateBlacklistedEmailArgs = {
  dto: CreateBlacklistedEmailInputDto;
};


export type MutationCreateClientProposalArgs = {
  inputs: CreateProposalInputDto;
};


export type MutationCreateClientProposalAndUpdateClientPricingItemsArgs = {
  inputs: CreateClientProposalAndUpdateClientPricingItemsInputDto;
};


export type MutationCreateClientProposalClientPricingItemAdminArgs = {
  clientProposalId: Scalars['String'];
  newClientPricingItemsInputDto: ClientPricingItemInputDto;
};


export type MutationCreateClientRequestAdminArgs = {
  createClientRequestDto: CreateClientRequestInputDto;
};


export type MutationCreateClientRequestAnonymousVisitedLogArgs = {
  clientRequestAnonymousVisitedLogDto: ClientRequestAnonymousVisitedLogDto;
};


export type MutationCreateClientRequestPurchaseOrderUrlArgs = {
  createClientRequestPurchaseOrderUrlData: CreateClientRequestPurchaseOrderUrlInputDto;
};


export type MutationCreateCompanyAdminArgs = {
  createCompanyAdminDto: CreateCompanyAdminInputDto;
};


export type MutationCreateCustomHouseFaqArgs = {
  dto: Array<CreateCustomHouseFaqInputDto>;
  houseId: Scalars['String'];
};


export type MutationCreateDefaultHouseFaqArgs = {
  dto: Array<CreateDefaultHouseFaqInputDto>;
  houseId: Scalars['String'];
};


export type MutationCreateHouseAdminArgs = {
  createHouseData: CreateHouseAdminDto;
};


export type MutationCreateHouseOwnerPasswordArgs = {
  dto: CreatePasswordInputDto;
};


export type MutationCreateHouseWorkspaceArgs = {
  houseId: Scalars['String'];
  workspace: HouseWorkspaceInputDto;
};


export type MutationCreateNewEquipmentArgs = {
  dto: CreateEquipmentInputDto;
};


export type MutationCreateNewTagArgs = {
  dto: CreateTagInputDto;
};


export type MutationCreateOrUpdatePaymentsByAdminArgs = {
  clientRequestId: Scalars['String'];
  createOrUpdatePaymentInputDto: Array<CreateOrUpdatePaymentInputDto>;
};


export type MutationCreateOwnerAdminArgs = {
  createOwnerAdminDto: CreateOwnerAdminInputDto;
};


export type MutationCreateServiceOwnerArgs = {
  dto: CreateServiceOwnerInputDto;
};


export type MutationCreateServiceProviderAdminArgs = {
  createServiceProviderAdminDto: CreateServiceProviderAdminInputDto;
};


export type MutationCreateServiceProviderPicturesArgs = {
  picturesDto: Array<CreateServiceProviderPictureInputDto>;
  serviceProviderId: Scalars['String'];
};


export type MutationCreateServiceProvisionsAdminArgs = {
  dto: ServiceProvisionAdminInputDto;
};


export type MutationCreateUserAdminArgs = {
  createUserAdminDto: CreateUserAdminInputDto;
};


export type MutationCreateUserLogArgs = {
  parentId?: InputMaybe<Scalars['String']>;
  userLogDto: UserLogDto;
};


export type MutationDeleteAdminArgs = {
  adminId: Scalars['String'];
};


export type MutationDeleteAdminRoleArgs = {
  adminRoleId: Scalars['String'];
};


export type MutationDeleteAdvisorConversationMessageAdminArgs = {
  input: DeleteAdvisorConversationMessageInputDto;
};


export type MutationDeleteAdvisorConversationMessageAppArgs = {
  input: DeleteAdvisorConversationMessageInputDto;
};


export type MutationDeleteArticleArgs = {
  articleId: Scalars['String'];
};


export type MutationDeleteBillingTransferArgs = {
  billingTransferId: Scalars['String'];
};


export type MutationDeleteBillingTransferPaymentsArgs = {
  paymentIds: Array<Scalars['String']>;
};


export type MutationDeleteBlacklistedEmailArgs = {
  dto: DeleteBlacklistedEmailInputDto;
};


export type MutationDeleteClientPricingItemAdminArgs = {
  clientPricingItemId: Scalars['String'];
};


export type MutationDeleteClientProposalArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationDeleteClientRequestAdminArgs = {
  clientRequestId: Scalars['String'];
};


export type MutationDeleteCompaniesFromParentCompanyArgs = {
  deleteCompaniesFromParentCompany: UpdateCompaniesFromParentCompanyInputDto;
};


export type MutationDeleteCompanyAdminArgs = {
  companyId: Scalars['String'];
};


export type MutationDeleteCustomHouseFaqArgs = {
  faqIds: Array<Scalars['String']>;
  houseId: Scalars['String'];
};


export type MutationDeleteDefaultHouseFaqArgs = {
  faqIds: Array<Scalars['String']>;
  houseId: Scalars['String'];
};


export type MutationDeleteEquipmentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteHouseArgs = {
  houseId: Scalars['String'];
};


export type MutationDeleteHouseBedroomAdminArgs = {
  dto: Scalars['String'];
  houseId: Scalars['String'];
};


export type MutationDeleteHouseWorkspaceArgs = {
  workspaceId: Scalars['String'];
};


export type MutationDeleteMarketplaceArgs = {
  marketplaceId: Scalars['String'];
};


export type MutationDeleteOwnerAdminArgs = {
  ownerId: Scalars['String'];
};


export type MutationDeletePaymentArgs = {
  paymentId: Scalars['String'];
};


export type MutationDeletePurchaseOrderUrlArgs = {
  clientRequestId: Scalars['String'];
};


export type MutationDeleteServiceOwnerArgs = {
  id: Scalars['String'];
};


export type MutationDeleteServiceProviderAdminArgs = {
  serviceProviderId: Scalars['String'];
};


export type MutationDeleteServiceProvisionAdminArgs = {
  serviceProvisionId: Scalars['String'];
};


export type MutationDeleteSiteResourceArgs = {
  resourceId: Scalars['String'];
  siteId: Scalars['String'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserAdminArgs = {
  userId: Scalars['String'];
};


export type MutationDeployCustomDomainArgs = {
  inputs: DeployCustomDomainInputDto;
};


export type MutationFinalizeAccountArgs = {
  finalizeAccountDto: FinalizeAccountInputDto;
};


export type MutationForgotPasswordAdminArgs = {
  dto: ForgotPasswordDto;
};


export type MutationForgotPasswordHostArgs = {
  dto: ForgotPasswordDto;
};


export type MutationForgotPasswordHouseOwnerArgs = {
  dto: ForgotPasswordDto;
};


export type MutationForgotPasswordUserArgs = {
  dto: ForgotPasswordDto;
};


export type MutationGenerateClientRequestDocumentsArgs = {
  clientProposalId?: InputMaybe<Scalars['String']>;
  clientRequestId: Scalars['String'];
  pdfs: Array<PdfTypeEnum>;
};


export type MutationGetPdfsByClientRequestIdArgs = {
  clientProposalId?: InputMaybe<Scalars['String']>;
  clientRequestId: Scalars['String'];
  pdfTypes: Array<PdfTypeEnum>;
  regenerate?: InputMaybe<Scalars['Boolean']>;
};


export type MutationHandleBalancePaymentArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationHandleBalancePostFinalPaymentArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationHandleDepositPaymentArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationImportJabbaHouseArgs = {
  importData: Scalars['String'];
};


export type MutationLogInAdminArgs = {
  inputs: AuthDto;
};


export type MutationLoginHostArgs = {
  inputs: AuthDto;
};


export type MutationLoginOwnerArgs = {
  inputs: AuthDto;
};


export type MutationLoginOwnerByTokenArgs = {
  token: Scalars['String'];
};


export type MutationLoginUserArgs = {
  inputs: AuthDto;
};


export type MutationMarkAllAdvisorMessagesAsReadArgs = {
  input: MarkAllMessagesAsReadInputDto;
};


export type MutationMarkAsReadClientProposalsByClientRequestIdArgs = {
  clientRequestId: Scalars['String'];
};


export type MutationOwnerAddICalendarUrlsArgs = {
  houseId: Scalars['String'];
  inputDto: HouseICalendarUrlsInputDto;
};


export type MutationOwnerAskedAdjustmentsModificationArgs = {
  clientProposalId: Scalars['String'];
  message: Scalars['String'];
};


export type MutationOwnerCanceledQuoteProvisionSuppressionArgs = {
  clientPricingItemId: Scalars['String'];
  clientProposalId: Scalars['String'];
};


export type MutationOwnerConfirmedAdjustmentsArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationOwnerConfirmedBookingArgs = {
  clientProposalId: Scalars['String'];
  depositRate: Scalars['Float'];
};


export type MutationOwnerConfirmedQuotationArgs = {
  clientProposalId: Scalars['String'];
  ownerConfirmedQuotationInputs: ClientProposalOwnerConfirmedQuotationInputDto;
};


export type MutationOwnerCreatedQuoteProvisionArgs = {
  clientProposalId: Scalars['String'];
  quoteProvisionInputs: ClientProposalCreateQuoteProvisionInputDto;
};


export type MutationOwnerDeclinedBookingArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationOwnerDeclinedQuotationArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationOwnerDeletedQuoteProvisionArgs = {
  clientPricingItemId: Scalars['String'];
  clientProposalId: Scalars['String'];
};


export type MutationOwnerExtractQuoteItemsFromPdfArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationOwnerKeepICalendarUpToDateArgs = {
  houseId: Scalars['String'];
};


export type MutationOwnerUpdateHouseCorporateEveningArgs = {
  dto: HouseCorporateEveningDto;
  houseId: Scalars['String'];
};


export type MutationOwnerUpdateHouseNightlyTripArgs = {
  dto: HouseNightlyTripDto;
  houseId: Scalars['String'];
};


export type MutationOwnerUpdateHouseSeasonalBusynessCalendarArgs = {
  dto: Array<HouseSeasonalBusynessCalendarDto>;
  houseId: Scalars['String'];
};


export type MutationOwnerUpdateHouseStudyDayArgs = {
  dto: HouseStudyDayDto;
  houseId: Scalars['String'];
};


export type MutationOwnerUpdatedQuoteProvisionArgs = {
  clientProposalId: Scalars['String'];
  quoteProvisionInputs: ClientProposalUpdateQuoteProvisionInputDto;
};


export type MutationOwnerUpdatedQuoteProvisionsPositionsArgs = {
  clientPricingItemsIds: Array<Scalars['String']>;
  clientProposalId: Scalars['String'];
};


export type MutationOwnerUploadedQuotationArgs = {
  clientProposalId: Scalars['String'];
  ownerUploadedQuotationInputs: ClientProposalOwnerUploadedQuotationInputDto;
};


export type MutationOwnerUpsertHouseAvailabilityArgs = {
  houseId: Scalars['String'];
  inputDto: HouseAvailabilityGlobalOrIndividualDto;
};


export type MutationOwnerUpsertManyHouseAvailabilitiesArgs = {
  houseId: Scalars['String'];
  inputDtos: HouseAvailabilityGlobalOrIndividualManyDto;
};


export type MutationRegenerateAuthenticateTokenArgs = {
  url: Scalars['String'];
};


export type MutationRemoveServiceOwnerOfServiceProviderArgs = {
  serviceProviderId: Scalars['String'];
};


export type MutationRequestNewEmailVerificationCodeArgs = {
  domain?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};


export type MutationResetHostPasswordArgs = {
  dto: ResetHostPasswordDto;
};


export type MutationResetPasswordAdminArgs = {
  dto: ResetPasswordDto;
};


export type MutationResetPasswordHouseOwnerArgs = {
  dto: ResetPasswordDto;
};


export type MutationResetPasswordUserArgs = {
  dto: ResetPasswordDto;
};


export type MutationSeedDbArgs = {
  inputs?: InputMaybe<SeedingInputDto>;
};


export type MutationSendEmailInvitationArgs = {
  ownerId: Scalars['String'];
};


export type MutationSendSearchSessionSlackNotificationArgs = {
  inputs: SearchSessionSlackInputDto;
};


export type MutationSetClientCarbonFootprintArgs = {
  clientCarbonFootprintInputDto: ClientCarbonFootprintInputDto;
  clientProposalId: Scalars['String'];
};


export type MutationSetClientProposalVoteArgs = {
  input: SetClientProposalVoteInputDto;
};


export type MutationSetUserFeatureFlagArgs = {
  input: SetUserFeatureFlagInputDto;
};


export type MutationSubscribeUserArgs = {
  inputs: AuthRegistrationDto;
};


export type MutationSuccessClientRequestPaymentArgs = {
  inputs: PaymentSuccessInputDto;
};


export type MutationUpdateAdminArgs = {
  adminId: Scalars['String'];
  dto: UpdateAdminInputDto;
};


export type MutationUpdateAdminHeaderArgs = {
  updateAdminHeaderDto: UpdateAdminHeaderInputDto;
};


export type MutationUpdateAdminRoleArgs = {
  adminRoleId: Scalars['String'];
  dto: AdminRoleInputDto;
};


export type MutationUpdateArticleArgs = {
  articleDto: UpdateArticleInputDto;
  articleId: Scalars['String'];
};


export type MutationUpdateBillingTransferHeaderArgs = {
  billingTransferId: Scalars['String'];
  dto: UpdateBillingTransferHeaderInputDto;
};


export type MutationUpdateBillingTransferInformationArgs = {
  billingTransferId: Scalars['String'];
  dto: UpdateBillingTransferInformationInputDto;
};


export type MutationUpdateBillingTransferPaymentsArgs = {
  dtos: Array<UpdateBillingTransferPaymentInputDto>;
};


export type MutationUpdateClientPricingItemByIdArgs = {
  updatePayload: UpdateClientPricingItemInputDto;
};


export type MutationUpdateClientProposalByIdArgs = {
  clientProposalId: Scalars['String'];
  propaleBookingDto: ClientProposalInputDto;
};


export type MutationUpdateClientProposalDatesArgs = {
  dto: ClientProposalDatesInputDto;
};


export type MutationUpdateClientProposalPositionArgs = {
  input: UpdateClientProposalPositionInputDto;
};


export type MutationUpdateClientRequestBriefAdminArgs = {
  clientRequestId: Scalars['String'];
  updateClientRequestBriefAdminData: UpdateClientRequestBriefAdminInputDto;
};


export type MutationUpdateClientRequestHeaderAdminArgs = {
  clientRequestId: Scalars['String'];
  updateClientRequestData: UpdateClientRequestHeaderAdminInputDto;
};


export type MutationUpdateClientRequestReviewArgs = {
  clientRequestId: Scalars['String'];
  input: ClientRequestReviewInputDto;
};


export type MutationUpdateClientRequestSettingsAdminArgs = {
  clientRequestId: Scalars['String'];
  updateClientRequestSettingsAdminData: UpdateClientRequestSettingsAdminDataInputDto;
};


export type MutationUpdateCompanyInformationsAdminArgs = {
  companyId: Scalars['String'];
  updateCompanyInformations: UpdateCompanyInformationsAdminInputDto;
};


export type MutationUpdateCompanySettingsArgs = {
  dto: UpdateCompanySettingsAdminInputDto;
};


export type MutationUpdateCompanyTravelPoliciesArgs = {
  companyId: Scalars['String'];
  updateCompanyTravelPolicies: UpdateCompanyTravelPoliciesInputDto;
};


export type MutationUpdateCustomHouseFaqArgs = {
  dto: Array<UpdateCustomHouseFaqInputDto>;
  houseId: Scalars['String'];
};


export type MutationUpdateDefaultHouseFaqArgs = {
  dto: Array<UpdateDefaultHouseFaqInputDto>;
  houseId: Scalars['String'];
};


export type MutationUpdateEditorialArgs = {
  inputs: UpdateEditorialInputDto;
  siteId: Scalars['String'];
};


export type MutationUpdateEquipmentArgs = {
  dto: UpdateEquipmentInputDto;
  id: Scalars['String'];
  newPosition?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateHostLocaleArgs = {
  locale: IntlLocales;
};


export type MutationUpdateHouseBedroomsAdminArgs = {
  dto: UpdateBedroomsInfosDto;
  houseId: Scalars['String'];
};


export type MutationUpdateHouseCertificationAdminArgs = {
  houseId: Scalars['String'];
  updateHouseData: UpdateHouseCertificationAdminDto;
};


export type MutationUpdateHouseDescriptionAdminArgs = {
  dto: UpdateHouseDescriptionDto;
};


export type MutationUpdateHouseEquipmentsAdminArgs = {
  dto: Array<CreateHouseEquipmentInputDto>;
  houseId: Scalars['String'];
};


export type MutationUpdateHouseHeaderAdminArgs = {
  houseId: Scalars['String'];
  updateHouseData: UpdateHouseHeaderAdminDto;
};


export type MutationUpdateHouseNumberOfWorkspacesArgs = {
  houseId: Scalars['String'];
  numberOfWorkspaces: Scalars['Int'];
};


export type MutationUpdateHousePicturesArgs = {
  dto: Array<UpdateHousePictureDto>;
  houseId: Scalars['String'];
};


export type MutationUpdateHouseScreenshotsArgs = {
  dto: Array<UpdateHousePictureDto>;
  houseId: Scalars['String'];
};


export type MutationUpdateHouseServicesByHouseIdAdminArgs = {
  dto: UpdateHouseServicesInputDto;
};


export type MutationUpdateHouseWorkspaceArgs = {
  workspace: HouseWorkspaceInputDto;
};


export type MutationUpdateLinkedHousesServiceAdminArgs = {
  dto: UpdateLinkedHousesServiceInputDto;
};


export type MutationUpdateMarketplaceArgs = {
  inputs: UpdateMarketplaceInputDto;
};


export type MutationUpdateMarketplaceStatusArgs = {
  inputs: UpdateMarketplaceStatusInputDto;
};


export type MutationUpdateOwnerHeaderAdminArgs = {
  dto: UpdateOwnerHeaderAdminInputDto;
  ownerId: Scalars['String'];
};


export type MutationUpdateOwnerInformationsAdminArgs = {
  dto: UpdateOwnerInformationsAdminInputDto;
  ownerId: Scalars['String'];
};


export type MutationUpdateSearchQueryResultIdsArgs = {
  inputs: UpdateQueryResultIdsInputDto;
};


export type MutationUpdateServiceOwnerArgs = {
  dto: UpdateServiceOwnerDto;
  id: Scalars['String'];
};


export type MutationUpdateServiceOwnerOfServiceProvidersArgs = {
  serviceOwnerId: Scalars['String'];
  serviceProviderIds: Array<Scalars['String']>;
};


export type MutationUpdateServiceProviderDescriptionAdminArgs = {
  dto: UpdateServiceProviderDescriptionAdminInputDto;
  serviceProviderId: Scalars['String'];
};


export type MutationUpdateServiceProviderHeaderAdminArgs = {
  dto: UpdateServiceProviderHeaderAdminInputDto;
  serviceProviderId: Scalars['String'];
};


export type MutationUpdateServiceProviderInformationsAdminArgs = {
  dto: UpdateServiceProviderInformationsAdminInputDto;
  serviceProviderId: Scalars['String'];
};


export type MutationUpdateSiteResourceArgs = {
  resource: PutSiteResourceInputDto;
  resourceId: Scalars['String'];
  siteId: Scalars['String'];
};


export type MutationUpdateTagArgs = {
  dto: UpdateTagInputDto;
  id: Scalars['String'];
  newPosition?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateUserDeletedValueArgs = {
  deleted: Scalars['Boolean'];
  userId: Scalars['String'];
};


export type MutationUpdateUserInformationsAdminArgs = {
  updateUserInformations: UpdateUserInformationsAdminDto;
  userId: Scalars['String'];
};


export type MutationUpdateUserInformationsUserArgs = {
  updateUserInformations: UpdateUserInformationsUserInputDto;
};


export type MutationUpdateUserLocaleArgs = {
  locale: IntlLocales;
};


export type MutationUpdateUserTravelCityArgs = {
  input: FilterLocationDto;
};


export type MutationUserAdminConfirmedBookingArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationUserAdminDeclinedBookingArgs = {
  clientProposalId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
};


export type MutationUserAskedQuotationArgs = {
  clientProposalId: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type MutationUserAskedUserAdminApprovalArgs = {
  clientProposalId: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
};


export type MutationUserConfirmedAdjustmentsArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationUserConfirmedBookingArgs = {
  clientProposalId: Scalars['String'];
};


export type MutationUserDeclinedClientProposalArgs = {
  clientProposalId: Scalars['String'];
  userDecliningReason: ClientProposalUserDecliningReasonEnum;
};


export type MutationValidateAccountHouseOwnerArgs = {
  dto: ValidateAccountDto;
};


export type MutationVerifyUserDigitsCodeArgs = {
  digitsVerificationCode: Scalars['String'];
  email: Scalars['String'];
};

export enum MySpaceClientRequestFilterEnum {
  CANCELED = 'CANCELED',
  IN_PROGRESS = 'IN_PROGRESS',
  PASSED = 'PASSED'
}

export type NabooRatingModel = {
  __typename?: 'NabooRatingModel';
  rating: Scalars['Float'];
  ratingsTotal: Scalars['Float'];
};

export type NavigationParamsInputDto = {
  houseId: Scalars['String'];
  indexInResults: Scalars['Float'];
  resultScores?: InputMaybe<ResultScoreSearchSessionInputDto>;
  target: NavigationTargetEnum;
};

/** The target of the navigation. */
export enum NavigationTargetEnum {
  CTA_GET_PROPOSAL = 'CTA_GET_PROPOSAL',
  HOUSE_PAGE = 'HOUSE_PAGE'
}

export type NestedItemObjectDataInputDto = {
  description?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  objectId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  serviceProvisionType?: InputMaybe<ServiceProvisionTypeEnum>;
  type: ClientPricingItemTypeEnum;
  unit?: InputMaybe<ServiceProvisionUnitEnum>;
};

export type NestedItemObjectDataOutputDto = {
  __typename?: 'NestedItemObjectDataOutputDto';
  description?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  objectId?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  serviceProvisionType?: Maybe<ServiceProvisionTypeEnum>;
  type: ClientPricingItemTypeEnum;
  unit?: Maybe<ServiceProvisionUnitEnum>;
};

export type NestedItemsInputDto = {
  dailyType?: InputMaybe<HouseDailyTypeEnum>;
  nightType?: InputMaybe<HouseNightTypeEnum>;
  serviceProvisionsId?: InputMaybe<Array<Scalars['String']>>;
};

export type NestedItemsOutputDto = {
  __typename?: 'NestedItemsOutputDto';
  dailyType?: Maybe<HouseDailyTypeEnum>;
  nightType?: Maybe<HouseNightTypeEnum>;
  serviceProvisionsId?: Maybe<Array<Scalars['String']>>;
};

export enum NetworkTypeEnum {
  FIVE_G = 'FIVE_G',
  FOUR_G = 'FOUR_G',
  WIFI = 'WIFI'
}

export enum NextSeminarEstimationEnum {
  IN_3_MONTHS = 'IN_3_MONTHS',
  IN_6_MONTHS = 'IN_6_MONTHS',
  IN_12_MONTHS = 'IN_12_MONTHS',
  NO_PLAN = 'NO_PLAN'
}

export type NotConfirmedClientRequestsInputDto = {
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ClientRequestStatusEnum>;
};

export type NumberOfBedroomsInputDto = {
  bedroomsMax?: InputMaybe<Scalars['Int']>;
  bedroomsMin?: InputMaybe<Scalars['Int']>;
};

export enum OperatorEnum {
  BOUYGUES = 'BOUYGUES',
  FREE = 'FREE',
  ORANGE = 'ORANGE',
  OTHER = 'OTHER',
  SFR = 'SFR'
}

export enum OwnerSpaceModeEnum {
  FULL = 'FULL',
  LIGHT = 'LIGHT',
  PREVIEW = 'PREVIEW'
}

export enum Payment_Stripe_Status {
  CANCELED = 'CANCELED',
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  REFUND = 'REFUND',
  REQUIRES_CAPTURE = 'REQUIRES_CAPTURE',
  SUCCEEDED = 'SUCCEEDED'
}

export enum Payment_Type {
  BALANCE = 'BALANCE',
  BALANCE_POST_FINAL = 'BALANCE_POST_FINAL',
  CANCELLATION = 'CANCELLATION',
  CUSTOM = 'CUSTOM',
  DEPOSIT = 'DEPOSIT'
}

export type PaginatedBillingTransfer = {
  __typename?: 'PaginatedBillingTransfer';
  edges?: Maybe<Array<BillingTransferOutputDtoEdge>>;
  nodes?: Maybe<Array<BillingTransferOutputDto>>;
  pageInfo?: Maybe<BillingTransferOutputDtoPageInfo>;
  totalCount: Scalars['Int'];
};

export type PaginatedClientRequest = {
  __typename?: 'PaginatedClientRequest';
  edges?: Maybe<Array<ClientRequestOutputDtoEdge>>;
  nodes?: Maybe<Array<ClientRequestOutputDto>>;
  pageInfo?: Maybe<ClientRequestOutputDtoPageInfo>;
  totalCount: Scalars['Int'];
};

export type PaginatedHouseOwner = {
  __typename?: 'PaginatedHouseOwner';
  edges?: Maybe<Array<HouseOwnerOutputDtoEdge>>;
  nodes?: Maybe<Array<HouseOwnerOutputDto>>;
  pageInfo?: Maybe<HouseOwnerOutputDtoPageInfo>;
  totalCount: Scalars['Int'];
};

export type PaginatedPayment = {
  __typename?: 'PaginatedPayment';
  edges?: Maybe<Array<PaymentOutputDtoEdge>>;
  nodes?: Maybe<Array<PaymentOutputDto>>;
  pageInfo?: Maybe<PaymentOutputDtoPageInfo>;
  totalCount: Scalars['Int'];
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  edges?: Maybe<Array<UserOutputDtoEdge>>;
  nodes?: Maybe<Array<UserOutputDto>>;
  pageInfo?: Maybe<UserOutputDtoPageInfo>;
  totalCount: Scalars['Int'];
};

export type PaginationDto = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
};

export type ParentCompaniesResearchInputDto = {
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
};

export type PaymentBillingTransferOutputDto = {
  __typename?: 'PaymentBillingTransferOutputDto';
  _id: Scalars['ID'];
  billingTransferId: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  effectivePayment?: Maybe<Scalars['Float']>;
  stripeStatus?: Maybe<Payment_Stripe_Status>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PaymentOutputDto = {
  __typename?: 'PaymentOutputDto';
  _id: Scalars['ID'];
  checkoutSessionId?: Maybe<Scalars['String']>;
  clientRequest?: Maybe<ClientRequestOutputDto>;
  clientRequestId?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  effectivePayment?: Maybe<Scalars['Float']>;
  paymentIntent?: Maybe<Scalars['String']>;
  stripeStatus?: Maybe<Payment_Stripe_Status>;
  type: Payment_Type;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type PaymentOutputDtoEdge = {
  __typename?: 'PaymentOutputDtoEdge';
  cursor: Scalars['String'];
  node: PaymentOutputDto;
};

export type PaymentOutputDtoPageInfo = {
  __typename?: 'PaymentOutputDtoPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PaymentSuccessInputDto = {
  bookingId?: InputMaybe<Scalars['String']>;
  clientRequestId?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
};

export type PdfOutputDto = {
  __typename?: 'PdfOutputDto';
  filename: Scalars['String'];
  pdfType?: Maybe<PdfTypeEnum>;
  url?: Maybe<Scalars['String']>;
};

export enum PdfTypeEnum {
  OWNER_BILLING = 'OWNER_BILLING',
  OWNER_BILLING_BEFORE_30_DAYS = 'OWNER_BILLING_BEFORE_30_DAYS',
  OWNER_BILLING_POST_BOOKING = 'OWNER_BILLING_POST_BOOKING',
  OWNER_COMMISSION_BILLING = 'OWNER_COMMISSION_BILLING',
  OWNER_COMMISSION_BILLING_BEFORE_30_DAYS = 'OWNER_COMMISSION_BILLING_BEFORE_30_DAYS',
  OWNER_COMMISSION_BILLING_POST_BOOKING = 'OWNER_COMMISSION_BILLING_POST_BOOKING',
  OWNER_MANDATE_CONTRACT_SIGNED = 'OWNER_MANDATE_CONTRACT_SIGNED',
  OWNER_MANDATE_CONTRACT_UNSIGNED = 'OWNER_MANDATE_CONTRACT_UNSIGNED',
  OWNER_QUOTATION_ACTUALIZED = 'OWNER_QUOTATION_ACTUALIZED',
  OWNER_QUOTATION_ACTUALIZED_SIGNED = 'OWNER_QUOTATION_ACTUALIZED_SIGNED',
  OWNER_QUOTATION_ADJUSTED = 'OWNER_QUOTATION_ADJUSTED',
  OWNER_QUOTATION_ADJUSTED_VALIDATED = 'OWNER_QUOTATION_ADJUSTED_VALIDATED',
  OWNER_QUOTATION_SIGNED = 'OWNER_QUOTATION_SIGNED',
  OWNER_QUOTATION_UNSIGNED = 'OWNER_QUOTATION_UNSIGNED',
  OWNER_RECEIPT = 'OWNER_RECEIPT',
  OWNER_RECEIPT_BEFORE_30_DAYS = 'OWNER_RECEIPT_BEFORE_30_DAYS',
  OWNER_RECEIPT_POST_BOOKING = 'OWNER_RECEIPT_POST_BOOKING',
  OWNER_SPECIAL_CONDITIONS = 'OWNER_SPECIAL_CONDITIONS',
  SERVICE_OWNER_BILLING_BEFORE_30_DAYS = 'SERVICE_OWNER_BILLING_BEFORE_30_DAYS',
  SERVICE_OWNER_BILLING_POST_BOOKING = 'SERVICE_OWNER_BILLING_POST_BOOKING',
  SERVICE_OWNER_BILLING_TO_BE_ESTABLISHED = 'SERVICE_OWNER_BILLING_TO_BE_ESTABLISHED',
  SERVICE_OWNER_BILLING_TO_BE_ESTABLISHED_CANCELED = 'SERVICE_OWNER_BILLING_TO_BE_ESTABLISHED_CANCELED',
  SERVICE_OWNER_COMMISSION_BILLING_BEFORE_30_DAYS = 'SERVICE_OWNER_COMMISSION_BILLING_BEFORE_30_DAYS',
  SERVICE_OWNER_COMMISSION_BILLING_POST_BOOKING = 'SERVICE_OWNER_COMMISSION_BILLING_POST_BOOKING',
  SERVICE_OWNER_COMMISSION_BILLING_TO_BE_ESTABLISHED = 'SERVICE_OWNER_COMMISSION_BILLING_TO_BE_ESTABLISHED',
  SERVICE_OWNER_COMMISSION_BILLING_TO_BE_ESTABLISHED_CANCELED = 'SERVICE_OWNER_COMMISSION_BILLING_TO_BE_ESTABLISHED_CANCELED',
  SERVICE_OWNER_QUOTATION_ADJUSTED = 'SERVICE_OWNER_QUOTATION_ADJUSTED',
  SERVICE_OWNER_QUOTATION_UNSIGNED = 'SERVICE_OWNER_QUOTATION_UNSIGNED',
  SERVICE_OWNER_RECEIPT_BEFORE_30_DAYS = 'SERVICE_OWNER_RECEIPT_BEFORE_30_DAYS',
  SERVICE_OWNER_RECEIPT_POST_BOOKING = 'SERVICE_OWNER_RECEIPT_POST_BOOKING',
  USER_BILLING = 'USER_BILLING',
  USER_BILLING_BEFORE_30_DAYS = 'USER_BILLING_BEFORE_30_DAYS',
  USER_BILLING_POST_BOOKING = 'USER_BILLING_POST_BOOKING',
  USER_BUSINESS_TRIP_CONDITIONS_SIGNED = 'USER_BUSINESS_TRIP_CONDITIONS_SIGNED',
  USER_BUSINESS_TRIP_CONDITIONS_UNSIGNED = 'USER_BUSINESS_TRIP_CONDITIONS_UNSIGNED',
  USER_PURCHASED_ORDER = 'USER_PURCHASED_ORDER',
  USER_QUOTATION = 'USER_QUOTATION',
  USER_QUOTATION_ACTUALIZED = 'USER_QUOTATION_ACTUALIZED',
  USER_QUOTATION_ACTUALIZED_SIGNED = 'USER_QUOTATION_ACTUALIZED_SIGNED',
  USER_QUOTATION_ADJUSTED = 'USER_QUOTATION_ADJUSTED',
  USER_QUOTATION_ADJUSTED_SIGNED = 'USER_QUOTATION_ADJUSTED_SIGNED',
  USER_QUOTATION_SIGNED = 'USER_QUOTATION_SIGNED'
}

export type PlanningItemsByDate = {
  __typename?: 'PlanningItemsByDate';
  date?: Maybe<Scalars['DateTime']>;
  planningItems: Array<ClientPricingItemPlanningOutputDto>;
};

export type PriceObjectDiscountOutputDto = {
  __typename?: 'PriceObjectDiscountOutputDto';
  basePrice?: Maybe<ComputedPrice>;
  feesByDiscountPrice?: Maybe<ComputedPrice>;
  ownerFeesByDiscountPrice?: Maybe<ComputedPrice>;
};

export type PriceObjectFeesOutputDto = {
  __typename?: 'PriceObjectFeesOutputDto';
  ownerFeesPrice?: Maybe<ComputedPrice>;
  userFeesPrice?: Maybe<ComputedPrice>;
};

export type PriceObjectInputDto = {
  basePrice?: InputMaybe<ComputedPriceDto>;
};

export type PriceObjectOptionFeesInputDto = {
  ownerFeesRate?: InputMaybe<Scalars['Int']>;
  ownerFeesVatRate?: InputMaybe<Scalars['Int']>;
  userFeesRate?: InputMaybe<Scalars['Int']>;
  userFeesVatRate?: InputMaybe<Scalars['Int']>;
};

export type PriceObjectOptionInputDto = {
  discountRate?: InputMaybe<Scalars['Int']>;
  fees?: InputMaybe<PriceObjectOptionFeesInputDto>;
  quantity: Scalars['Float'];
};

export type PriceObjectOutputDto = {
  __typename?: 'PriceObjectOutputDto';
  basePrice?: Maybe<ComputedPrice>;
  discountPrice?: Maybe<PriceObjectDiscountOutputDto>;
  fees?: Maybe<PriceObjectFeesOutputDto>;
  feesRate?: Maybe<PriceOptionFeesOutputDto>;
  feesWithDiscount?: Maybe<PriceObjectFeesOutputDto>;
  marginRate?: Maybe<ComputedPrice>;
  marginWithDiscount?: Maybe<ComputedPrice>;
  priceWithDiscount?: Maybe<ComputedPrice>;
  priceWithDiscountAndFees?: Maybe<ComputedPrice>;
  priceWithDiscountAndOwnerFees?: Maybe<ComputedPrice>;
  priceWithDiscountWithoutOwnerFees?: Maybe<ComputedPrice>;
  priceWithOwnerFees?: Maybe<ComputedPrice>;
  priceWithUserFees?: Maybe<ComputedPrice>;
  vatPrices?: Maybe<Array<ComputedPrice>>;
};

export type PriceOptionFeesOutputDto = {
  __typename?: 'PriceOptionFeesOutputDto';
  ownerFeesRate?: Maybe<Scalars['Int']>;
  ownerFeesVatRate?: Maybe<Scalars['Int']>;
  userFeesRate?: Maybe<Scalars['Int']>;
  userFeesVatRate?: Maybe<Scalars['Int']>;
};

export type PriceOptionOutputDto = {
  __typename?: 'PriceOptionOutputDto';
  discountRate?: Maybe<Scalars['Int']>;
  fees?: Maybe<PriceOptionFeesOutputDto>;
  quantity: Scalars['Float'];
};

export type PricesBeforeOwnerUpdatedQuotationOutputDto = {
  __typename?: 'PricesBeforeOwnerUpdatedQuotationOutputDto';
  totalPrice: PriceObjectOutputDto;
  unitPrice: PriceObjectOutputDto;
};

export enum PrivatizationStatusEnum {
  OPEN = 'OPEN',
  PRIVATIZABLE = 'PRIVATIZABLE',
  PRIVATIZED = 'PRIVATIZED'
}

export type ProjectAdditionParamsInputDto = {
  clientProposalId: Scalars['String'];
  clientRequestId: Scalars['String'];
  houseId: Scalars['String'];
  indexInResults: Scalars['Float'];
  resultScores?: InputMaybe<ResultScoreSearchSessionInputDto>;
};

export type ProposalSettingInputDto = {
  isQuotationConfirmedByAdmin?: InputMaybe<Scalars['Boolean']>;
  privatizationStatusOverride?: InputMaybe<PrivatizationStatusEnum>;
  userFeesVatRateOverride?: InputMaybe<Scalars['Int']>;
};

export enum ProposalStatusEnum {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED'
}

export type PutSiteResourceFileInputDto = {
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type PutSiteResourceInputDto = {
  coverImageUrl: Scalars['String'];
  description: Scalars['String'];
  file: PutSiteResourceFileInputDto;
  title: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  adminGetHouseWithAvailabilities: HouseContext;
  checkMultiVatRatesValidity: Scalars['Boolean'];
  checkTokenOwnerAccess: Scalars['Boolean'];
  countUnreadClientProposalsByUserId: Scalars['Int'];
  generateAndDownloadExport: Scalars['String'];
  getAdminById: AdminOutputDto;
  getAdminByToken: VerifiedToken;
  getAdminContext: AdminOutputDto;
  getAdminHeader: AdminOutputDto;
  getAdminRoles: Array<AdminRoleOutputDto>;
  getAdmins: Array<AdminOutputDto>;
  getAdminsCertificationAdmin: Array<SelectOptionAdmin>;
  getAdvisorConversationClientRequestNotifications: Array<AdvisorConversationNotificationsByClientRequestOutputDto>;
  getAdvisorConversationContactNotifications: Array<AdvisorConversationNotificationsByContactOutputDto>;
  getAllCompanyAndSubsidiariesPassedPayments: Array<PaymentOutputDto>;
  getAllCompanyAndSubsidiariesPendingPayments: Array<ClientRequestOutputDto>;
  getAllDepartments: Array<AddressDepartmentOutputDto>;
  getAllHouses: Array<SiteMap>;
  getArticle: ArticleOuputDto;
  getArticleByPathname: ArticleOuputDto;
  getArticles: Array<ArticleOuputDto>;
  getBedroomsByHouseId: Array<HouseBedroomContext>;
  getBillingTransferById: BillingTransferOutputDto;
  getBillingTransferPayments: Array<PaymentBillingTransferOutputDto>;
  getBillingTransfersAdmin: PaginatedBillingTransfer;
  getBillingTransfersApp: PaginatedBillingTransfer;
  getBlacklistedEmails: Array<BlacklistedEmailOutputDto>;
  getBookingLogs: Array<LogObj>;
  getBookingPrice: BookingPrice;
  getBookingPriceAdmin: BookingPrice;
  getBookingPriceApp: BookingPrice;
  getClientPricingItemById: ClientPricingItemOutputDto;
  getClientProposalById: ClientProposalOutputDto;
  getClientProposalByIdUser: ClientProposalOutputDto;
  getClientProposalsByClientRequestId: Array<ClientProposalOutputDto>;
  getClientProposalsByClientRequestIdUser: Array<ClientProposalOutputDto>;
  getClientRequestBriefContact: ClientRequestContactOutputDto;
  getClientRequestByAdminSalesId: Array<ClientRequestOutputDto>;
  getClientRequestByIdAdmin: ClientRequestOutputDto;
  getClientRequestByIdUser: ClientRequestOutputDto;
  getClientRequestByProposalId: ClientRequestOutputDto;
  getClientRequestFinancePdfTypes: Array<ClientRequestFinanceDocumentOutputDto>;
  getClientRequestLogs: Array<LogObj>;
  getClientRequestReview?: Maybe<ClientRequestReviewDto>;
  getClientRequestsAdmin: Array<ClientRequestOutputDto>;
  getClientRequestsByCompanyId: Array<ClientRequestOutputDto>;
  getClientRequestsByHouseId: Array<ClientRequestOutputDto>;
  getClientRequestsByUser: Array<ClientRequestOutputDto>;
  getClientRequestsVisibleByOwnerByHouseId: Array<ClientRequestOutputDto>;
  getCompaniesAdmin: Array<CompanyOutputDto>;
  getCompanyAndSubsidiariesClientRequestsByCompanyId: Array<ClientRequestOutputDto>;
  getCompanyAndSubsidiariesLatestClientRequests: Array<ClientRequestOutputDto>;
  getCompanyAndSubsidiariesLatestClientRequestsPaginated: PaginatedClientRequest;
  getCompanyAndSubsidiariesPassedPayments: PaginatedPayment;
  getCompanyAndSubsidiariesPendingPayments: PaginatedClientRequest;
  getCompanyById: CompanyOutputDto;
  getDomainExtension: Scalars['String'];
  getEquipmentsList: Array<EquipmentOutputDto>;
  getFinanceByClientRequestId: ClientRequestOutputDto;
  getFinanceClientRequests: Array<FinanceClientRequestDto>;
  getFinanceClientRequestsCount: FinanceClientRequestsCount;
  getHostClientProposalById: ClientProposalOutputDto;
  getHostTokenData: VerifiedToken;
  getHouseAndRestaurationClientPricingMenus?: Maybe<Array<ClientPricingMenuOutputDto>>;
  getHouseBookingsWithHostActionRequired: HouseBookingsWithActionRequiredOutputDto;
  getHouseByIdAdmin: HouseContext;
  getHouseCapacitiesAndBedrooms: HouseCapacitiesAndBedrooms;
  getHouseCertificationAdmin: HouseContext;
  getHouseClientProposals: Array<ClientProposalOutputDto>;
  getHouseClientRequestsReviews?: Maybe<ServiceProviderReviewOutputDto>;
  getHouseContextById: HouseContext;
  getHouseEquipmentsByHouseId: Array<HouseEquipmentOutputDto>;
  getHouseHeaderAdmin: HouseContext;
  getHouseIdByPathname: HouseUrlOutputDto;
  getHouseMenuPrices?: Maybe<Array<HouseMenuPriceOutputDto>>;
  getHouseNumberOfWorkspacesByHouseId: Scalars['Float'];
  getHouseOwnerByToken: VerifiedToken;
  getHouseOwnerClientPricingItems: Array<ClientPricingItemOutputDto>;
  getHouseOwnerContext: HouseOwnerOutputDto;
  getHouseOwnerListPaginated: PaginatedHouseOwner;
  getHousePicturesByHouseId: Array<HousePictureByType>;
  getHouseScreenshotsByHouseId: Array<HousePictureContext>;
  getHouseServiceProvisions: HouseServiceProvisionsOutputDto;
  getHouseServicesByHouseIdAdmin: HouseServicesAdminOutputDto;
  getHouseWorkspacesByHouseId: Array<HouseWorkspaceOutputDto>;
  getHousesByGooglePlaceId: Array<HouseContext>;
  getHousesByIds: Array<HouseContext>;
  getHousesByIdsAdmin: Array<HouseContext>;
  getHousesDataForTravelSuggestion: HouseContext;
  getHousesList: Array<HouseContext>;
  getHousesWithFilters: Array<HouseContext>;
  getLastBookingHouses: Array<HouseContext>;
  getLastParentCompanyContractFromClientProposalIdAdmin?: Maybe<CompanyContractOutputDto>;
  getLastVisitedHouses: Array<LastVisitedHousesOutputDto>;
  getMarketPlaceById: MarketplaceOutputDto;
  getMarketplaces: Array<MarketplaceOutputDto>;
  getMeHost?: Maybe<HostOutputDto>;
  getMeMiceUser?: Maybe<UserOutputDto>;
  getMiceCarbonFootprintClientRequests: Array<ClientRequestOutputDto>;
  getMiceClientRequest: ClientRequestOutputDto;
  getMiceUsers: PaginatedUser;
  getMissingServiceProvisionsForMenusAdmin: Array<MissingServiceProvisionForMenusOutputDto>;
  getMostBookedDepartments: Array<AddressDepartmentOutputDto>;
  getMostBookedHouses: Array<HouseContext>;
  getMyCompanyMice: CompanyOutputDto;
  getMySpaceClientRequests: Array<ClientRequestOutputDto>;
  getNewCompaniesAdmin: Array<CompanyOutputDto>;
  getNotConfirmedClientRequestsByCompanyId: Array<ClientRequestOutputDto>;
  getOwnerHeaderAdmin: HouseOwnerOutputDto;
  getOwnerInformationsAdmin: HouseOwnerOutputDto;
  getOwnerProposalsByClientRequestId: Array<ClientProposalOutputDto>;
  getOwnerStatusAdmin: HouseOwnerOutputDto;
  getOwnersCertificationAdmin: Array<SelectOptionAdmin>;
  getParentCompanies: Array<CompanyOutputDto>;
  getParentCompanyCompanies: Array<CompanyOutputDto>;
  getPaymentsByClientRequestAdmin: Array<PaymentOutputDto>;
  getPdfsByClientProposalId: Array<PdfOutputDto>;
  getPublishedArticles: Array<ArticleOuputDto>;
  getSearchHouse: Array<HouseContext>;
  getSelectableClientPricingItemsByHouseId: Array<ClientPricingItemOutputDto>;
  getServiceOwnerInformationsAdmin: ServiceOwnerOutputDto;
  getServiceOwners: Array<ServiceOwnerOutputDto>;
  getServiceProvider: ServiceProviderOutputDto;
  getServiceProviderAdmin: ServiceProviderOutputDto;
  getServiceProviderClientRequestsReviews?: Maybe<ServiceProviderReviewOutputDto>;
  getServiceProvidersAdmin: Array<ServiceProviderOutputDto>;
  getServiceProvidersByServiceOwner: Array<ServiceProviderOutputDto>;
  getServiceProvidersCountAdmin: Scalars['Float'];
  getServiceProvidersWithoutOwner: Array<ServiceProviderOutputDto>;
  getServiceProvisions: Array<ServiceProvisionOutputDtoUnion>;
  getSimilarArticles: Array<ArticleOuputDto>;
  getSimilarHouses: Array<HouseContext>;
  getSite?: Maybe<SiteOutputDto>;
  getSiteData?: Maybe<SiteOutputDto>;
  getSiteLastEvents?: Maybe<Array<SiteLastEventOutputDto>>;
  getTags: Array<TagOutputDto>;
  getTagsByCategories: Array<TagOutputDto>;
  getTop10SiteDestinations?: Maybe<Array<HouseContext>>;
  getTopActivesOrganizers: Array<TopActivesOrganizersOutputDto>;
  getTravelTimeByHouseId: Array<TravelTimeContext>;
  getUserAdmin: UserOutputDto;
  getUserByToken: VerifiedToken;
  getUserLogs: Array<LogObj>;
  getUsersAdmin: Array<UserOutputDto>;
  getUsersAdminOptions: Array<UserOutputDto>;
  isHouseAvailableForTravelTypeFromTo: Scalars['Boolean'];
  loginHostByToken: HostOutputDto;
  ownerGetHouseWithAvailabilities: HouseContext;
  publicGetHouseAvailabilitiesFromTo: Array<HouseAvailabilityUnionOutputDto>;
  publicTags: Array<TagOutputDto>;
  serviceOwner: ServiceOwnerOutputDto;
  serviceProviderPictures: Array<ServiceProviderPictureOutputDto>;
};


export type QueryAdminGetHouseWithAvailabilitiesArgs = {
  houseId: Scalars['String'];
};


export type QueryCheckMultiVatRatesValidityArgs = {
  clientProposalId: Scalars['String'];
  quoteProvisionInputs: ClientProposalCheckMultiVatRatesValidityInputDto;
};


export type QueryCheckTokenOwnerAccessArgs = {
  token: Scalars['String'];
};


export type QueryGenerateAndDownloadExportArgs = {
  exportType: ExportTypeEnum;
};


export type QueryGetAdminByIdArgs = {
  userId: Scalars['String'];
};


export type QueryGetAdminByTokenArgs = {
  token: Scalars['String'];
};


export type QueryGetAdminHeaderArgs = {
  adminId: Scalars['String'];
};


export type QueryGetAdminsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAdvisorConversationClientRequestNotificationsArgs = {
  input: GetAdvisorConversationClientRequestNotificationsInputDto;
};


export type QueryGetAdvisorConversationContactNotificationsArgs = {
  input: GetAdvisorConversationContactNotificationsInputDto;
};


export type QueryGetAllCompanyAndSubsidiariesPassedPaymentsArgs = {
  filters: MicePassedPaymentFilterInputDto;
};


export type QueryGetAllCompanyAndSubsidiariesPendingPaymentsArgs = {
  filters: MiceFuturePaymentFilterInputDto;
};


export type QueryGetAllDepartmentsArgs = {
  countryCode: Iso3166Alpha2Enum;
};


export type QueryGetArticleArgs = {
  articleId: Scalars['String'];
};


export type QueryGetArticleByPathnameArgs = {
  pathname: Scalars['String'];
};


export type QueryGetBedroomsByHouseIdArgs = {
  houseId: Scalars['String'];
};


export type QueryGetBillingTransferByIdArgs = {
  billingTransferId: Scalars['String'];
};


export type QueryGetBillingTransferPaymentsArgs = {
  billingTransferId: Scalars['String'];
};


export type QueryGetBillingTransfersAdminArgs = {
  dto: BillingTransferAdminPaginatedInputDto;
};


export type QueryGetBillingTransfersAppArgs = {
  dto: BillingTransferAppPaginatedInputDto;
};


export type QueryGetBlacklistedEmailsArgs = {
  dto?: InputMaybe<BlacklistedEmailPaginationInputDto>;
};


export type QueryGetBookingLogsArgs = {
  bookingId: Scalars['String'];
};


export type QueryGetBookingPriceArgs = {
  clientPricingItems: Array<ClientPricingItemInputDto>;
  clientProposalId?: InputMaybe<Scalars['String']>;
  houseId?: InputMaybe<Scalars['String']>;
};


export type QueryGetBookingPriceAdminArgs = {
  clientPricingItems: Array<ClientPricingItemInputDto>;
  clientProposalId?: InputMaybe<Scalars['String']>;
  houseId?: InputMaybe<Scalars['String']>;
};


export type QueryGetBookingPriceAppArgs = {
  clientPricingItems: Array<ClientPricingItemInputDto>;
  houseId?: InputMaybe<Scalars['String']>;
};


export type QueryGetClientPricingItemByIdArgs = {
  clientPricingItemId: Scalars['String'];
};


export type QueryGetClientProposalByIdArgs = {
  clientProposalId: Scalars['String'];
};


export type QueryGetClientProposalByIdUserArgs = {
  clientProposalId: Scalars['String'];
};


export type QueryGetClientProposalsByClientRequestIdArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetClientProposalsByClientRequestIdUserArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetClientRequestBriefContactArgs = {
  userId: Scalars['String'];
};


export type QueryGetClientRequestByAdminSalesIdArgs = {
  clientRequestsByAdminDto: ClientRequestsByAdminInputDto;
};


export type QueryGetClientRequestByIdAdminArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetClientRequestByIdUserArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetClientRequestByProposalIdArgs = {
  clientProposalId: Scalars['String'];
};


export type QueryGetClientRequestFinancePdfTypesArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetClientRequestLogsArgs = {
  clientRequestId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationDto>;
};


export type QueryGetClientRequestReviewArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetClientRequestsAdminArgs = {
  adminCsmId?: InputMaybe<Scalars['String']>;
  adminSalesId?: InputMaybe<Scalars['String']>;
  onlyTravelTypeWithHousing?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ClientRequestStatusEnum>;
};


export type QueryGetClientRequestsByCompanyIdArgs = {
  companyId: Scalars['String'];
  dto: CompanyClientRequestsInputDto;
};


export type QueryGetClientRequestsByHouseIdArgs = {
  houseId: Scalars['String'];
};


export type QueryGetClientRequestsByUserArgs = {
  maxStep?: InputMaybe<Scalars['Int']>;
};


export type QueryGetClientRequestsVisibleByOwnerByHouseIdArgs = {
  filters: ClientProposalOwnerListInputDto;
  houseId: Scalars['String'];
  pagination: PaginationDto;
};


export type QueryGetCompaniesAdminArgs = {
  companyListDto?: InputMaybe<CompanyListDto>;
};


export type QueryGetCompanyAndSubsidiariesClientRequestsByCompanyIdArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetCompanyAndSubsidiariesLatestClientRequestsArgs = {
  limit: Scalars['Float'];
};


export type QueryGetCompanyAndSubsidiariesLatestClientRequestsPaginatedArgs = {
  dto: ClientRequestMiceReservationInputDto;
  status?: InputMaybe<ClientRequestClientStatusEnum>;
};


export type QueryGetCompanyAndSubsidiariesPassedPaymentsArgs = {
  dto: MicePassedPaymentInputDto;
};


export type QueryGetCompanyAndSubsidiariesPendingPaymentsArgs = {
  dto: MiceFuturePaymentInputDto;
};


export type QueryGetCompanyByIdArgs = {
  companyId: Scalars['String'];
};


export type QueryGetFinanceByClientRequestIdArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetFinanceClientRequestsArgs = {
  datesBooking?: InputMaybe<FilterDatesDto>;
  datesClientRequest?: InputMaybe<FilterDatesDto>;
  datesPayment?: InputMaybe<FilterDatesDto>;
  houseId?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<HouseTypeEnum>;
  isSimplified?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ClientRequestStatusEnum>;
  step?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFinanceClientRequestsCountArgs = {
  datesBooking?: InputMaybe<FilterDatesDto>;
  datesClientRequest?: InputMaybe<FilterDatesDto>;
  datesPayment?: InputMaybe<FilterDatesDto>;
  houseId?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<HouseTypeEnum>;
  isSimplified?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ClientRequestStatusEnum>;
  step?: InputMaybe<Scalars['Int']>;
};


export type QueryGetHostClientProposalByIdArgs = {
  clientProposalId: Scalars['String'];
};


export type QueryGetHostTokenDataArgs = {
  token: Scalars['String'];
};


export type QueryGetHouseAndRestaurationClientPricingMenusArgs = {
  dto: HouseAndRestaurationClientPricingMenuInputDto;
};


export type QueryGetHouseBookingsWithHostActionRequiredArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseByIdAdminArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseCapacitiesAndBedroomsArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseCertificationAdminArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseClientProposalsArgs = {
  dto: GetHouseClientProposalsInputDto;
};


export type QueryGetHouseClientRequestsReviewsArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseContextByIdArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseEquipmentsByHouseIdArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseHeaderAdminArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseIdByPathnameArgs = {
  pathname: Scalars['String'];
};


export type QueryGetHouseMenuPricesArgs = {
  dto: HouseMenuPricesInputDto;
};


export type QueryGetHouseNumberOfWorkspacesByHouseIdArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseOwnerByTokenArgs = {
  token: Scalars['String'];
};


export type QueryGetHouseOwnerClientPricingItemsArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseOwnerListPaginatedArgs = {
  dto: HouseOwnerSearchInputDto;
};


export type QueryGetHousePicturesByHouseIdArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseScreenshotsByHouseIdArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseServiceProvisionsArgs = {
  houseId: Scalars['String'];
  serviceProviderCategory: ServiceProviderCategoryEnum;
};


export type QueryGetHouseServicesByHouseIdAdminArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHouseWorkspacesByHouseIdArgs = {
  houseId: Scalars['String'];
};


export type QueryGetHousesByGooglePlaceIdArgs = {
  googlePlaceId: Scalars['String'];
};


export type QueryGetHousesByIdsArgs = {
  houseIds: Array<Scalars['String']>;
};


export type QueryGetHousesByIdsAdminArgs = {
  houseIds: Array<Scalars['String']>;
};


export type QueryGetHousesDataForTravelSuggestionArgs = {
  clientProposalId: Scalars['String'];
  houseId: Scalars['String'];
};


export type QueryGetHousesListArgs = {
  houseListDto?: InputMaybe<HouseListDto>;
};


export type QueryGetHousesWithFiltersArgs = {
  housesWithFiltersDto: HousesWithFiltersDto;
};


export type QueryGetLastBookingHousesArgs = {
  ambiance?: InputMaybe<Array<AmbianceEnum>>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Iso3166Alpha2Enum>;
  department?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<Array<HouseTypeEnum>>;
  region?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<TagSpecialTypeEnum>;
  travelType: TravelTypeEnum;
};


export type QueryGetLastParentCompanyContractFromClientProposalIdAdminArgs = {
  clientProposalId: Scalars['String'];
};


export type QueryGetLastVisitedHousesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetMarketPlaceByIdArgs = {
  marketplaceId: Scalars['String'];
};


export type QueryGetMarketplacesArgs = {
  inputs?: InputMaybe<GetMarketplacesInputDto>;
};


export type QueryGetMiceCarbonFootprintClientRequestsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetMiceClientRequestArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetMiceUsersArgs = {
  dto: UserMiceInputDto;
  miceRole: CompanyRoleEnum;
};


export type QueryGetMissingServiceProvisionsForMenusAdminArgs = {
  houseId: Scalars['String'];
};


export type QueryGetMostBookedDepartmentsArgs = {
  countryCode: Iso3166Alpha2Enum;
};


export type QueryGetMostBookedHousesArgs = {
  ambiance?: InputMaybe<Array<AmbianceEnum>>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Iso3166Alpha2Enum>;
  department?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<Array<HouseTypeEnum>>;
  region?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<TagSpecialTypeEnum>;
  travelType: TravelTypeEnum;
};


export type QueryGetMySpaceClientRequestsArgs = {
  filter: MySpaceClientRequestFilterEnum;
};


export type QueryGetNewCompaniesAdminArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
};


export type QueryGetNotConfirmedClientRequestsByCompanyIdArgs = {
  companyId: Scalars['String'];
  dto: NotConfirmedClientRequestsInputDto;
};


export type QueryGetOwnerHeaderAdminArgs = {
  ownerId: Scalars['String'];
};


export type QueryGetOwnerInformationsAdminArgs = {
  ownerId: Scalars['String'];
};


export type QueryGetOwnerProposalsByClientRequestIdArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetOwnerStatusAdminArgs = {
  ownerId: Scalars['String'];
};


export type QueryGetParentCompaniesArgs = {
  parentCompaniesResearch?: InputMaybe<ParentCompaniesResearchInputDto>;
};


export type QueryGetParentCompanyCompaniesArgs = {
  parentCompanyId: Scalars['String'];
};


export type QueryGetPaymentsByClientRequestAdminArgs = {
  clientRequestId: Scalars['String'];
};


export type QueryGetPdfsByClientProposalIdArgs = {
  clientProposalId: Scalars['String'];
  clientRequestId: Scalars['String'];
  pdfTypes: Array<PdfTypeEnum>;
};


export type QueryGetSearchHouseArgs = {
  inputs?: InputMaybe<HouseSearchInputDto>;
};


export type QueryGetSelectableClientPricingItemsByHouseIdArgs = {
  houseId: Scalars['String'];
};


export type QueryGetServiceOwnerInformationsAdminArgs = {
  serviceOwnerId: Scalars['String'];
};


export type QueryGetServiceOwnersArgs = {
  category?: InputMaybe<ServiceProviderCategoryEnum>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetServiceProviderArgs = {
  serviceProviderId: Scalars['String'];
};


export type QueryGetServiceProviderAdminArgs = {
  serviceProviderId: Scalars['String'];
};


export type QueryGetServiceProviderClientRequestsReviewsArgs = {
  serviceProviderId: Scalars['String'];
};


export type QueryGetServiceProvidersAdminArgs = {
  adminOpsId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<ServiceProviderCategoryEnum>;
  pagination?: InputMaybe<PaginationDto>;
  q?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ServiceProviderStatusEnum>;
};


export type QueryGetServiceProvidersByServiceOwnerArgs = {
  serviceOwnerId: Scalars['String'];
};


export type QueryGetServiceProvidersCountAdminArgs = {
  adminOpsId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<ServiceProviderCategoryEnum>;
  q?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ServiceProviderStatusEnum>;
};


export type QueryGetServiceProvisionsArgs = {
  isHouseProvision: Scalars['Boolean'];
  provisionParentId: Scalars['String'];
  serviceCategories?: InputMaybe<Array<ServiceProviderCategoryEnum>>;
};


export type QueryGetSimilarArticlesArgs = {
  articleCategories: Array<ArticleCategoryEnum>;
  currentArticleId: Scalars['String'];
};


export type QueryGetSimilarHousesArgs = {
  houseId: Scalars['String'];
};


export type QueryGetSiteArgs = {
  siteId: Scalars['String'];
};


export type QueryGetSiteDataArgs = {
  inputs: SiteDataInputDto;
};


export type QueryGetSiteLastEventsArgs = {
  inputs: GetSiteLastEventsInputDto;
};


export type QueryGetTagsByCategoriesArgs = {
  categories: Array<TagCategoryEnum>;
};


export type QueryGetTop10SiteDestinationsArgs = {
  inputs: GetTop10SiteDestinationsInputDto;
};


export type QueryGetTopActivesOrganizersArgs = {
  limit?: Scalars['Int'];
  siteId: Scalars['String'];
};


export type QueryGetTravelTimeByHouseIdArgs = {
  cityName: Scalars['String'];
  houseId: Scalars['String'];
};


export type QueryGetUserAdminArgs = {
  userId: Scalars['String'];
};


export type QueryGetUserByTokenArgs = {
  token: Scalars['String'];
};


export type QueryGetUserLogsArgs = {
  pagination?: InputMaybe<PaginationDto>;
  userClientRequestIds?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryGetUsersAdminArgs = {
  input: GetUsersAdminInputDto;
};


export type QueryIsHouseAvailableForTravelTypeFromToArgs = {
  inputDto: IsHouseAvailableForTravelTypeFromTo;
};


export type QueryLoginHostByTokenArgs = {
  token: Scalars['String'];
};


export type QueryOwnerGetHouseWithAvailabilitiesArgs = {
  houseId: Scalars['String'];
};


export type QueryPublicGetHouseAvailabilitiesFromToArgs = {
  inputDto: HouseAvailabilityGetFromToInputDto;
};


export type QueryServiceOwnerArgs = {
  id: Scalars['String'];
};


export type QueryServiceProviderPicturesArgs = {
  serviceProviderId: Scalars['String'];
};

export enum QuestionTypeEnum {
  EQUIPMENTQ1 = 'EquipmentQ1',
  Q1 = 'Q1',
  Q2 = 'Q2',
  Q3 = 'Q3'
}

export type QuotationDifferenceOutputDto = {
  __typename?: 'QuotationDifferenceOutputDto';
  amountQuotationDifference: Scalars['Float'];
  percentageQuotationDifference: Scalars['Int'];
};

export type ResetHostPasswordDto = {
  confirmedPassword: Scalars['String'];
  isAuthenticatingToken?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  token: Scalars['String'];
};

export type ResetPasswordDto = {
  isAuthenticatingToken?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  token: Scalars['String'];
};

export type ResponseLogout = {
  __typename?: 'ResponseLogout';
  success: Scalars['Boolean'];
};

export type ResultScoreSearchSessionInputDto = {
  baseProximityScore?: InputMaybe<Scalars['Float']>;
  bedScore?: InputMaybe<Scalars['Float']>;
  bedroomScore?: InputMaybe<Scalars['Float']>;
  budgetScore?: InputMaybe<Scalars['Float']>;
  capacityScore?: InputMaybe<Scalars['Float']>;
  equipmentScore?: InputMaybe<Scalars['Float']>;
  forestAccessibilityScore?: InputMaybe<Scalars['Float']>;
  locationScore?: InputMaybe<Scalars['Float']>;
  oneDayTripScore?: InputMaybe<Scalars['Float']>;
  participantScore?: InputMaybe<Scalars['Float']>;
  privatisationScore?: InputMaybe<Scalars['Float']>;
  raScore?: InputMaybe<Scalars['Float']>;
  seasonBudgetScore?: InputMaybe<Scalars['Float']>;
  totalBudgetScore?: InputMaybe<Scalars['Float']>;
  totalScore?: InputMaybe<Scalars['Float']>;
  trainAccessibilityScore?: InputMaybe<Scalars['Float']>;
  travelTimeScore?: InputMaybe<Scalars['Float']>;
};

export type ScoresContext = {
  __typename?: 'ScoresContext';
  baseProximityScore?: Maybe<Scalars['Float']>;
  bedScore?: Maybe<Scalars['Float']>;
  bedroomScore?: Maybe<Scalars['Float']>;
  budgetScore?: Maybe<Scalars['Float']>;
  capacityScore?: Maybe<Scalars['Float']>;
  equipmentScore?: Maybe<Scalars['Float']>;
  forestAccessibilityScore?: Maybe<Scalars['Float']>;
  locationScore?: Maybe<Scalars['Float']>;
  oneDayTripScore?: Maybe<Scalars['Float']>;
  participantScore?: Maybe<Scalars['Float']>;
  privatisationScore?: Maybe<Scalars['Float']>;
  seasonBudgetScore?: Maybe<Scalars['Float']>;
  totalBudgetScore?: Maybe<Scalars['Float']>;
  totalScore?: Maybe<Scalars['Float']>;
  trainAccessibilityScore?: Maybe<Scalars['Float']>;
  travelTimeScore?: Maybe<Scalars['Float']>;
};

export type SearchParamsContext = {
  __typename?: 'SearchParamsContext';
  budget?: Maybe<BudgetRequestedContext>;
  capacity?: Maybe<Scalars['Float']>;
  equipments?: Maybe<Array<EquipmentRequested>>;
  forestAccessibility?: Maybe<TagSpecialTypeEnum>;
  houseAmbiance?: Maybe<Array<AmbianceEnum>>;
  houseCanBePrivatised?: Maybe<Scalars['Boolean']>;
  houseDisponibility?: Maybe<HouseDisponibilityRequested>;
  houseType?: Maybe<Array<HouseTypeEnum>>;
  location?: Maybe<LocationRequired>;
  maxNumberOfBedrooms?: Maybe<Scalars['Float']>;
  numberOfBedrooms?: Maybe<Scalars['Float']>;
  numberOfBeds?: Maybe<Scalars['Float']>;
  onlyHouseCertified?: Maybe<Scalars['Boolean']>;
  onlyHouseExecutive?: Maybe<Scalars['Boolean']>;
  trainAccessibility?: Maybe<TagSpecialTypeEnum>;
  travelTime?: Maybe<TravelTimeRequested>;
  travelType?: Maybe<TravelTypeEnum>;
};

export type SearchSessionSlackBudgetInputDto = {
  budgetMin: Scalars['Float'];
  formatedBudget: Scalars['String'];
};

export type SearchSessionSlackDatesInputDto = {
  endDate: Scalars['DateTime'];
  flexible: Scalars['Boolean'];
  formatedDates: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type SearchSessionSlackInputDto = {
  budget: SearchSessionSlackBudgetInputDto;
  dates: SearchSessionSlackDatesInputDto;
  location: Scalars['String'];
  participants: Scalars['Float'];
  sessionId?: InputMaybe<Scalars['String']>;
  travelType: TravelTypeEnum;
};

export enum SeasonEnum {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type SeasonsPriceOptionObjects = {
  __typename?: 'SeasonsPriceOptionObjects';
  HIGH?: Maybe<ComputedPrice>;
  LOW?: Maybe<ComputedPrice>;
  MEDIUM?: Maybe<ComputedPrice>;
};

export type SeedingInputDto = {
  dropCollections?: InputMaybe<Scalars['Boolean']>;
  marketplaceDomain?: InputMaybe<Scalars['String']>;
};

export type SeedingOutputDto = {
  __typename?: 'SeedingOutputDto';
  admin: AdminModel;
  company: CompanyOutputDto;
  estimatedPriceHouse: HouseContext;
  globalPriceHouse: HouseContext;
  house: HouseContext;
  houseOwner: HouseOwnerOutputDto;
  individualPriceHouse: HouseContext;
  instantPriceHouse: HouseContext;
  quotationPriceHouse: HouseContext;
  serviceOwner: ServiceOwnerOutputDto;
  serviceProvider: ServiceProviderOutputDto;
  tag: TagOutputDto;
  travelCity: TravelCityModel;
  user: UserOutputDto;
  userMarketplace: UserOutputDto;
};

export type SelectOptionAdmin = {
  __typename?: 'SelectOptionAdmin';
  deleted?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type SendSearchSessionSlackNotificationOutputDto = {
  __typename?: 'SendSearchSessionSlackNotificationOutputDto';
  sessionId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ServiceFeesMilestonesInputDto = {
  requiredSpentAmount: Scalars['Float'];
  userFeesRate: Scalars['Float'];
};

export type ServiceFeesMilestonesOutputDto = {
  __typename?: 'ServiceFeesMilestonesOutputDto';
  requiredSpentAmount: Scalars['Float'];
  userFeesRate: Scalars['Float'];
};

export type ServiceOwnerOutputDto = {
  __typename?: 'ServiceOwnerOutputDto';
  _id: Scalars['ID'];
  companyAddress?: Maybe<AddressContext>;
  companyName?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  hubspot?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  readableId: Scalars['String'];
  /** 🔐 Authentication required - must be an admin */
  serviceProviders?: Maybe<Array<ServiceProviderOutputDto>>;
  siret?: Maybe<Scalars['String']>;
  status?: Maybe<ServiceOwnerStatusEnum>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  vatNumber?: Maybe<Scalars['String']>;
};

export enum ServiceOwnerStatusEnum {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  PENDING = 'PENDING'
}

export enum ServiceProviderCategoryEnum {
  ACTIVITY = 'ACTIVITY',
  BATCH_PROVISIONS = 'BATCH_PROVISIONS',
  FEES_ADJUSTMENTS = 'FEES_ADJUSTMENTS',
  HOUSE = 'HOUSE',
  RESTAURATION = 'RESTAURATION',
  TAXES = 'TAXES',
  TOTAL = 'TOTAL',
  TRANSPORT = 'TRANSPORT'
}

export type ServiceProviderCountsOutputDto = {
  __typename?: 'ServiceProviderCountsOutputDto';
  ACTIVITY?: Maybe<Scalars['Int']>;
  RESTAURATION?: Maybe<Scalars['Int']>;
  TRANSPORT?: Maybe<Scalars['Int']>;
};

export type ServiceProviderOutputDto = {
  __typename?: 'ServiceProviderOutputDto';
  _id: Scalars['ID'];
  address?: Maybe<AddressContext>;
  adminOps?: Maybe<AdminLightOutputDto>;
  adminOpsId?: Maybe<Scalars['String']>;
  associatedHousesNumber?: Maybe<Scalars['Int']>;
  bookingType?: Maybe<HouseBookingTypeEnum>;
  category: ServiceProviderCategoryEnum;
  clientPricingItems?: Maybe<Array<ClientPricingItemOutputDto>>;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  currencyArea: CurrencyAreaOutputDto;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  googleRating?: Maybe<GoogleRatingOutputDto>;
  houseInRange?: Maybe<Array<HouseContext>>;
  hubspot?: Maybe<Scalars['String']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  mainPicture?: Maybe<ServiceProviderPictureOutputDto>;
  mainPictureId?: Maybe<Scalars['String']>;
  maxDistance?: Maybe<Scalars['Int']>;
  memo?: Maybe<Scalars['String']>;
  nabooRating?: Maybe<NabooRatingModel>;
  phone?: Maybe<Scalars['String']>;
  pictures?: Maybe<Array<ServiceProviderPictureOutputDto>>;
  provisions: Array<ServiceProvisionOutputDtoUnion>;
  readableId: Scalars['String'];
  serviceOwner?: Maybe<ServiceOwnerOutputDto>;
  serviceOwnerId?: Maybe<Scalars['String']>;
  serviceProvisions?: Maybe<Array<ServiceProvisionOutputDtoUnion>>;
  status?: Maybe<ServiceProviderStatusEnum>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<TagOutputDto>>;
  taxIdentifier: TaxIdentifierEnum;
  title: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  websiteURL?: Maybe<Scalars['String']>;
};


export type ServiceProviderOutputDtoClientPricingItemsArgs = {
  onlyIsVisible?: Scalars['Boolean'];
};


export type ServiceProviderOutputDtoProvisionsArgs = {
  clientProposalId?: InputMaybe<Scalars['String']>;
  onlyIsVisible?: Scalars['Boolean'];
};

export type ServiceProviderPictureOutputDto = {
  __typename?: 'ServiceProviderPictureOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  position: Scalars['Float'];
  serviceProviderId?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type ServiceProviderReviewOutputDto = {
  __typename?: 'ServiceProviderReviewOutputDto';
  feedbacks?: Maybe<Array<ClientRequestsReviewOutputDto>>;
  nabooRating?: Maybe<NabooRatingModel>;
};

export enum ServiceProviderStatusEnum {
  BANNED = 'BANNED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  REFUSAL = 'REFUSAL'
}

export type ServiceProvisionActivityInputDto = {
  _id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  environments?: InputMaybe<Array<ServiceProvisionEnvironmentEnum>>;
  feesRate?: InputMaybe<Scalars['Float']>;
  houseId?: InputMaybe<Scalars['String']>;
  isSavedWithVat?: InputMaybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  nestedItems?: InputMaybe<NestedItemsInputDto>;
  pictures?: InputMaybe<Array<ServiceProvisionPictureInputDto>>;
  position: Scalars['Float'];
  prices?: InputMaybe<Array<ServiceProvisionPriceInputDto>>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProviderId?: InputMaybe<Scalars['String']>;
  takePlaces?: InputMaybe<Array<ServiceProvisionTakePlaceEnum>>;
  title: Scalars['String'];
  travelTypes?: InputMaybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
};

export type ServiceProvisionActivityOutputDto = ServiceProvisionBaseOutputDto & {
  __typename?: 'ServiceProvisionActivityOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  environments?: Maybe<Array<ServiceProvisionEnvironmentEnum>>;
  fees?: Maybe<PriceOptionFeesOutputDto>;
  houseId?: Maybe<Scalars['String']>;
  isSavedWithVat?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  minQuantity?: Maybe<Scalars['Float']>;
  nestedItems?: Maybe<NestedItemsOutputDto>;
  pictures?: Maybe<Array<ServiceProvisionPictureOutputDto>>;
  position?: Maybe<Scalars['Float']>;
  prices: Array<ServiceProvisionPriceOutputDto>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProvider?: Maybe<ServiceProviderOutputDto>;
  serviceProviderId?: Maybe<Scalars['String']>;
  startingFees?: Maybe<ServiceProvisionPriceOutputDto>;
  takePlaces?: Maybe<Array<ServiceProvisionTakePlaceEnum>>;
  title: Scalars['String'];
  travelTypes?: Maybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ServiceProvisionActivityTypeEnum {
  ARCHERY = 'ARCHERY',
  BIKE = 'BIKE',
  CASINO_NIGHT = 'CASINO_NIGHT',
  CONFERENCES = 'CONFERENCES',
  COOKING_COURSE_AND_MIXOLOGY = 'COOKING_COURSE_AND_MIXOLOGY',
  CREATIVE_WORKSHOPS = 'CREATIVE_WORKSHOPS',
  CSR_WORKSHOP = 'CSR_WORKSHOP',
  DANCE = 'DANCE',
  DEGUSTATION = 'DEGUSTATION',
  DISCOVERY_WALK = 'DISCOVERY_WALK',
  DJ_SOUND_AND_LIGHTING = 'DJ_SOUND_AND_LIGHTING',
  ESCAPE_GAME = 'ESCAPE_GAME',
  EVENT_PROJECT_MANAGER = 'EVENT_PROJECT_MANAGER',
  GAMES_AND_CONSTRUCTION = 'GAMES_AND_CONSTRUCTION',
  GOODIES = 'GOODIES',
  GUESS_THE_SONG_GAME_AND_KARAOKE = 'GUESS_THE_SONG_GAME_AND_KARAOKE',
  GUIDED_VISITS = 'GUIDED_VISITS',
  HORSE_RIDING = 'HORSE_RIDING',
  MAGIC_AND_MENTALISM = 'MAGIC_AND_MENTALISM',
  MASSAGE_AND_WELLNESS = 'MASSAGE_AND_WELLNESS',
  MOTORSPORTS = 'MOTORSPORTS',
  MOUNTAIN_ACTIVITIES = 'MOUNTAIN_ACTIVITIES',
  MURDER_AND_MYSTERY_PARTY = 'MURDER_AND_MYSTERY_PARTY',
  NAUTICAL_ACTIVITIES = 'NAUTICAL_ACTIVITIES',
  OLYMPIADS = 'OLYMPIADS',
  OTHER = 'OTHER',
  PAINTBALL_AND_LASER_TAG = 'PAINTBALL_AND_LASER_TAG',
  PHOTOGRAPHER_AND_PHOTOBOOTH = 'PHOTOGRAPHER_AND_PHOTOBOOTH',
  QUIZ_AND_BURGER_CHALLENGE = 'QUIZ_AND_BURGER_CHALLENGE',
  TECHNICAL_PRESTATION = 'TECHNICAL_PRESTATION',
  TREASURE_HUNT_AND_ORIENTEERING_RACE = 'TREASURE_HUNT_AND_ORIENTEERING_RACE',
  TREE_CLIMBING = 'TREE_CLIMBING',
  YOGA_AND_PILATES = 'YOGA_AND_PILATES'
}

export type ServiceProvisionAdminInputDto = {
  activities?: InputMaybe<Array<ServiceProvisionActivityInputDto>>;
  batchProvisions?: InputMaybe<Array<ServiceProvisionBatchProvisionsInputDto>>;
  houses?: InputMaybe<Array<ServiceProvisionHouseInputDto>>;
  restaurations?: InputMaybe<Array<ServiceProvisionRestaurationInputDto>>;
  transports?: InputMaybe<Array<ServiceProvisionTransportInputDto>>;
};

export type ServiceProvisionBaseOutputDto = {
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  fees?: Maybe<PriceOptionFeesOutputDto>;
  houseId?: Maybe<Scalars['String']>;
  isSavedWithVat?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  minQuantity?: Maybe<Scalars['Float']>;
  nestedItems?: Maybe<NestedItemsOutputDto>;
  pictures?: Maybe<Array<ServiceProvisionPictureOutputDto>>;
  position?: Maybe<Scalars['Float']>;
  prices: Array<ServiceProvisionPriceOutputDto>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProvider?: Maybe<ServiceProviderOutputDto>;
  serviceProviderId?: Maybe<Scalars['String']>;
  startingFees?: Maybe<ServiceProvisionPriceOutputDto>;
  title: Scalars['String'];
  travelTypes?: Maybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ServiceProvisionBatchProvisionTypeEnum {
  AFTERNOON_HALF_DAY_PACKAGE = 'AFTERNOON_HALF_DAY_PACKAGE',
  BNB_SINGLE = 'BNB_SINGLE',
  BNB_TWIN = 'BNB_TWIN',
  COCKTAIL_RECEPTION = 'COCKTAIL_RECEPTION',
  DANCE_EVENING = 'DANCE_EVENING',
  DAY_PACKAGE = 'DAY_PACKAGE',
  DELIVERY_24_HOURS_RESTORATION_PACKAGE = 'DELIVERY_24_HOURS_RESTORATION_PACKAGE',
  EVENING_PACKAGE = 'EVENING_PACKAGE',
  MORNING_HALF_DAY_PACKAGE = 'MORNING_HALF_DAY_PACKAGE',
  OTHER = 'OTHER',
  SEATED_DINNER = 'SEATED_DINNER',
  SHARED_RESIDENTIAL_SEMINAR = 'SHARED_RESIDENTIAL_SEMINAR',
  SINGLE_RESIDENTIAL_SEMINAR = 'SINGLE_RESIDENTIAL_SEMINAR',
  WORKSPACE_DAY = 'WORKSPACE_DAY',
  WORKSPACE_HALF_DAY = 'WORKSPACE_HALF_DAY'
}

export type ServiceProvisionBatchProvisionsInputDto = {
  _id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feesRate?: InputMaybe<Scalars['Float']>;
  houseId?: InputMaybe<Scalars['String']>;
  isSavedWithVat?: InputMaybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  nestedItems?: InputMaybe<NestedItemsInputDto>;
  pictures?: InputMaybe<Array<ServiceProvisionPictureInputDto>>;
  position: Scalars['Float'];
  prices?: InputMaybe<Array<ServiceProvisionPriceInputDto>>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProviderId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  travelTypes?: InputMaybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
};

export type ServiceProvisionBatchProvisionsOutputDto = ServiceProvisionBaseOutputDto & {
  __typename?: 'ServiceProvisionBatchProvisionsOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  fees?: Maybe<PriceOptionFeesOutputDto>;
  houseId?: Maybe<Scalars['String']>;
  isSavedWithVat?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  minQuantity?: Maybe<Scalars['Float']>;
  nestedItems?: Maybe<NestedItemsOutputDto>;
  pictures?: Maybe<Array<ServiceProvisionPictureOutputDto>>;
  position?: Maybe<Scalars['Float']>;
  prices: Array<ServiceProvisionPriceOutputDto>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProvider?: Maybe<ServiceProviderOutputDto>;
  serviceProviderId?: Maybe<Scalars['String']>;
  startingFees?: Maybe<ServiceProvisionPriceOutputDto>;
  title: Scalars['String'];
  travelTypes?: Maybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ServiceProvisionEnvironmentEnum {
  INDOOR = 'INDOOR',
  OUTDOOR = 'OUTDOOR'
}

export type ServiceProvisionHouseInputDto = {
  _id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feesRate?: InputMaybe<Scalars['Float']>;
  houseId?: InputMaybe<Scalars['String']>;
  isSavedWithVat?: InputMaybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  nestedItems?: InputMaybe<NestedItemsInputDto>;
  pictures?: InputMaybe<Array<ServiceProvisionPictureInputDto>>;
  position: Scalars['Float'];
  prices?: InputMaybe<Array<ServiceProvisionPriceInputDto>>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProviderId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  travelTypes?: InputMaybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
};

export type ServiceProvisionHouseOutputDto = ServiceProvisionBaseOutputDto & {
  __typename?: 'ServiceProvisionHouseOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  fees?: Maybe<PriceOptionFeesOutputDto>;
  houseId?: Maybe<Scalars['String']>;
  isSavedWithVat?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  minQuantity?: Maybe<Scalars['Float']>;
  nestedItems?: Maybe<NestedItemsOutputDto>;
  pictures?: Maybe<Array<ServiceProvisionPictureOutputDto>>;
  position?: Maybe<Scalars['Float']>;
  prices: Array<ServiceProvisionPriceOutputDto>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProvider?: Maybe<ServiceProviderOutputDto>;
  serviceProviderId?: Maybe<Scalars['String']>;
  startingFees?: Maybe<ServiceProvisionPriceOutputDto>;
  title: Scalars['String'];
  travelTypes?: Maybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ServiceProvisionHouseTypeEnum {
  EXTRA = 'EXTRA',
  MATERIAL = 'MATERIAL',
  OTHER = 'OTHER',
  PRIVATIZATION = 'PRIVATIZATION',
  SPACE = 'SPACE',
  STAFF = 'STAFF'
}

export type ServiceProvisionOutputDtoUnion = ServiceProvisionActivityOutputDto | ServiceProvisionBatchProvisionsOutputDto | ServiceProvisionHouseOutputDto | ServiceProvisionRestaurationOutputDto | ServiceProvisionTransportOutputDto;

export type ServiceProvisionPictureInputDto = {
  _id: Scalars['String'];
  deleted?: InputMaybe<Scalars['Boolean']>;
  position: Scalars['Float'];
  uri: Scalars['String'];
};

export type ServiceProvisionPictureOutputDto = {
  __typename?: 'ServiceProvisionPictureOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  position: Scalars['Float'];
  serviceProvisionId?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type ServiceProvisionPriceInputDto = {
  _id?: InputMaybe<Scalars['String']>;
  maxAdults?: InputMaybe<Scalars['Float']>;
  minAdults?: InputMaybe<Scalars['Float']>;
  season?: InputMaybe<SeasonEnum>;
  unit: ServiceProvisionUnitEnum;
  vatPrices: Array<ComputedPriceDto>;
};

export type ServiceProvisionPriceOutputDto = {
  __typename?: 'ServiceProvisionPriceOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  maxAdults?: Maybe<Scalars['Float']>;
  minAdults?: Maybe<Scalars['Float']>;
  price?: Maybe<ComputedPrice>;
  season?: Maybe<SeasonEnum>;
  serviceProvisionId?: Maybe<Scalars['String']>;
  unit: ServiceProvisionUnitEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  vatPrices: Array<ComputedPrice>;
};

export enum ServiceProvisionPricingTypeEnum {
  INCLUDED = 'INCLUDED',
  PERMANENT = 'PERMANENT',
  SEASONAL = 'SEASONAL'
}

export type ServiceProvisionRestaurationInputDto = {
  _id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feesRate?: InputMaybe<Scalars['Float']>;
  houseId?: InputMaybe<Scalars['String']>;
  isSavedWithVat?: InputMaybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  nestedItems?: InputMaybe<NestedItemsInputDto>;
  pictures?: InputMaybe<Array<ServiceProvisionPictureInputDto>>;
  position: Scalars['Float'];
  prices?: InputMaybe<Array<ServiceProvisionPriceInputDto>>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProviderId?: InputMaybe<Scalars['String']>;
  takePlaces?: InputMaybe<Array<ServiceProvisionTakePlaceEnum>>;
  title: Scalars['String'];
  travelTypes?: InputMaybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
  withCulteryDishesGlass?: InputMaybe<Scalars['Boolean']>;
  withService?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceProvisionRestaurationOutputDto = ServiceProvisionBaseOutputDto & {
  __typename?: 'ServiceProvisionRestaurationOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  fees?: Maybe<PriceOptionFeesOutputDto>;
  houseId?: Maybe<Scalars['String']>;
  isSavedWithVat?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  minQuantity?: Maybe<Scalars['Float']>;
  nestedItems?: Maybe<NestedItemsOutputDto>;
  pictures?: Maybe<Array<ServiceProvisionPictureOutputDto>>;
  position?: Maybe<Scalars['Float']>;
  prices: Array<ServiceProvisionPriceOutputDto>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProvider?: Maybe<ServiceProviderOutputDto>;
  serviceProviderId?: Maybe<Scalars['String']>;
  startingFees?: Maybe<ServiceProvisionPriceOutputDto>;
  takePlaces?: Maybe<Array<ServiceProvisionTakePlaceEnum>>;
  title: Scalars['String'];
  travelTypes?: Maybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  withCulteryDishesGlass?: Maybe<Scalars['Boolean']>;
  withService?: Maybe<Scalars['Boolean']>;
};

export enum ServiceProvisionRestaurationTypeEnum {
  AFTERNOON_SNACK = 'AFTERNOON_SNACK',
  APERITIF = 'APERITIF',
  BREAKFAST = 'BREAKFAST',
  DINNER = 'DINNER',
  DRINK = 'DRINK',
  GROCERY_DELIVERY = 'GROCERY_DELIVERY',
  LUNCH = 'LUNCH',
  MEAL_DRINK = 'MEAL_DRINK',
  MORNING_SNACK = 'MORNING_SNACK',
  OTHER = 'OTHER',
  PERMANENT_SNACK = 'PERMANENT_SNACK',
  WELCOME_COFFEE = 'WELCOME_COFFEE'
}

export enum ServiceProvisionTakePlaceEnum {
  ON_CLIENT_SITE = 'ON_CLIENT_SITE',
  ON_PROVIDER_SITE = 'ON_PROVIDER_SITE'
}

export type ServiceProvisionTransportInputDto = {
  _id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  feesRate?: InputMaybe<Scalars['Float']>;
  houseId?: InputMaybe<Scalars['String']>;
  isSavedWithVat?: InputMaybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  nestedItems?: InputMaybe<NestedItemsInputDto>;
  pictures?: InputMaybe<Array<ServiceProvisionPictureInputDto>>;
  position: Scalars['Float'];
  prices?: InputMaybe<Array<ServiceProvisionPriceInputDto>>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProviderId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  travelTypes?: InputMaybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
};

export type ServiceProvisionTransportOutputDto = ServiceProvisionBaseOutputDto & {
  __typename?: 'ServiceProvisionTransportOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  fees?: Maybe<PriceOptionFeesOutputDto>;
  houseId?: Maybe<Scalars['String']>;
  isSavedWithVat?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  minQuantity?: Maybe<Scalars['Float']>;
  nestedItems?: Maybe<NestedItemsOutputDto>;
  pictures?: Maybe<Array<ServiceProvisionPictureOutputDto>>;
  position?: Maybe<Scalars['Float']>;
  prices: Array<ServiceProvisionPriceOutputDto>;
  pricingType: ServiceProvisionPricingTypeEnum;
  serviceCategory: ServiceProviderCategoryEnum;
  serviceProvider?: Maybe<ServiceProviderOutputDto>;
  serviceProviderId?: Maybe<Scalars['String']>;
  startingFees?: Maybe<ServiceProvisionPriceOutputDto>;
  title: Scalars['String'];
  travelTypes?: Maybe<Array<TravelTypeEnum>>;
  type: ServiceProvisionTypeEnum;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ServiceProvisionTransportTypeEnum {
  BUS = 'BUS',
  OTHER = 'OTHER',
  PLANE = 'PLANE',
  SHUTTLE = 'SHUTTLE',
  TAXI = 'TAXI',
  TRAIN = 'TRAIN',
  VTC = 'VTC'
}

export enum ServiceProvisionTypeEnum {
  AFTERNOON_HALF_DAY_PACKAGE = 'AFTERNOON_HALF_DAY_PACKAGE',
  AFTERNOON_SNACK = 'AFTERNOON_SNACK',
  APERITIF = 'APERITIF',
  ARCHERY = 'ARCHERY',
  BIKE = 'BIKE',
  BNB_SINGLE = 'BNB_SINGLE',
  BNB_TWIN = 'BNB_TWIN',
  BREAKFAST = 'BREAKFAST',
  BUS = 'BUS',
  CASINO_NIGHT = 'CASINO_NIGHT',
  COCKTAIL_RECEPTION = 'COCKTAIL_RECEPTION',
  CONFERENCES = 'CONFERENCES',
  COOKING_COURSE_AND_MIXOLOGY = 'COOKING_COURSE_AND_MIXOLOGY',
  CREATIVE_WORKSHOPS = 'CREATIVE_WORKSHOPS',
  CSR_WORKSHOP = 'CSR_WORKSHOP',
  DANCE = 'DANCE',
  DANCE_EVENING = 'DANCE_EVENING',
  DAY_PACKAGE = 'DAY_PACKAGE',
  DEGUSTATION = 'DEGUSTATION',
  DELIVERY_24_HOURS_RESTORATION_PACKAGE = 'DELIVERY_24_HOURS_RESTORATION_PACKAGE',
  DINNER = 'DINNER',
  DISCOVERY_WALK = 'DISCOVERY_WALK',
  DJ_SOUND_AND_LIGHTING = 'DJ_SOUND_AND_LIGHTING',
  DRINK = 'DRINK',
  ESCAPE_GAME = 'ESCAPE_GAME',
  EVENING_PACKAGE = 'EVENING_PACKAGE',
  EVENT_PROJECT_MANAGER = 'EVENT_PROJECT_MANAGER',
  EXTRA = 'EXTRA',
  GAMES_AND_CONSTRUCTION = 'GAMES_AND_CONSTRUCTION',
  GOODIES = 'GOODIES',
  GROCERY_DELIVERY = 'GROCERY_DELIVERY',
  GUESS_THE_SONG_GAME_AND_KARAOKE = 'GUESS_THE_SONG_GAME_AND_KARAOKE',
  GUIDED_VISITS = 'GUIDED_VISITS',
  HORSE_RIDING = 'HORSE_RIDING',
  LUNCH = 'LUNCH',
  MAGIC_AND_MENTALISM = 'MAGIC_AND_MENTALISM',
  MASSAGE_AND_WELLNESS = 'MASSAGE_AND_WELLNESS',
  MATERIAL = 'MATERIAL',
  MEAL_DRINK = 'MEAL_DRINK',
  MORNING_HALF_DAY_PACKAGE = 'MORNING_HALF_DAY_PACKAGE',
  MORNING_SNACK = 'MORNING_SNACK',
  MOTORSPORTS = 'MOTORSPORTS',
  MOUNTAIN_ACTIVITIES = 'MOUNTAIN_ACTIVITIES',
  MURDER_AND_MYSTERY_PARTY = 'MURDER_AND_MYSTERY_PARTY',
  NAUTICAL_ACTIVITIES = 'NAUTICAL_ACTIVITIES',
  OLYMPIADS = 'OLYMPIADS',
  OTHER = 'OTHER',
  PAINTBALL_AND_LASER_TAG = 'PAINTBALL_AND_LASER_TAG',
  PERMANENT_SNACK = 'PERMANENT_SNACK',
  PHOTOGRAPHER_AND_PHOTOBOOTH = 'PHOTOGRAPHER_AND_PHOTOBOOTH',
  PLANE = 'PLANE',
  PRIVATIZATION = 'PRIVATIZATION',
  QUIZ_AND_BURGER_CHALLENGE = 'QUIZ_AND_BURGER_CHALLENGE',
  SEATED_DINNER = 'SEATED_DINNER',
  SHARED_RESIDENTIAL_SEMINAR = 'SHARED_RESIDENTIAL_SEMINAR',
  SHUTTLE = 'SHUTTLE',
  SINGLE_RESIDENTIAL_SEMINAR = 'SINGLE_RESIDENTIAL_SEMINAR',
  SPACE = 'SPACE',
  STAFF = 'STAFF',
  TAXI = 'TAXI',
  TECHNICAL_PRESTATION = 'TECHNICAL_PRESTATION',
  TRAIN = 'TRAIN',
  TREASURE_HUNT_AND_ORIENTEERING_RACE = 'TREASURE_HUNT_AND_ORIENTEERING_RACE',
  TREE_CLIMBING = 'TREE_CLIMBING',
  VTC = 'VTC',
  WELCOME_COFFEE = 'WELCOME_COFFEE',
  WORKSPACE_DAY = 'WORKSPACE_DAY',
  WORKSPACE_HALF_DAY = 'WORKSPACE_HALF_DAY',
  YOGA_AND_PILATES = 'YOGA_AND_PILATES'
}

export enum ServiceProvisionUnitEnum {
  DAILY = 'DAILY',
  GROUP = 'GROUP',
  HALF_DAY = 'HALF_DAY',
  INCLUDED = 'INCLUDED',
  INDIVIDUAL = 'INDIVIDUAL',
  NIGHT = 'NIGHT',
  ROOM = 'ROOM',
  SOJOURN = 'SOJOURN'
}

export type SetClientProposalVoteInputDto = {
  clientProposalId: Scalars['String'];
  email: Scalars['String'];
  vote?: InputMaybe<ClientProposalVoteEnum>;
};

export type SetUserFeatureFlagInputDto = {
  enabled: Scalars['Boolean'];
  featureFlag: Scalars['String'];
  userId: Scalars['String'];
};

export type SingleLogObj = {
  __typename?: 'SingleLogObj';
  _id: Scalars['String'];
  bookingId?: Maybe<Scalars['String']>;
  clientFeeling?: Maybe<ClientFeelingEnum>;
  clientRequestId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  house?: Maybe<HouseContext>;
  houseId?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Scalars['String']>>;
  searchFilters?: Maybe<FilterMatchsObj>;
  searchParams?: Maybe<FilterSearchObj>;
  serviceProvider?: Maybe<ServiceProviderOutputDto>;
  serviceProviderId?: Maybe<Scalars['String']>;
  suggestionId?: Maybe<Scalars['String']>;
  threadId?: Maybe<Scalars['String']>;
  type: LogTypeEnum;
  user?: Maybe<UserOutputDto>;
  userId?: Maybe<Scalars['String']>;
  visitorEmail?: Maybe<Scalars['String']>;
  vote?: Maybe<ClientProposalVoteEnum>;
};

export type SiteAdminWordOutputDto = {
  __typename?: 'SiteAdminWordOutputDto';
  description: IntlOutputDto;
  descriptionTitle: IntlOutputDto;
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  role: IntlOutputDto;
  title: IntlOutputDto;
};

export type SiteDataInputDto = {
  domain: Scalars['String'];
};

export type SiteEditorialOutputDto = {
  __typename?: 'SiteEditorialOutputDto';
  adminWord?: Maybe<SiteAdminWordOutputDto>;
  editorialVideo?: Maybe<SiteEditorialVideoOutputDto>;
};

export type SiteEditorialVideoOutputDto = {
  __typename?: 'SiteEditorialVideoOutputDto';
  coverPictureUrl: Scalars['String'];
  url: Scalars['String'];
};

export type SiteLastEventInformationOutputDto = {
  __typename?: 'SiteLastEventInformationOutputDto';
  contactFirstname?: Maybe<Scalars['String']>;
  contactLastname?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  travelType?: Maybe<TravelTypeEnum>;
};

export type SiteLastEventOutputDto = {
  __typename?: 'SiteLastEventOutputDto';
  eventInformation: SiteLastEventInformationOutputDto;
  house: HouseContext;
};

export type SiteMap = {
  __typename?: 'SiteMap';
  _id: Scalars['ID'];
  pathname: Scalars['String'];
};

export type SiteOutputDto = {
  __typename?: 'SiteOutputDto';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  domain: Scalars['String'];
  editorial: SiteEditorialOutputDto;
  name: Scalars['String'];
  pictures: SitePictureOutputDto;
  resources: Array<SiteResourceOutputDto>;
  status: SiteStatusEnum;
  theme: SiteThemeOutputDto;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type SiteOutputDtoResourcesArgs = {
  limit?: InputMaybe<Scalars['Float']>;
};

export type SitePictureOutputDto = {
  __typename?: 'SitePictureOutputDto';
  banner: Scalars['String'];
  icon: Scalars['String'];
  logo: Scalars['String'];
};

export type SiteResourceFileOutputDto = {
  __typename?: 'SiteResourceFileOutputDto';
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type SiteResourceOutputDto = {
  __typename?: 'SiteResourceOutputDto';
  _id: Scalars['ID'];
  coverImageUrl: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  description: IntlOutputDto;
  file: SiteResourceFileOutputDto;
  id: Scalars['String'];
  title: IntlOutputDto;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** The status of the site. */
export enum SiteStatusEnum {
  DEPLOYED = 'DEPLOYED',
  DRAFT = 'DRAFT',
  READY = 'READY'
}

export type SiteThemeOutputDto = {
  __typename?: 'SiteThemeOutputDto';
  background: Scalars['String'];
  btnTextPrimary: Scalars['String'];
  primary: Scalars['String'];
  secondary: Scalars['String'];
  textPrimary: Scalars['String'];
};

export type SpecialConditions = {
  __typename?: 'SpecialConditions';
  /** @deprecated we switched to PDF only -> use `url` */
  text?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type SpecialConditionsDto = {
  text?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type StartEndDates = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type StepUpdatedAtOutputDto = {
  __typename?: 'StepUpdatedAtOutputDto';
  date: Scalars['DateTime'];
  stepNumber: Scalars['Float'];
};

export type SuccessReponseJabbaImport = {
  __typename?: 'SuccessReponseJabbaImport';
  error?: Maybe<Scalars['String']>;
  errorDetails?: Maybe<Scalars['String']>;
  houseId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SuggestionsContext = {
  __typename?: 'SuggestionsContext';
  budget?: Maybe<BudgetSuggestionContext>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  distanceInKilometers?: Maybe<Scalars['Float']>;
  houseId: Scalars['String'];
  isEligibleForClientProposalAddition?: Maybe<Scalars['Boolean']>;
  nbResults?: Maybe<Scalars['Int']>;
  runningTimeMs?: Maybe<Scalars['Int']>;
  scores: ScoresContext;
  travelTimeInSecondForDriving?: Maybe<Scalars['Int']>;
  travelTimeInSecondForTransit?: Maybe<Scalars['Int']>;
};

export enum Transport_Type {
  DRIVING = 'DRIVING',
  TRANSIT = 'TRANSIT'
}

export enum TagCategoryEnum {
  HOUSE_PRIVATE = 'HOUSE_PRIVATE',
  HOUSE_PUBLIC = 'HOUSE_PUBLIC'
}

export type TagOutputDto = {
  __typename?: 'TagOutputDto';
  _id: Scalars['ID'];
  category: TagCategoryEnum;
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  filters: Array<FiltersEnum>;
  icon: Scalars['String'];
  label: Scalars['String'];
  labelIntl: IntlLocalesOutputDto;
  position: Scalars['Int'];
  specialType?: Maybe<TagSpecialTypeEnum>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum TagSpecialTypeEnum {
  CASTLE = 'CASTLE',
  EXECUTIVE = 'EXECUTIVE',
  FOREST_LESS_THAN_15_MINUTES_AWAY_ON_FOOT = 'FOREST_LESS_THAN_15_MINUTES_AWAY_ON_FOOT',
  ICAL_PROVIDED_PRIVATE = 'ICAL_PROVIDED_PRIVATE',
  JABBA = 'JABBA',
  POOL = 'POOL',
  PRIVATISABLE = 'PRIVATISABLE',
  SKI = 'SKI',
  TOP_INTERNATIONAL = 'TOP_INTERNATIONAL',
  TRAIN_ACCESSIBLE_IN_LESS_THAN_15_MINUTES = 'TRAIN_ACCESSIBLE_IN_LESS_THAN_15_MINUTES',
  TRAIN_ACCESSIBLE_ON_FOOT = 'TRAIN_ACCESSIBLE_ON_FOOT',
  UNUSUAL = 'UNUSUAL'
}

export enum TaxIdentifierEnum {
  AUT = 'AUT',
  BEL = 'BEL',
  BGR = 'BGR',
  CHE = 'CHE',
  COR = 'COR',
  CYP = 'CYP',
  CZE = 'CZE',
  DNK = 'DNK',
  EST = 'EST',
  FIN = 'FIN',
  FLO = 'FLO',
  FRA = 'FRA',
  GBR = 'GBR',
  GER = 'GER',
  GRE = 'GRE',
  HRV = 'HRV',
  HUN = 'HUN',
  ICS = 'ICS',
  IRL = 'IRL',
  ISL = 'ISL',
  ITA = 'ITA',
  LIE = 'LIE',
  LTU = 'LTU',
  LUX = 'LUX',
  LVA = 'LVA',
  MAD = 'MAD',
  MAR = 'MAR',
  MAS = 'MAS',
  MCO = 'MCO',
  MLT = 'MLT',
  MNE = 'MNE',
  NLD = 'NLD',
  NOR = 'NOR',
  POL = 'POL',
  POR = 'POR',
  ROU = 'ROU',
  SPA = 'SPA',
  SVK = 'SVK',
  SVN = 'SVN',
  SWE = 'SWE',
  TUR = 'TUR'
}

export type TopActivesOrganizersOutputDto = {
  __typename?: 'TopActivesOrganizersOutputDto';
  contact: ClientRequestContactOutputDto;
  totalAssociations: Scalars['Int'];
};

export type TotalByCurrencyOutputDto = {
  __typename?: 'TotalByCurrencyOutputDto';
  currency: CurrencyEnum;
  total: Scalars['Float'];
};

export type TrainStation = {
  __typename?: 'TrainStation';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  placeId: Scalars['String'];
};

export type TrainStationAdminDto = {
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
};

export enum TransportEnum {
  BUS = 'BUS',
  ELECTRIC_CAR = 'ELECTRIC_CAR',
  PLANE = 'PLANE',
  THERMAL_CAR = 'THERMAL_CAR',
  TRAIN = 'TRAIN'
}

export enum TransportTimeRange {
  LESS_FIFTEEN_MINUTES = 'LESS_FIFTEEN_MINUTES',
  LESS_ONE_HOUR = 'LESS_ONE_HOUR',
  LESS_ONE_HOUR_AND_THIRTY_MINUTES = 'LESS_ONE_HOUR_AND_THIRTY_MINUTES',
  LESS_THIRTY_MINUTES = 'LESS_THIRTY_MINUTES',
  LESS_THREE_HOURS = 'LESS_THREE_HOURS',
  LESS_TWO_HOURS = 'LESS_TWO_HOURS'
}

export type TravelCityContext = {
  __typename?: 'TravelCityContext';
  label: Scalars['String'];
  placeId: Scalars['String'];
};

export type TravelCityModel = {
  __typename?: 'TravelCityModel';
  _id: Scalars['ID'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TravelPoliciesBudgetInputDto = {
  currency: CurrencyEnum;
  price: Scalars['Float'];
};

export type TravelPoliciesBudgetOutputDto = {
  __typename?: 'TravelPoliciesBudgetOutputDto';
  currency: CurrencyEnum;
  price: Scalars['Float'];
};

export type TravelTimeContext = {
  __typename?: 'TravelTimeContext';
  duration?: Maybe<Scalars['Float']>;
  type?: Maybe<Transport_Type>;
};

export type TravelTimeRequested = {
  __typename?: 'TravelTimeRequested';
  maxDurationInSeconds?: Maybe<Scalars['Float']>;
  preferredTransportType?: Maybe<Transport_Type>;
  targetCity?: Maybe<Scalars['String']>;
};

export enum TravelTypeEnum {
  BUSINESS_MEAL = 'BUSINESS_MEAL',
  CORPORATE_EVENING_EVENT = 'CORPORATE_EVENING_EVENT',
  DAILY_TRIP = 'DAILY_TRIP',
  NIGHTLY_TRIP = 'NIGHTLY_TRIP',
  TEAM_BUILDING = 'TEAM_BUILDING',
  TRANSPORT = 'TRANSPORT'
}

export type UnrestrictedPaginationDto = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type UpdateAdminHeaderInputDto = {
  adminId: Scalars['String'];
  hubspot?: InputMaybe<Scalars['String']>;
};

export type UpdateAdminInputDto = {
  billingEntity: BillingEntityEnum;
  email: Scalars['String'];
  firstname: Scalars['String'];
  hubspotInternal?: InputMaybe<Scalars['String']>;
  hubspotMeetingUrl?: InputMaybe<Scalars['String']>;
  lastname: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  profilePicture: Scalars['String'];
  roleId?: InputMaybe<Scalars['String']>;
  slackUserId?: InputMaybe<Scalars['String']>;
  teamsMeetingUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateArticleInputDto = {
  abstractContent?: InputMaybe<Scalars['String']>;
  authorId?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<ArticleCategoryEnum>>;
  content?: InputMaybe<Scalars['String']>;
  illustration?: InputMaybe<ArticleIllustrationInputDto>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ArticleStatusEnum>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateBedroomsInfosDto = {
  bedrooms: Array<BedroomDto>;
  maximumNumberOfTravellers?: InputMaybe<Scalars['Float']>;
  numberOfBathrooms?: InputMaybe<Scalars['Float']>;
  numberOfBedrooms?: InputMaybe<Scalars['Float']>;
  numberOfBeds?: InputMaybe<Scalars['Float']>;
  numberOfTwins?: InputMaybe<Scalars['Float']>;
};

export type UpdateBillingTransferHeaderInputDto = {
  status: BillingTransferStatusEnum;
};

export type UpdateBillingTransferInformationInputDto = {
  adminFinanceId?: InputMaybe<Scalars['String']>;
  adminSalesId?: InputMaybe<Scalars['String']>;
  billingInformation?: InputMaybe<BillingTransferBillInformationInputDto>;
  clientDocuments?: InputMaybe<Array<DocumentInputDto>>;
  companyId: Scalars['String'];
  nabooDocument?: InputMaybe<BillingTransferNabooDocumentInputDto>;
  userId: Scalars['String'];
};

export type UpdateBillingTransferPaymentInputDto = {
  date: Scalars['DateTime'];
  effectivePayment: Scalars['Float'];
  paymentId: Scalars['String'];
};

export type UpdateClientPricingItemInputDto = {
  clientPricingItemId: Scalars['String'];
  quantity: Scalars['Int'];
  vatPrices: Array<UpdateClientPricingItemVatPricesInputDto>;
};

export type UpdateClientPricingItemVatPricesInputDto = {
  priceWithoutVat: Scalars['Float'];
  vatRate: Scalars['Float'];
};

export type UpdateClientProposalPositionInputDto = {
  clientProposalId: Scalars['String'];
  clientRequestId: Scalars['String'];
  newPosition: Scalars['Int'];
};

export type UpdateClientRequestBriefAdminInputDto = {
  adminCsmId?: InputMaybe<Scalars['String']>;
  adminFinanceId?: InputMaybe<Scalars['String']>;
  adminSalesId?: InputMaybe<Scalars['String']>;
  billingEntity: BillingEntityEnum;
  briefDescription?: InputMaybe<Scalars['String']>;
  briefOwner?: InputMaybe<Scalars['String']>;
  briefTitle: Scalars['String'];
  companyId?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<ClientRequestBriefContactInputDto>;
  freeFieldPdf?: InputMaybe<Scalars['String']>;
  gbv?: InputMaybe<Scalars['Float']>;
  glideLink?: InputMaybe<Scalars['String']>;
  hubspotNumber: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
  purchaseOrder?: InputMaybe<Scalars['String']>;
};

export type UpdateClientRequestHeaderAdminInputDto = {
  status: ClientRequestStatusEnum;
};

export type UpdateClientRequestSettingsAdminDataInputDto = {
  isCompanyHidden: Scalars['Boolean'];
  mailParams: ClientRequestMailParamsInputDto;
};

export type UpdateCompaniesFromParentCompanyInputDto = {
  companyIds: Array<Scalars['String']>;
  parentCompanyId: Scalars['String'];
};

export type UpdateCompanyInformationsAdminInputDto = {
  accountingAddress?: InputMaybe<Scalars['String']>;
  adminLinkedId?: InputMaybe<Scalars['String']>;
  billingTransfer?: InputMaybe<CompanyBillingTransferInputDto>;
  contactFirstname?: InputMaybe<Scalars['String']>;
  contactLastname?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<CompanyContractInputDto>;
  extension?: InputMaybe<Scalars['String']>;
  logoURL?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  siret?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanySettingsAdminInputDto = {
  blacklistedInLanding: Scalars['Boolean'];
  companyId: Scalars['String'];
};

export type UpdateCompanyTravelPoliciesInputDto = {
  authorizedHouseTypes: Array<HouseTypeEnum>;
  budget: BudgetByTravelTypeInputDto;
};

export type UpdateCustomHouseFaqInputDto = {
  _id: Scalars['String'];
  answer?: InputMaybe<Scalars['String']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Float']>;
  question?: InputMaybe<Scalars['String']>;
};

export type UpdateDefaultHouseFaqInputDto = {
  _id: Scalars['String'];
  answer?: InputMaybe<Scalars['String']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['Float']>;
};

export type UpdateEditorialInputDto = {
  adminWord?: InputMaybe<AdminWordInputDto>;
  editorialVideo?: InputMaybe<EditorialVideoInputDto>;
};

export type UpdateEquipmentInputDto = {
  category: EquipmentCategoryEnum;
  filters?: Array<FiltersEnum>;
  icon: Scalars['String'];
  labelIntl: IntlInputDto;
  position: Scalars['Float'];
};

export type UpdateHouseCertificationAdminDto = {
  adminLinkedId?: InputMaybe<Scalars['String']>;
  ambiance?: InputMaybe<AmbianceEnum>;
  arrival?: InputMaybe<Scalars['String']>;
  carbonFootprint?: InputMaybe<HouseCarbonFootprintDto>;
  departure?: InputMaybe<Scalars['String']>;
  feesRate: Scalars['Int'];
  houseType?: InputMaybe<HouseTypeEnum>;
  locale: IntlLocales;
  networks?: InputMaybe<Array<CreateNetworkAdminDto>>;
  ownerId?: InputMaybe<Scalars['String']>;
  placeId: Scalars['String'];
  priceType?: InputMaybe<HousePriceTypeEnum>;
  residentialBookingType: HouseBookingTypeEnum;
  singleDayBookingType: HouseBookingTypeEnum;
  title?: InputMaybe<Scalars['String']>;
  trainStation?: InputMaybe<TrainStationAdminDto>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateHouseDescriptionDto = {
  description: HouseDescriptionInputDto;
  houseId: Scalars['String'];
  memo: Scalars['String'];
  specialConditions?: InputMaybe<SpecialConditionsDto>;
  tags: Array<Scalars['String']>;
};

export type UpdateHouseHeaderAdminDto = {
  hubspot?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<HouseStatus>;
};

export type UpdateHousePictureDto = {
  _id: Scalars['String'];
  bedroomId?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  position: Scalars['Float'];
  type: HousePictureEnum;
  uri: Scalars['String'];
};

export type UpdateHouseServiceInputDto = {
  category?: InputMaybe<ServiceProviderCategoryEnum>;
  position: Scalars['Int'];
  recommended?: InputMaybe<Scalars['Boolean']>;
  serviceProviderId: Scalars['String'];
};

export type UpdateHouseServicesExclusivityInputDto = {
  activities?: Scalars['Boolean'];
  mobility?: Scalars['Boolean'];
  restoration?: Scalars['Boolean'];
};

export type UpdateHouseServicesInputDto = {
  houseId: Scalars['String'];
  houseServicesExclusivity: UpdateHouseServicesExclusivityInputDto;
  services: Array<UpdateHouseServiceInputDto>;
};

export type UpdateLinkedHousesServiceInputDto = {
  houses: Array<HouseIsDispoServiceInputDto>;
  serviceProviderId: Scalars['String'];
};

export type UpdateMarketplaceInputDto = {
  companyId?: InputMaybe<Scalars['String']>;
  marketplaceId: Scalars['String'];
  name: Scalars['String'];
  pictures?: InputMaybe<MarketplacePictureInputDto>;
  theme?: InputMaybe<MarketplaceThemeInputDto>;
};

export type UpdateMarketplaceStatusInputDto = {
  marketplaceId: Scalars['String'];
  status: SiteStatusEnum;
};

export type UpdateOwnerHeaderAdminInputDto = {
  hubspot?: InputMaybe<Scalars['String']>;
};

export type UpdateOwnerInformationsAdminInputDto = {
  companyName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  houses: Array<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  lastname: Scalars['String'];
  phone: Scalars['String'];
  placeId: Scalars['String'];
  siret?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateQueryResultIdsInputDto = {
  resultIds: Array<Scalars['String']>;
  searchId: Scalars['String'];
  sessionId: Scalars['String'];
};

export type UpdateServiceOwnerDto = {
  companyName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  hubspot?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  siret?: InputMaybe<Scalars['String']>;
  vatNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateServiceProviderDescriptionAdminInputDto = {
  description?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
};

export type UpdateServiceProviderHeaderAdminInputDto = {
  hubspot?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ServiceProviderStatusEnum>;
};

export type UpdateServiceProviderInformationsAdminInputDto = {
  adminOpsId?: InputMaybe<Scalars['String']>;
  category: ServiceProviderCategoryEnum;
  email?: InputMaybe<Scalars['String']>;
  houseId?: InputMaybe<Scalars['String']>;
  hubspot: Scalars['String'];
  isVisible: Scalars['Boolean'];
  maxDistance?: InputMaybe<Scalars['Float']>;
  phone?: InputMaybe<Scalars['String']>;
  placeId: Scalars['String'];
  serviceOwnerId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ServiceProviderStatusEnum>;
  title: Scalars['String'];
  websiteURL?: InputMaybe<Scalars['String']>;
};

export type UpdateTagInputDto = {
  category: TagCategoryEnum;
  filters?: Array<FiltersEnum>;
  icon: Scalars['String'];
  labelIntl: IntlInputDto;
  position: Scalars['Float'];
};

export type UpdateUserInformationsAdminDto = {
  companyId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  lastname?: InputMaybe<Scalars['String']>;
  locale: IntlLocales;
  miceRole?: InputMaybe<CompanyRoleEnum>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInformationsUserInputDto = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UserLogDto = {
  clientFeeling?: InputMaybe<ClientFeelingEnum>;
  clientRequestId?: InputMaybe<Scalars['String']>;
  houseId?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Array<Scalars['String']>>;
  searchFilters?: InputMaybe<FilterMatchsDto>;
  searchParams?: InputMaybe<FilterSearchDto>;
  serviceProviderId?: InputMaybe<Scalars['String']>;
  suggestionId?: InputMaybe<Scalars['String']>;
  threadId?: InputMaybe<Scalars['String']>;
  type: LogTypeEnum;
};

export type UserMiceFilterInputDto = {
  companiesId?: InputMaybe<Array<Scalars['String']>>;
  q?: InputMaybe<Scalars['String']>;
};

export type UserMiceInputDto = {
  filters: UserMiceFilterInputDto;
  paginationArgsBackward?: InputMaybe<BackwardPaginationInputDto>;
  paginationArgsForward?: InputMaybe<ForwardPaginationInputDto>;
};

export type UserOutputDto = {
  __typename?: 'UserOutputDto';
  IASearchOn24h?: Maybe<Scalars['Float']>;
  _id: Scalars['ID'];
  canTransferBills?: Maybe<Scalars['Boolean']>;
  company?: Maybe<CompanyOutputDto>;
  companyId?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Identifies if a document was soft deleted. */
  deleted?: Maybe<Scalars['Boolean']>;
  detailedName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  featureFlags: Array<Scalars['String']>;
  filledInformationStatus?: Maybe<Scalars['Boolean']>;
  firstname?: Maybe<Scalars['String']>;
  housePageVisitedOn24h?: Maybe<Scalars['Float']>;
  hubspot?: Maybe<Scalars['String']>;
  isManager?: Maybe<Scalars['Boolean']>;
  isPasswordFilled?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  lastConnect?: Maybe<Scalars['DateTime']>;
  lastname?: Maybe<Scalars['String']>;
  locale: IntlLocales;
  marketplaceDomain?: Maybe<Scalars['String']>;
  miceRole?: Maybe<CompanyRoleEnum>;
  name?: Maybe<Scalars['String']>;
  organizedEventCount?: Maybe<Scalars['Float']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  provider?: Maybe<UserProviderTypeEnum>;
  searchOn24h?: Maybe<Scalars['Float']>;
  siteUrl?: Maybe<Scalars['String']>;
  stripeId?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  userQuotation24h?: Maybe<Scalars['Float']>;
};

export type UserOutputDtoEdge = {
  __typename?: 'UserOutputDtoEdge';
  cursor: Scalars['String'];
  node: UserOutputDto;
};

export type UserOutputDtoPageInfo = {
  __typename?: 'UserOutputDtoPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export enum UserProviderTypeEnum {
  AZURE = 'AZURE',
  CREDENTIALS = 'CREDENTIALS',
  GOOGLE = 'GOOGLE'
}

export enum UserStatusEnum {
  DELETED = 'DELETED',
  IN_NABOO = 'IN_NABOO'
}

export type ValidateAccountDto = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type VerifiedToken = {
  __typename?: 'VerifiedToken';
  _id: Scalars['String'];
  email: Scalars['String'];
  token: ConsumableTokenOutputDto;
};

export enum WasteTypeEnum {
  NONE = 'NONE',
  SELECTIVE_SORTING = 'SELECTIVE_SORTING',
  SELECTIVE_SORTING_AND_COMPOST = 'SELECTIVE_SORTING_AND_COMPOST'
}

export enum WifiTypeEnum {
  ADSL_VDSL = 'ADSL_VDSL',
  BOX_FOUR_G = 'BOX_FOUR_G',
  OPTICAL_FIBER = 'OPTICAL_FIBER',
  SATELLITE = 'SATELLITE'
}

export type CreatePasswordInputDto = {
  confirmPassword: Scalars['String'];
  password: Scalars['String'];
};

export type LoginMutationVariables = Exact<{
  inputs: AuthDto;
}>;


export type LoginMutation = { __typename?: 'Mutation', loginOwner: { __typename?: 'HouseOwnerOutputDto', _id: string, email?: string | null, firstname?: string | null, lastname?: string | null, status?: HouseOwnerStatusEnum | null, notifications?: number | null, hasPassword?: boolean | null, houses?: Array<{ __typename?: 'HouseContext', _id: string, readableId?: string | null, title: string, pathname?: string | null, taxIdentifier: TaxIdentifierEnum, priceType: HousePriceTypeEnum, residentialBookingType: HouseBookingTypeEnum, singleDayBookingType: HouseBookingTypeEnum, status: HouseStatus, ownerSpaceMode?: OwnerSpaceModeEnum | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> }, specialConditions: { __typename?: 'SpecialConditions', url: string }, pictures: Array<{ __typename?: 'HousePictureContext', _id: string, uri: string }>, admin?: { __typename?: 'AdminOutputDto', firstname?: string | null, label?: string | null, profilePicture?: string | null, email?: string | null } | null }> | null } };

export type LoginOwnerByTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type LoginOwnerByTokenMutation = { __typename?: 'Mutation', loginOwnerByToken: { __typename?: 'LoginOwnerByTokenOutputDto', isAuthenticateTokenExpired: boolean, owner?: { __typename?: 'HouseOwnerOutputDto', _id: string, email?: string | null, firstname?: string | null, lastname?: string | null, status?: HouseOwnerStatusEnum | null, notifications?: number | null, hasPassword?: boolean | null, houses?: Array<{ __typename?: 'HouseContext', _id: string, readableId?: string | null, title: string, pathname?: string | null, taxIdentifier: TaxIdentifierEnum, priceType: HousePriceTypeEnum, residentialBookingType: HouseBookingTypeEnum, singleDayBookingType: HouseBookingTypeEnum, status: HouseStatus, ownerSpaceMode?: OwnerSpaceModeEnum | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> }, specialConditions: { __typename?: 'SpecialConditions', url: string }, pictures: Array<{ __typename?: 'HousePictureContext', _id: string, uri: string }>, admin?: { __typename?: 'AdminOutputDto', firstname?: string | null, label?: string | null, profilePicture?: string | null, email?: string | null } | null }> | null } | null } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logoutHouseOwner: { __typename?: 'ResponseLogout', success: boolean } };

export type GetHouseOwnerByTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetHouseOwnerByTokenQuery = { __typename?: 'Query', getHouseOwnerByToken: { __typename?: 'VerifiedToken', email: string, token: { __typename?: 'ConsumableTokenOutputDto', token: string, type: ConsumableTokenTypeEnum } } };

export type ValidateAccountHouseOwnerMutationVariables = Exact<{
  dto: ValidateAccountDto;
}>;


export type ValidateAccountHouseOwnerMutation = { __typename?: 'Mutation', validateAccountHouseOwner: { __typename?: 'EmailPayload', email: string } };

export type CreateHouseOwnerPasswordMutationVariables = Exact<{
  dto: CreatePasswordInputDto;
}>;


export type CreateHouseOwnerPasswordMutation = { __typename?: 'Mutation', createHouseOwnerPassword: { __typename?: 'SuccessResponse', error?: string | null, success: boolean } };

export type ForgotPasswordHouseOwnerMutationVariables = Exact<{
  dto: ForgotPasswordDto;
}>;


export type ForgotPasswordHouseOwnerMutation = { __typename?: 'Mutation', forgotPasswordHouseOwner: boolean };

export type ResetPasswordHouseOwnerMutationVariables = Exact<{
  dto: ResetPasswordDto;
}>;


export type ResetPasswordHouseOwnerMutation = { __typename?: 'Mutation', resetPasswordHouseOwner: { __typename?: 'EmailPayload', email: string } };

export type RegenerateAuthenticateTokenMutationVariables = Exact<{
  url: Scalars['String'];
}>;


export type RegenerateAuthenticateTokenMutation = { __typename?: 'Mutation', regenerateAuthenticateToken: { __typename?: 'SuccessResponse', error?: string | null, success: boolean } };

export type ClientRequestDepositOwnerFragment = { __typename?: 'ClientRequestPaymentOutputDto', depositRate?: number | null, status?: ClientRequestPaymentStatusEnum | null, price?: { __typename?: 'BookingPrice', totalUser?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null } | null };

export type GetPdfsByClientRequestIdMutationVariables = Exact<{
  clientRequestId: Scalars['String'];
  pdfTypes: Array<PdfTypeEnum> | PdfTypeEnum;
  clientProposalId?: InputMaybe<Scalars['String']>;
  regenerate?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPdfsByClientRequestIdMutation = { __typename?: 'Mutation', getPdfsByClientRequestId: Array<{ __typename?: 'PdfOutputDto', filename: string, url?: string | null }> };

export type GenerateClientRequestDocumentsMutationVariables = Exact<{
  clientRequestId: Scalars['String'];
  clientProposalId?: InputMaybe<Scalars['String']>;
  pdfs: Array<PdfTypeEnum> | PdfTypeEnum;
}>;


export type GenerateClientRequestDocumentsMutation = { __typename?: 'Mutation', generateClientRequestDocuments: Array<{ __typename?: 'PdfOutputDto', url?: string | null }> };

export type GetClientRequestByProposalIdQueryVariables = Exact<{
  clientProposalId: Scalars['String'];
  serviceOwnerId?: InputMaybe<Scalars['String']>;
}>;


export type GetClientRequestByProposalIdQuery = { __typename?: 'Query', getClientRequestByProposalId: { __typename?: 'ClientRequestOutputDto', _id: string, readableId: string, status?: ClientRequestStatusEnum | null, gbv?: number | null, createdAt?: any | null, updatedAt?: any | null, selectedProposalId?: string | null, briefOwner?: string | null, pdfOwnerDocumentType?: Array<PdfTypeEnum> | null, shouldGenerateDocuments?: Array<PdfTypeEnum> | null, currentUserIsContact: boolean, type: TravelTypeEnum, company?: { __typename?: 'CompanyOutputDto', name: string, logoURL: string } | null, adminSales?: { __typename?: 'AdminOutputDto', _id: string, firstname?: string | null, lastname?: string | null, email?: string | null, profilePicture?: string | null } | null, adminCsm?: { __typename?: 'AdminOutputDto', _id: string, firstname?: string | null, lastname?: string | null, email?: string | null, profilePicture?: string | null } | null, selectedProposal?: { __typename?: 'ClientProposalOutputDto', _id: string, type: TravelTypeEnum, houseBookingType?: HouseBookingTypeEnum | null, briefOwner: string, clientRequestId: string, privatizationStatus?: PrivatizationStatusEnum | null, houseId?: string | null, startDate?: any | null, endDate?: any | null, arrivalHour?: string | null, departureHour?: string | null, adults?: number | null, isDeclinedByOwner?: boolean | null, userCurrentAction?: ClientProposalUserActionEnum | null, ownerCurrentAction?: ClientProposalOwnerActionEnum | null, userPaidDepositAt?: any | null, adminSkippedDepositPaymentAt?: any | null, hidePrices?: boolean | null, ownerAskedAdjustmentsModificationAt?: any | null, quotationConfirmedAt?: any | null, permissions: { __typename?: 'ClientProposalPermissionsOutputDto', canCancelStepSeven: boolean, canEditPricingItems: boolean, canOverrideUserFeesVatRate: boolean, canReadBriefOwner: boolean, canUpdateProposal: boolean, canValidateStepFiveWithoutBalancePayment: boolean, canValidateStepThreeWithoutDepositPayment: boolean, canCancelUserConfirmedBooking: boolean }, house?: { __typename?: 'HouseContext', _id: string, taxIdentifier: TaxIdentifierEnum, title: string, priceType: HousePriceTypeEnum, departure: string, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number>, multiVatRates?: Array<Array<number>> | null }, address?: { __typename?: 'AddressContext', country?: string | null, city?: string | null, street?: string | null, postalCode?: string | null } | null, owner?: { __typename?: 'HouseOwnerOutputDto', firstname?: string | null, lastname?: string | null, vatNumber?: string | null, siret?: string | null, email?: string | null, address?: { __typename?: 'AddressContext', street?: string | null, city?: string | null, postalCode?: string | null } | null } | null, bedrooms: Array<{ __typename?: 'HouseBedroomContext', capacity?: number | null }>, specialConditions: { __typename?: 'SpecialConditions', url: string }, options: { __typename: 'HouseOptionsGlobal', corporateEvening: { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } | { __typename: 'HouseOptionsIndividual', corporateEvening: { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } } | null, price?: { __typename?: 'BookingPrice', priceItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, totalUser?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, feesWithDiscount?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, vatPrices?: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> | null } | null, totalPerVatRates?: Array<{ __typename?: 'PriceObjectOutputDto', priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null }> | null } | null, clientPricingItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, adjustmentPrices?: Array<{ __typename?: 'ClientPricingItemOutputDto', adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, planning?: Array<{ __typename?: 'PlanningItemsByDate', date?: any | null, planningItems: Array<{ __typename?: 'ClientPricingItemPlanningOutputDto', _id: string, clientPricingItemId: string, date?: any | null, position: number, quantity: number, clientPricingItem: { __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null } }> }> | null, carbonFootprint?: { __typename?: 'ClientCarbonFootprintOutputDto', transport?: TransportEnum | null, lastKmsTransport?: LastKmsTransportEnum | null, mealsType?: MealsTypeEnum | null, departureCity?: { __typename?: 'ClientCarbonFootprintDepartureCityOutputDto', description: string, distanceInMeters: number, placeId: string } | null, carbonEmissions?: { __typename?: 'CarbonEmissionsOutputDto', accommodationEmissionsCount?: number | null, activitiesEmissionsCount?: number | null, cateringEmissionsCount?: number | null, totalEmissionsCount?: number | null, transportEmissionsCount?: number | null } | null } | null, state?: { __typename?: 'ClientProposalStateOutputDto', ownerAction?: ClientProposalStateOwnerActionEnum | null } | null, ownerUploadedQuotation?: { __typename?: 'ClientProposalOwnerUploadedQuotationOutputDto', at: any, quotationFileHistory: Array<{ __typename?: 'ClientProposalQuotationFileOutputDto', url: string }> } | null } | null, stepUser?: { __typename?: 'ClientRequestStepOutputDto', stepNumber: number, stepState?: ClientRequestStepStateEnum | null, stepsUpdatedAt?: Array<{ __typename?: 'StepUpdatedAtOutputDto', stepNumber: number, date: any }> | null } | null, stepOwner?: { __typename?: 'ClientRequestStepOutputDto', stepNumber: number, stepState?: ClientRequestStepStateEnum | null, stepsUpdatedAt?: Array<{ __typename?: 'StepUpdatedAtOutputDto', stepNumber: number, date: any }> | null } | null, contact?: { __typename?: 'ClientRequestContactOutputDto', firstname?: string | null, lastname?: string | null, mail?: string | null, phone?: string | null } | null, clientProposal?: { __typename?: 'ClientProposalOutputDto', _id: string, type: TravelTypeEnum, houseBookingType?: HouseBookingTypeEnum | null, briefOwner: string, clientRequestId: string, privatizationStatus?: PrivatizationStatusEnum | null, houseId?: string | null, startDate?: any | null, endDate?: any | null, arrivalHour?: string | null, departureHour?: string | null, adults?: number | null, isDeclinedByOwner?: boolean | null, userCurrentAction?: ClientProposalUserActionEnum | null, ownerCurrentAction?: ClientProposalOwnerActionEnum | null, userPaidDepositAt?: any | null, adminSkippedDepositPaymentAt?: any | null, hidePrices?: boolean | null, ownerAskedAdjustmentsModificationAt?: any | null, quotationConfirmedAt?: any | null, permissions: { __typename?: 'ClientProposalPermissionsOutputDto', canCancelStepSeven: boolean, canEditPricingItems: boolean, canOverrideUserFeesVatRate: boolean, canReadBriefOwner: boolean, canUpdateProposal: boolean, canValidateStepFiveWithoutBalancePayment: boolean, canValidateStepThreeWithoutDepositPayment: boolean, canCancelUserConfirmedBooking: boolean }, house?: { __typename?: 'HouseContext', _id: string, taxIdentifier: TaxIdentifierEnum, title: string, priceType: HousePriceTypeEnum, departure: string, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number>, multiVatRates?: Array<Array<number>> | null }, address?: { __typename?: 'AddressContext', country?: string | null, city?: string | null, street?: string | null, postalCode?: string | null } | null, owner?: { __typename?: 'HouseOwnerOutputDto', firstname?: string | null, lastname?: string | null, vatNumber?: string | null, siret?: string | null, email?: string | null, address?: { __typename?: 'AddressContext', street?: string | null, city?: string | null, postalCode?: string | null } | null } | null, bedrooms: Array<{ __typename?: 'HouseBedroomContext', capacity?: number | null }>, specialConditions: { __typename?: 'SpecialConditions', url: string }, options: { __typename: 'HouseOptionsGlobal', corporateEvening: { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } | { __typename: 'HouseOptionsIndividual', corporateEvening: { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } } | null, price?: { __typename?: 'BookingPrice', priceItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, totalUser?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, feesWithDiscount?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, vatPrices?: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> | null } | null, totalPerVatRates?: Array<{ __typename?: 'PriceObjectOutputDto', priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null }> | null } | null, clientPricingItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, adjustmentPrices?: Array<{ __typename?: 'ClientPricingItemOutputDto', adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, planning?: Array<{ __typename?: 'PlanningItemsByDate', date?: any | null, planningItems: Array<{ __typename?: 'ClientPricingItemPlanningOutputDto', _id: string, clientPricingItemId: string, date?: any | null, position: number, quantity: number, clientPricingItem: { __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null } }> }> | null, carbonFootprint?: { __typename?: 'ClientCarbonFootprintOutputDto', transport?: TransportEnum | null, lastKmsTransport?: LastKmsTransportEnum | null, mealsType?: MealsTypeEnum | null, departureCity?: { __typename?: 'ClientCarbonFootprintDepartureCityOutputDto', description: string, distanceInMeters: number, placeId: string } | null, carbonEmissions?: { __typename?: 'CarbonEmissionsOutputDto', accommodationEmissionsCount?: number | null, activitiesEmissionsCount?: number | null, cateringEmissionsCount?: number | null, totalEmissionsCount?: number | null, transportEmissionsCount?: number | null } | null } | null, state?: { __typename?: 'ClientProposalStateOutputDto', ownerAction?: ClientProposalStateOwnerActionEnum | null } | null, ownerUploadedQuotation?: { __typename?: 'ClientProposalOwnerUploadedQuotationOutputDto', at: any, quotationFileHistory: Array<{ __typename?: 'ClientProposalQuotationFileOutputDto', url: string }> } | null } | null, confirmationData?: { __typename?: 'ClientRequestConfirmationDataOutputDto', isConfirmed?: boolean | null, confirmationDate?: any | null, confirmedByOwner?: any | null, confirmedByUser?: any | null } | null, deposit?: { __typename?: 'ClientRequestPaymentOutputDto', status?: ClientRequestPaymentStatusEnum | null } | null, balance?: { __typename?: 'ClientRequestPaymentOutputDto', status?: ClientRequestPaymentStatusEnum | null } | null, balancePostFinal?: { __typename?: 'ClientRequestPaymentOutputDto', status?: ClientRequestPaymentStatusEnum | null } | null, permissions: { __typename?: 'ClientRequestPermissionsOutputDto', canEdit: boolean } } };

export type GetPdfsByClientProposalIdQueryVariables = Exact<{
  pdfTypes: Array<PdfTypeEnum> | PdfTypeEnum;
  clientRequestId: Scalars['String'];
  clientProposalId: Scalars['String'];
}>;


export type GetPdfsByClientProposalIdQuery = { __typename?: 'Query', getPdfsByClientProposalId: Array<{ __typename?: 'PdfOutputDto', url?: string | null, pdfType?: PdfTypeEnum | null, filename: string }> };

export type GetClientRequestsVisibleByOwnerByHouseIdQueryVariables = Exact<{
  houseId: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  filters: ClientProposalOwnerListInputDto;
}>;


export type GetClientRequestsVisibleByOwnerByHouseIdQuery = { __typename?: 'Query', getClientRequestsVisibleByOwnerByHouseId: Array<{ __typename?: 'ClientRequestOutputDto', _id: string, readableId: string, createdAt?: any | null, company?: { __typename?: 'CompanyOutputDto', name: string, logoURL: string } | null, adminSales?: { __typename?: 'AdminOutputDto', name?: string | null } | null, adminCsm?: { __typename?: 'AdminOutputDto', name?: string | null } | null, stepOwner?: { __typename?: 'ClientRequestStepOutputDto', stepNumber: number } | null, clientProposal?: { __typename?: 'ClientProposalOutputDto', type: TravelTypeEnum, _id: string, startDate?: any | null, endDate?: any | null, arrivalHour?: string | null, departureHour?: string | null, adults?: number | null, readByOwner: boolean, state?: { __typename?: 'ClientProposalStateOutputDto', ownerStatus?: ClientProposalStateOwnerStatusEnum | null, ownerAction?: ClientProposalStateOwnerActionEnum | null } | null } | null }> };

export type OwnerUploadedQuotationMutationVariables = Exact<{
  clientProposalId: Scalars['String'];
  ownerUploadedQuotationInputs: ClientProposalOwnerUploadedQuotationInputDto;
}>;


export type OwnerUploadedQuotationMutation = { __typename?: 'Mutation', ownerUploadedQuotation: { __typename?: 'SuccessResponse', success: boolean } };

export type OwnerConfirmedQuotationMutationVariables = Exact<{
  clientProposalId: Scalars['String'];
  ownerConfirmedQuotationInputs: ClientProposalOwnerConfirmedQuotationInputDto;
}>;


export type OwnerConfirmedQuotationMutation = { __typename?: 'Mutation', ownerConfirmedQuotation: { __typename?: 'SuccessResponse', success: boolean } };

export type OwnerDeclinedQuotationMutationVariables = Exact<{
  clientProposalId: Scalars['String'];
}>;


export type OwnerDeclinedQuotationMutation = { __typename?: 'Mutation', ownerDeclinedQuotation: { __typename?: 'SuccessResponse', success: boolean } };

export type OwnerDeclinedBookingMutationVariables = Exact<{
  clientProposalId: Scalars['String'];
}>;


export type OwnerDeclinedBookingMutation = { __typename?: 'Mutation', ownerDeclinedBooking: { __typename?: 'SuccessResponse', success: boolean } };

export type OwnerConfirmedBookingMutationVariables = Exact<{
  clientProposalId: Scalars['String'];
  depositRate: Scalars['Float'];
}>;


export type OwnerConfirmedBookingMutation = { __typename?: 'Mutation', ownerConfirmedBooking: Array<PdfTypeEnum> };

export type OwnerConfirmedAdjustmentsMutationVariables = Exact<{
  clientProposalId: Scalars['String'];
}>;


export type OwnerConfirmedAdjustmentsMutation = { __typename?: 'Mutation', ownerConfirmedAdjustments: Array<PdfTypeEnum> };

export type OwnerAskedAdjustmentsModificationMutationVariables = Exact<{
  clientProposalId: Scalars['String'];
  message: Scalars['String'];
}>;


export type OwnerAskedAdjustmentsModificationMutation = { __typename?: 'Mutation', ownerAskedAdjustmentsModification: { __typename?: 'SuccessResponse', success: boolean } };

export type OwnerCreatedQuoteProvisionMutationVariables = Exact<{
  clientProposalId: Scalars['String'];
  quoteProvisionInputs: ClientProposalCreateQuoteProvisionInputDto;
}>;


export type OwnerCreatedQuoteProvisionMutation = { __typename?: 'Mutation', ownerCreatedQuoteProvision: { __typename?: 'SuccessResponse', success: boolean, error?: string | null } };

export type OwnerUpdatedQuoteProvisionMutationVariables = Exact<{
  clientProposalId: Scalars['String'];
  quoteProvisionInputs: ClientProposalUpdateQuoteProvisionInputDto;
}>;


export type OwnerUpdatedQuoteProvisionMutation = { __typename?: 'Mutation', ownerUpdatedQuoteProvision: { __typename?: 'SuccessResponse', success: boolean } };

export type OwnerDeletedQuoteProvisionMutationVariables = Exact<{
  clientPricingItemId: Scalars['String'];
  clientProposalId: Scalars['String'];
}>;


export type OwnerDeletedQuoteProvisionMutation = { __typename?: 'Mutation', ownerDeletedQuoteProvision: { __typename?: 'SuccessResponse', success: boolean } };

export type OwnerCanceledQuoteProvisionSuppressionMutationVariables = Exact<{
  clientPricingItemId: Scalars['String'];
  clientProposalId: Scalars['String'];
}>;


export type OwnerCanceledQuoteProvisionSuppressionMutation = { __typename?: 'Mutation', ownerCanceledQuoteProvisionSuppression: { __typename?: 'SuccessResponse', success: boolean } };

export type CheckMultiVatRatesValidityQueryVariables = Exact<{
  clientProposalId: Scalars['String'];
  quoteProvisionInputs: ClientProposalCheckMultiVatRatesValidityInputDto;
}>;


export type CheckMultiVatRatesValidityQuery = { __typename?: 'Query', checkMultiVatRatesValidity: boolean };

export type OwnerUpdatedQuoteProvisionsPositionsMutationVariables = Exact<{
  clientPricingItemsIds: Array<Scalars['String']> | Scalars['String'];
  clientProposalId: Scalars['String'];
}>;


export type OwnerUpdatedQuoteProvisionsPositionsMutation = { __typename?: 'Mutation', ownerUpdatedQuoteProvisionsPositions: { __typename?: 'SuccessResponse', success: boolean } };

export type ClientProposalFragment = { __typename?: 'ClientProposalOutputDto', _id: string, type: TravelTypeEnum, houseBookingType?: HouseBookingTypeEnum | null, briefOwner: string, clientRequestId: string, privatizationStatus?: PrivatizationStatusEnum | null, houseId?: string | null, startDate?: any | null, endDate?: any | null, arrivalHour?: string | null, departureHour?: string | null, adults?: number | null, isDeclinedByOwner?: boolean | null, userCurrentAction?: ClientProposalUserActionEnum | null, ownerCurrentAction?: ClientProposalOwnerActionEnum | null, userPaidDepositAt?: any | null, adminSkippedDepositPaymentAt?: any | null, hidePrices?: boolean | null, ownerAskedAdjustmentsModificationAt?: any | null, quotationConfirmedAt?: any | null, permissions: { __typename?: 'ClientProposalPermissionsOutputDto', canCancelStepSeven: boolean, canEditPricingItems: boolean, canOverrideUserFeesVatRate: boolean, canReadBriefOwner: boolean, canUpdateProposal: boolean, canValidateStepFiveWithoutBalancePayment: boolean, canValidateStepThreeWithoutDepositPayment: boolean, canCancelUserConfirmedBooking: boolean }, house?: { __typename?: 'HouseContext', _id: string, taxIdentifier: TaxIdentifierEnum, title: string, priceType: HousePriceTypeEnum, departure: string, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number>, multiVatRates?: Array<Array<number>> | null }, address?: { __typename?: 'AddressContext', country?: string | null, city?: string | null, street?: string | null, postalCode?: string | null } | null, owner?: { __typename?: 'HouseOwnerOutputDto', firstname?: string | null, lastname?: string | null, vatNumber?: string | null, siret?: string | null, email?: string | null, address?: { __typename?: 'AddressContext', street?: string | null, city?: string | null, postalCode?: string | null } | null } | null, bedrooms: Array<{ __typename?: 'HouseBedroomContext', capacity?: number | null }>, specialConditions: { __typename?: 'SpecialConditions', url: string }, options: { __typename: 'HouseOptionsGlobal', corporateEvening: { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } | { __typename: 'HouseOptionsIndividual', corporateEvening: { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } } | null, price?: { __typename?: 'BookingPrice', priceItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, totalUser?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, feesWithDiscount?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, vatPrices?: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> | null } | null, totalPerVatRates?: Array<{ __typename?: 'PriceObjectOutputDto', priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null }> | null } | null, clientPricingItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, adjustmentPrices?: Array<{ __typename?: 'ClientPricingItemOutputDto', adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, planning?: Array<{ __typename?: 'PlanningItemsByDate', date?: any | null, planningItems: Array<{ __typename?: 'ClientPricingItemPlanningOutputDto', _id: string, clientPricingItemId: string, date?: any | null, position: number, quantity: number, clientPricingItem: { __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null } }> }> | null, carbonFootprint?: { __typename?: 'ClientCarbonFootprintOutputDto', transport?: TransportEnum | null, lastKmsTransport?: LastKmsTransportEnum | null, mealsType?: MealsTypeEnum | null, departureCity?: { __typename?: 'ClientCarbonFootprintDepartureCityOutputDto', description: string, distanceInMeters: number, placeId: string } | null, carbonEmissions?: { __typename?: 'CarbonEmissionsOutputDto', accommodationEmissionsCount?: number | null, activitiesEmissionsCount?: number | null, cateringEmissionsCount?: number | null, totalEmissionsCount?: number | null, transportEmissionsCount?: number | null } | null } | null, state?: { __typename?: 'ClientProposalStateOutputDto', ownerAction?: ClientProposalStateOwnerActionEnum | null } | null, ownerUploadedQuotation?: { __typename?: 'ClientProposalOwnerUploadedQuotationOutputDto', at: any, quotationFileHistory: Array<{ __typename?: 'ClientProposalQuotationFileOutputDto', url: string }> } | null };

export type BookingPricePriceItemsFragment = { __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', description?: string | null, label: string, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, maxAdults?: number | null, minAdults?: number | null, unit: ServiceProvisionUnitEnum, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } }> }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null };

export type GetBookingPriceQueryVariables = Exact<{
  clientPricingItems: Array<ClientPricingItemInputDto> | ClientPricingItemInputDto;
  houseId?: InputMaybe<Scalars['String']>;
}>;


export type GetBookingPriceQuery = { __typename?: 'Query', getBookingPrice: { __typename?: 'BookingPrice', priceItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', description?: string | null, label: string, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, maxAdults?: number | null, minAdults?: number | null, unit: ServiceProvisionUnitEnum, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } }> }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, totalUser?: { __typename?: 'PriceObjectOutputDto', priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesWithDiscount?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscountAndOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null } };

export type ClientCarbonFootprintFragment = { __typename?: 'ClientCarbonFootprintOutputDto', transport?: TransportEnum | null, lastKmsTransport?: LastKmsTransportEnum | null, mealsType?: MealsTypeEnum | null, departureCity?: { __typename?: 'ClientCarbonFootprintDepartureCityOutputDto', description: string, distanceInMeters: number, placeId: string } | null, carbonEmissions?: { __typename?: 'CarbonEmissionsOutputDto', accommodationEmissionsCount?: number | null, activitiesEmissionsCount?: number | null, cateringEmissionsCount?: number | null, totalEmissionsCount?: number | null, transportEmissionsCount?: number | null } | null };

export type ClientPricingItemFragment = { __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null };

export type ClientPricingItemWithDiscountFragment = { __typename?: 'ClientPricingItemOutputDto', adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null };

export type ClientPricingItemObjectDataFragment = { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } };

export type NestedItemObjectDataFragment = { __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null };

export type ClientProposalPermissionsFragment = { __typename?: 'ClientProposalPermissionsOutputDto', canCancelStepSeven: boolean, canEditPricingItems: boolean, canOverrideUserFeesVatRate: boolean, canReadBriefOwner: boolean, canUpdateProposal: boolean, canValidateStepFiveWithoutBalancePayment: boolean, canValidateStepThreeWithoutDepositPayment: boolean, canCancelUserConfirmedBooking: boolean };

export type ClientRequestContactOwnerFragment = { __typename?: 'ClientRequestContactOutputDto', firstname?: string | null, lastname?: string | null, mail?: string | null, phone?: string | null };

export type ClientRequestStepFragment = { __typename?: 'ClientRequestStepOutputDto', stepNumber: number, stepState?: ClientRequestStepStateEnum | null, stepsUpdatedAt?: Array<{ __typename?: 'StepUpdatedAtOutputDto', stepNumber: number, date: any }> | null };

export type ClientRequestStepOwnerFragment = { __typename?: 'ClientRequestOutputDto', _id: string, readableId: string, status?: ClientRequestStatusEnum | null, gbv?: number | null, createdAt?: any | null, updatedAt?: any | null, selectedProposalId?: string | null, briefOwner?: string | null, pdfOwnerDocumentType?: Array<PdfTypeEnum> | null, shouldGenerateDocuments?: Array<PdfTypeEnum> | null, currentUserIsContact: boolean, type: TravelTypeEnum, company?: { __typename?: 'CompanyOutputDto', name: string, logoURL: string } | null, adminSales?: { __typename?: 'AdminOutputDto', _id: string, firstname?: string | null, lastname?: string | null, email?: string | null, profilePicture?: string | null } | null, adminCsm?: { __typename?: 'AdminOutputDto', _id: string, firstname?: string | null, lastname?: string | null, email?: string | null, profilePicture?: string | null } | null, selectedProposal?: { __typename?: 'ClientProposalOutputDto', _id: string, type: TravelTypeEnum, houseBookingType?: HouseBookingTypeEnum | null, briefOwner: string, clientRequestId: string, privatizationStatus?: PrivatizationStatusEnum | null, houseId?: string | null, startDate?: any | null, endDate?: any | null, arrivalHour?: string | null, departureHour?: string | null, adults?: number | null, isDeclinedByOwner?: boolean | null, userCurrentAction?: ClientProposalUserActionEnum | null, ownerCurrentAction?: ClientProposalOwnerActionEnum | null, userPaidDepositAt?: any | null, adminSkippedDepositPaymentAt?: any | null, hidePrices?: boolean | null, ownerAskedAdjustmentsModificationAt?: any | null, quotationConfirmedAt?: any | null, permissions: { __typename?: 'ClientProposalPermissionsOutputDto', canCancelStepSeven: boolean, canEditPricingItems: boolean, canOverrideUserFeesVatRate: boolean, canReadBriefOwner: boolean, canUpdateProposal: boolean, canValidateStepFiveWithoutBalancePayment: boolean, canValidateStepThreeWithoutDepositPayment: boolean, canCancelUserConfirmedBooking: boolean }, house?: { __typename?: 'HouseContext', _id: string, taxIdentifier: TaxIdentifierEnum, title: string, priceType: HousePriceTypeEnum, departure: string, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number>, multiVatRates?: Array<Array<number>> | null }, address?: { __typename?: 'AddressContext', country?: string | null, city?: string | null, street?: string | null, postalCode?: string | null } | null, owner?: { __typename?: 'HouseOwnerOutputDto', firstname?: string | null, lastname?: string | null, vatNumber?: string | null, siret?: string | null, email?: string | null, address?: { __typename?: 'AddressContext', street?: string | null, city?: string | null, postalCode?: string | null } | null } | null, bedrooms: Array<{ __typename?: 'HouseBedroomContext', capacity?: number | null }>, specialConditions: { __typename?: 'SpecialConditions', url: string }, options: { __typename: 'HouseOptionsGlobal', corporateEvening: { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } | { __typename: 'HouseOptionsIndividual', corporateEvening: { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } } | null, price?: { __typename?: 'BookingPrice', priceItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, totalUser?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, feesWithDiscount?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, vatPrices?: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> | null } | null, totalPerVatRates?: Array<{ __typename?: 'PriceObjectOutputDto', priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null }> | null } | null, clientPricingItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, adjustmentPrices?: Array<{ __typename?: 'ClientPricingItemOutputDto', adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, planning?: Array<{ __typename?: 'PlanningItemsByDate', date?: any | null, planningItems: Array<{ __typename?: 'ClientPricingItemPlanningOutputDto', _id: string, clientPricingItemId: string, date?: any | null, position: number, quantity: number, clientPricingItem: { __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null } }> }> | null, carbonFootprint?: { __typename?: 'ClientCarbonFootprintOutputDto', transport?: TransportEnum | null, lastKmsTransport?: LastKmsTransportEnum | null, mealsType?: MealsTypeEnum | null, departureCity?: { __typename?: 'ClientCarbonFootprintDepartureCityOutputDto', description: string, distanceInMeters: number, placeId: string } | null, carbonEmissions?: { __typename?: 'CarbonEmissionsOutputDto', accommodationEmissionsCount?: number | null, activitiesEmissionsCount?: number | null, cateringEmissionsCount?: number | null, totalEmissionsCount?: number | null, transportEmissionsCount?: number | null } | null } | null, state?: { __typename?: 'ClientProposalStateOutputDto', ownerAction?: ClientProposalStateOwnerActionEnum | null } | null, ownerUploadedQuotation?: { __typename?: 'ClientProposalOwnerUploadedQuotationOutputDto', at: any, quotationFileHistory: Array<{ __typename?: 'ClientProposalQuotationFileOutputDto', url: string }> } | null } | null, stepUser?: { __typename?: 'ClientRequestStepOutputDto', stepNumber: number, stepState?: ClientRequestStepStateEnum | null, stepsUpdatedAt?: Array<{ __typename?: 'StepUpdatedAtOutputDto', stepNumber: number, date: any }> | null } | null, stepOwner?: { __typename?: 'ClientRequestStepOutputDto', stepNumber: number, stepState?: ClientRequestStepStateEnum | null, stepsUpdatedAt?: Array<{ __typename?: 'StepUpdatedAtOutputDto', stepNumber: number, date: any }> | null } | null, contact?: { __typename?: 'ClientRequestContactOutputDto', firstname?: string | null, lastname?: string | null, mail?: string | null, phone?: string | null } | null, clientProposal?: { __typename?: 'ClientProposalOutputDto', _id: string, type: TravelTypeEnum, houseBookingType?: HouseBookingTypeEnum | null, briefOwner: string, clientRequestId: string, privatizationStatus?: PrivatizationStatusEnum | null, houseId?: string | null, startDate?: any | null, endDate?: any | null, arrivalHour?: string | null, departureHour?: string | null, adults?: number | null, isDeclinedByOwner?: boolean | null, userCurrentAction?: ClientProposalUserActionEnum | null, ownerCurrentAction?: ClientProposalOwnerActionEnum | null, userPaidDepositAt?: any | null, adminSkippedDepositPaymentAt?: any | null, hidePrices?: boolean | null, ownerAskedAdjustmentsModificationAt?: any | null, quotationConfirmedAt?: any | null, permissions: { __typename?: 'ClientProposalPermissionsOutputDto', canCancelStepSeven: boolean, canEditPricingItems: boolean, canOverrideUserFeesVatRate: boolean, canReadBriefOwner: boolean, canUpdateProposal: boolean, canValidateStepFiveWithoutBalancePayment: boolean, canValidateStepThreeWithoutDepositPayment: boolean, canCancelUserConfirmedBooking: boolean }, house?: { __typename?: 'HouseContext', _id: string, taxIdentifier: TaxIdentifierEnum, title: string, priceType: HousePriceTypeEnum, departure: string, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number>, multiVatRates?: Array<Array<number>> | null }, address?: { __typename?: 'AddressContext', country?: string | null, city?: string | null, street?: string | null, postalCode?: string | null } | null, owner?: { __typename?: 'HouseOwnerOutputDto', firstname?: string | null, lastname?: string | null, vatNumber?: string | null, siret?: string | null, email?: string | null, address?: { __typename?: 'AddressContext', street?: string | null, city?: string | null, postalCode?: string | null } | null } | null, bedrooms: Array<{ __typename?: 'HouseBedroomContext', capacity?: number | null }>, specialConditions: { __typename?: 'SpecialConditions', url: string }, options: { __typename: 'HouseOptionsGlobal', corporateEvening: { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } | { __typename: 'HouseOptionsIndividual', corporateEvening: { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } } | null, price?: { __typename?: 'BookingPrice', priceItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, totalUser?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, feesWithDiscount?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, vatPrices?: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> | null } | null, totalPerVatRates?: Array<{ __typename?: 'PriceObjectOutputDto', priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null }> | null } | null, clientPricingItems?: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, adjustmentPrices?: Array<{ __typename?: 'ClientPricingItemOutputDto', adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> | null, planning?: Array<{ __typename?: 'PlanningItemsByDate', date?: any | null, planningItems: Array<{ __typename?: 'ClientPricingItemPlanningOutputDto', _id: string, clientPricingItemId: string, date?: any | null, position: number, quantity: number, clientPricingItem: { __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null } }> }> | null, carbonFootprint?: { __typename?: 'ClientCarbonFootprintOutputDto', transport?: TransportEnum | null, lastKmsTransport?: LastKmsTransportEnum | null, mealsType?: MealsTypeEnum | null, departureCity?: { __typename?: 'ClientCarbonFootprintDepartureCityOutputDto', description: string, distanceInMeters: number, placeId: string } | null, carbonEmissions?: { __typename?: 'CarbonEmissionsOutputDto', accommodationEmissionsCount?: number | null, activitiesEmissionsCount?: number | null, cateringEmissionsCount?: number | null, totalEmissionsCount?: number | null, transportEmissionsCount?: number | null } | null } | null, state?: { __typename?: 'ClientProposalStateOutputDto', ownerAction?: ClientProposalStateOwnerActionEnum | null } | null, ownerUploadedQuotation?: { __typename?: 'ClientProposalOwnerUploadedQuotationOutputDto', at: any, quotationFileHistory: Array<{ __typename?: 'ClientProposalQuotationFileOutputDto', url: string }> } | null } | null, confirmationData?: { __typename?: 'ClientRequestConfirmationDataOutputDto', isConfirmed?: boolean | null, confirmationDate?: any | null, confirmedByOwner?: any | null, confirmedByUser?: any | null } | null, deposit?: { __typename?: 'ClientRequestPaymentOutputDto', status?: ClientRequestPaymentStatusEnum | null } | null, balance?: { __typename?: 'ClientRequestPaymentOutputDto', status?: ClientRequestPaymentStatusEnum | null } | null, balancePostFinal?: { __typename?: 'ClientRequestPaymentOutputDto', status?: ClientRequestPaymentStatusEnum | null } | null, permissions: { __typename?: 'ClientRequestPermissionsOutputDto', canEdit: boolean } };

export type CreateTokenOwnerAccessMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateTokenOwnerAccessMutation = { __typename?: 'Mutation', createTokenOwnerAccess: string };

export type ComputedPriceFragment = { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null };

export type PriceWithOwnerFeesFragment = { __typename?: 'PriceObjectOutputDto', priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null };

export type PriceFeesFragment = { __typename?: 'PriceObjectOutputDto', fees?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, feesWithDiscount?: { __typename?: 'PriceObjectFeesOutputDto', ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null };

export type PriceWithDiscountAndOwnerFeesFragment = { __typename?: 'PriceObjectOutputDto', priceWithDiscountAndOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null };

export type PriceWithDiscountFragment = { __typename?: 'PriceObjectOutputDto', priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null };

export type PriceOptionFragment = { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null };

export type VatPricesFragment = { __typename?: 'PriceObjectOutputDto', vatPrices?: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> | null };

export type UnitPriceObjectWithDiscountFragment = { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null };

export type TotalPriceObjectWithDiscountFragment = { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null };

export type GetHouseOwnerClientPricingItemsQueryVariables = Exact<{
  houseId: Scalars['String'];
}>;


export type GetHouseOwnerClientPricingItemsQuery = { __typename?: 'Query', getHouseOwnerClientPricingItems: Array<{ __typename?: 'ClientPricingItemOutputDto', _id: string, type: ClientPricingItemTypeEnum, category: ServiceProviderCategoryEnum, season?: SeasonEnum | null, priceUnit?: ServiceProvisionUnitEnum | null, position?: number | null, adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum | null, objectData: { __typename?: 'ClientPricingItemObjectDataOutputDto', label: string, description?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null, serviceOwnerId?: string | null, taxIdentifier: TaxIdentifierEnum, prices: Array<{ __typename?: 'ClientPricingItemObjectDataPriceOutputDto', _id: string, unit: ServiceProvisionUnitEnum, minAdults?: number | null, maxAdults?: number | null, price: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, feesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesByDiscountPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, fees?: { __typename?: 'PriceObjectFeesOutputDto', userFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, ownerFeesPrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }, vatPrices: Array<{ __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null }> }>, nestedItemsObjectData?: Array<{ __typename?: 'NestedItemObjectDataOutputDto', label: string, description?: string | null, type: ClientPricingItemTypeEnum, unit?: ServiceProvisionUnitEnum | null, quantity: number, objectId?: string | null, serviceProvisionType?: ServiceProvisionTypeEnum | null }> | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> } }, option: { __typename?: 'ClientPricingItemOptionOutputDto', objectId?: string | null, priceId?: string | null }, priceOption: { __typename?: 'PriceOptionOutputDto', quantity: number, discountRate?: number | null, fees?: { __typename?: 'PriceOptionFeesOutputDto', userFeesRate?: number | null, ownerFeesRate?: number | null } | null }, unitPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, discountPrice?: { __typename?: 'PriceObjectDiscountOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null, totalPrice?: { __typename?: 'PriceObjectOutputDto', basePrice?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscount?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithUserFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithDiscountAndFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null, priceWithOwnerFees?: { __typename?: 'ComputedPrice', priceWithoutVat: number, vat: number, priceWithVat: number, vatRate?: number | null } | null } | null }> };

export type HouseContextOwnerFragment = { __typename?: 'HouseContext', _id: string, priceType: HousePriceTypeEnum, residentialBookingType: HouseBookingTypeEnum, singleDayBookingType: HouseBookingTypeEnum, taxIdentifier: TaxIdentifierEnum, iCalURL?: string | null, options: { __typename: 'HouseOptionsGlobal', corporateEvening: { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } | { __typename: 'HouseOptionsIndividual', corporateEvening: { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> }, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> }, availabilities?: Array<{ __typename: 'HouseAvailabilityGlobalOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityGlobalCorporateEveningOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityGlobalNightlyTripOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalNightlyTripOptionsOutputDto', price?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityGlobalStudyDayOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalStudyDayOptionsOutputDto', price?: number | null } | null } } | { __typename: 'HouseAvailabilityICalendarOutputDto', _id: string, date: any, houseId: string } | { __typename: 'HouseAvailabilityIndividualOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityIndividualCorporateEveningOutputDto', isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityIndividualNightlyTripOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualNightlyTripOptionsOutputDto', sharedBedroomPrice?: number | null, singleBedroomPrice?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityIndividualStudyDayOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualStudyDayOptionsOutputDto', fullDayPrice?: number | null, halfDayPrice?: number | null, residentialPrice?: number | null } | null } }> | null, iCalendars: { __typename?: 'HouseICalendarsOutputDto', urls: Array<string> } };

export type OwnerAddICalendarUrlsMutationVariables = Exact<{
  houseId: Scalars['String'];
  inputDto: HouseICalendarUrlsInputDto;
}>;


export type OwnerAddICalendarUrlsMutation = { __typename?: 'Mutation', ownerAddICalendarUrls: { __typename?: 'SuccessResponse', error?: string | null, success: boolean } };

export type OwnerGetHouseWithAvailabilitiesQueryVariables = Exact<{
  houseId: Scalars['String'];
}>;


export type OwnerGetHouseWithAvailabilitiesQuery = { __typename?: 'Query', ownerGetHouseWithAvailabilities: { __typename?: 'HouseContext', _id: string, priceType: HousePriceTypeEnum, residentialBookingType: HouseBookingTypeEnum, singleDayBookingType: HouseBookingTypeEnum, taxIdentifier: TaxIdentifierEnum, iCalURL?: string | null, options: { __typename: 'HouseOptionsGlobal', corporateEvening: { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> } | { __typename: 'HouseOptionsIndividual', corporateEvening: { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> }, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> }, availabilities?: Array<{ __typename: 'HouseAvailabilityGlobalOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityGlobalCorporateEveningOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityGlobalNightlyTripOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalNightlyTripOptionsOutputDto', price?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityGlobalStudyDayOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalStudyDayOptionsOutputDto', price?: number | null } | null } } | { __typename: 'HouseAvailabilityICalendarOutputDto', _id: string, date: any, houseId: string } | { __typename: 'HouseAvailabilityIndividualOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityIndividualCorporateEveningOutputDto', isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityIndividualNightlyTripOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualNightlyTripOptionsOutputDto', sharedBedroomPrice?: number | null, singleBedroomPrice?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityIndividualStudyDayOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualStudyDayOptionsOutputDto', fullDayPrice?: number | null, halfDayPrice?: number | null, residentialPrice?: number | null } | null } }> | null, iCalendars: { __typename?: 'HouseICalendarsOutputDto', urls: Array<string> } } };

export type CorporateEveningGlobalFragment = { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null };

export type CorporateEveningIndividualFragment = { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null };

export type OwnerUpdateHouseCorporateEveningMutationVariables = Exact<{
  houseId: Scalars['String'];
  dto: HouseCorporateEveningDto;
}>;


export type OwnerUpdateHouseCorporateEveningMutation = { __typename?: 'Mutation', ownerUpdateHouseCorporateEvening: { __typename?: 'SuccessResponse', success: boolean, error?: string | null } };

type HouseOptions_HouseOptionsGlobal_Fragment = { __typename: 'HouseOptionsGlobal', corporateEvening: { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> };

type HouseOptions_HouseOptionsIndividual_Fragment = { __typename: 'HouseOptionsIndividual', corporateEvening: { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> };

export type HouseOptionsFragment = HouseOptions_HouseOptionsGlobal_Fragment | HouseOptions_HouseOptionsIndividual_Fragment;

export type HouseOptionsGlobalFragment = { __typename: 'HouseOptionsGlobal', corporateEvening: { __typename?: 'HouseCorporateEveningGlobal', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> };

export type HouseOptionsIndividualFragment = { __typename: 'HouseOptionsIndividual', corporateEvening: { __typename?: 'HouseCorporateEveningIndividual', isEnabled: boolean, options?: { __typename?: 'HouseCorporateEveningIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, hours: { __typename?: 'HouseCorporateEveningOptionsHours', endAt: string, overStayMaxAt: string, startAt: string }, seasonalPrices: Array<{ __typename?: 'HouseCorporateEveningOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, overStayMax: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, regular: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, nightlyTrip: { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, studyDay: { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null }, seasonalBusynessCalendar: Array<{ __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } }> };

export type NightlyTripGlobalFragment = { __typename?: 'HouseNightlyTripGlobal', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripGlobalOptions', touristTaxPrice?: number | null, vatRate?: number | null, flexibleSchedule: { __typename?: 'HouseNightlyTripGlobalOptionsFlexibleSchedule', earlyCheckinPrice?: number | null, lateCheckoutPrice?: number | null, vatRate?: number | null }, houseHold?: { __typename?: 'HouseNightlyTripGlobalOptionsHouseHold', cleaningPrice?: number | null, laundryPrice?: number | null, vatRate?: number | null } | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripGlobalOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, weekDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, weekEnd: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null };

export type NightlyTripIndividualFragment = { __typename?: 'HouseNightlyTripIndividual', isEnabled: boolean, options?: { __typename?: 'HouseNightlyTripIndividualOptions', touristTaxPrice?: number | null, vatRate?: number | null, seasonalPrices: Array<{ __typename?: 'HouseNightlyTripIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, sharedBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, singleBedroom: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null };

export type OwnerUpdateHouseNightlyTripMutationVariables = Exact<{
  houseId: Scalars['String'];
  dto: HouseNightlyTripDto;
}>;


export type OwnerUpdateHouseNightlyTripMutation = { __typename?: 'Mutation', ownerUpdateHouseNightlyTrip: { __typename?: 'SuccessResponse', success: boolean, error?: string | null } };

export type SeasonalBusynessCalendarFragment = { __typename?: 'HouseSeasonalBusynessCalendar', endAt?: any | null, startAt?: any | null, months: { __typename?: 'HouseSeasonalBusynessCalendarMonths', april: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, october: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, september: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, august: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, december: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, february: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, january: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, july: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, june: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, march: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, may: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum }, november: { __typename?: 'HouseSeasonalBusynessCalendarMonth', firstHalf: SeasonEnum, secondHalf: SeasonEnum } } };

export type OwnerUpdateHouseSeasonalBusynessCalendarMutationVariables = Exact<{
  houseId: Scalars['String'];
  dto: Array<HouseSeasonalBusynessCalendarDto> | HouseSeasonalBusynessCalendarDto;
}>;


export type OwnerUpdateHouseSeasonalBusynessCalendarMutation = { __typename?: 'Mutation', ownerUpdateHouseSeasonalBusynessCalendar: { __typename?: 'SuccessResponse', success: boolean, error?: string | null } };

export type StudyDayGlobalFragment = { __typename?: 'HouseStudyDayGlobal', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayGlobalOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayGlobalOptionsSeasonalPrices', endAt?: any | null, highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null, startAt?: any | null }> } | null };

export type StudyDayIndividualFragment = { __typename?: 'HouseStudyDayIndividual', isEnabled: boolean, options?: { __typename?: 'HouseStudyDayIndividualOptions', vatRate?: number | null, capacity: { __typename?: 'HouseOptionsCapacity', max: number, min: number }, seasonalPrices: Array<{ __typename?: 'HouseStudyDayIndividualOptionsSeasonalPrices', endAt?: any | null, startAt?: any | null, fullDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, halfDay: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null }, residential: { __typename?: 'HouseOptionsSeasonPrice', highPrice?: number | null, lowPrice?: number | null, mediumPrice?: number | null } }> } | null };

export type OwnerUpdateHouseStudyDayMutationVariables = Exact<{
  houseId: Scalars['String'];
  dto: HouseStudyDayDto;
}>;


export type OwnerUpdateHouseStudyDayMutation = { __typename?: 'Mutation', ownerUpdateHouseStudyDay: { __typename?: 'SuccessResponse', success: boolean, error?: string | null } };

type HouseAvailability_HouseAvailabilityGlobalOutputDto_Fragment = { __typename: 'HouseAvailabilityGlobalOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityGlobalCorporateEveningOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityGlobalNightlyTripOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalNightlyTripOptionsOutputDto', price?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityGlobalStudyDayOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalStudyDayOptionsOutputDto', price?: number | null } | null } };

type HouseAvailability_HouseAvailabilityICalendarOutputDto_Fragment = { __typename: 'HouseAvailabilityICalendarOutputDto', _id: string, date: any, houseId: string };

type HouseAvailability_HouseAvailabilityIndividualOutputDto_Fragment = { __typename: 'HouseAvailabilityIndividualOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityIndividualCorporateEveningOutputDto', isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityIndividualNightlyTripOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualNightlyTripOptionsOutputDto', sharedBedroomPrice?: number | null, singleBedroomPrice?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityIndividualStudyDayOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualStudyDayOptionsOutputDto', fullDayPrice?: number | null, halfDayPrice?: number | null, residentialPrice?: number | null } | null } };

export type HouseAvailabilityFragment = HouseAvailability_HouseAvailabilityGlobalOutputDto_Fragment | HouseAvailability_HouseAvailabilityICalendarOutputDto_Fragment | HouseAvailability_HouseAvailabilityIndividualOutputDto_Fragment;

export type HouseAvailabilityGlobalFragment = { __typename: 'HouseAvailabilityGlobalOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityGlobalCorporateEveningOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityGlobalNightlyTripOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalNightlyTripOptionsOutputDto', price?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityGlobalStudyDayOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalStudyDayOptionsOutputDto', price?: number | null } | null } };

export type HouseAvailabilityICalendarFragment = { __typename: 'HouseAvailabilityICalendarOutputDto', _id: string, date: any, houseId: string };

export type HouseAvailabilityIndividualFragment = { __typename: 'HouseAvailabilityIndividualOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityIndividualCorporateEveningOutputDto', isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityIndividualNightlyTripOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualNightlyTripOptionsOutputDto', sharedBedroomPrice?: number | null, singleBedroomPrice?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityIndividualStudyDayOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualStudyDayOptionsOutputDto', fullDayPrice?: number | null, halfDayPrice?: number | null, residentialPrice?: number | null } | null } };

export type OwnerUpsertHouseAvailabilityMutationVariables = Exact<{
  houseId: Scalars['String'];
  inputDto: HouseAvailabilityGlobalOrIndividualDto;
}>;


export type OwnerUpsertHouseAvailabilityMutation = { __typename?: 'Mutation', ownerUpsertHouseAvailability: { __typename?: 'SuccessResponse', error?: string | null, success: boolean } };

export type OwnerUpsertManyHouseAvailabilitiesMutationVariables = Exact<{
  houseId: Scalars['String'];
  inputDtos: HouseAvailabilityGlobalOrIndividualManyDto;
}>;


export type OwnerUpsertManyHouseAvailabilitiesMutation = { __typename?: 'Mutation', ownerUpsertManyHouseAvailabilities: { __typename?: 'SuccessResponse', error?: string | null, success: boolean } };

export type OwnerKeepICalendarUpToDateMutationVariables = Exact<{
  houseId: Scalars['String'];
}>;


export type OwnerKeepICalendarUpToDateMutation = { __typename?: 'Mutation', ownerKeepICalendarUpToDate: { __typename?: 'SuccessResponse', error?: string | null, success: boolean } };

export type PublicGetHouseAvailabilitiesFromToQueryVariables = Exact<{
  inputDto: HouseAvailabilityGetFromToInputDto;
}>;


export type PublicGetHouseAvailabilitiesFromToQuery = { __typename?: 'Query', publicGetHouseAvailabilitiesFromTo: Array<{ __typename: 'HouseAvailabilityGlobalOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityGlobalCorporateEveningOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityGlobalNightlyTripOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalNightlyTripOptionsOutputDto', price?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityGlobalStudyDayOutputDto', state: HouseAvailabilityGlobalStateEnum, isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityGlobalStudyDayOptionsOutputDto', price?: number | null } | null } } | { __typename: 'HouseAvailabilityICalendarOutputDto', _id: string, date: any, houseId: string } | { __typename: 'HouseAvailabilityIndividualOutputDto', _id: string, date: any, houseId: string, corporateEvening: { __typename?: 'HouseAvailabilityIndividualCorporateEveningOutputDto', isEnabled: boolean }, nightlyTrip: { __typename?: 'HouseAvailabilityIndividualNightlyTripOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualNightlyTripOptionsOutputDto', sharedBedroomPrice?: number | null, singleBedroomPrice?: number | null } | null }, studyDay: { __typename?: 'HouseAvailabilityIndividualStudyDayOutputDto', isEnabled: boolean, options?: { __typename?: 'HouseAvailabilityIndividualStudyDayOptionsOutputDto', fullDayPrice?: number | null, halfDayPrice?: number | null, residentialPrice?: number | null } | null } }> };

export type AddressFragment = { __typename?: 'AddressContext', street?: string | null, city?: string | null, latitude?: number | null, longitude?: number | null, postalCode?: string | null, department?: string | null, region?: string | null, country?: string | null, placeId?: string | null };

export type IntlFragment = { __typename?: 'IntlOutputDto', label: string, labelIntl: { __typename?: 'IntlLocalesOutputDto', deDE: string, enGB: string, esES: string, frBE: string, frFR: string, itIT: string, nlBE: string, nlNL: string } };

export type IntlLocalesFragment = { __typename?: 'IntlLocalesOutputDto', deDE: string, enGB: string, esES: string, frBE: string, frFR: string, itIT: string, nlBE: string, nlNL: string };

export type UpdateUserTravelCityMutationVariables = Exact<{
  input: FilterLocationDto;
}>;


export type UpdateUserTravelCityMutation = { __typename?: 'Mutation', updateUserTravelCity: { __typename?: 'SuccessResponse', success: boolean } };

export type GetUserContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserContextQuery = { __typename?: 'Query', getHouseOwnerContext: { __typename?: 'HouseOwnerOutputDto', _id: string, email?: string | null, firstname?: string | null, lastname?: string | null, notifications?: number | null, houses?: Array<{ __typename?: 'HouseContext', _id: string, readableId?: string | null, title: string, pathname?: string | null, priceType: HousePriceTypeEnum, status: HouseStatus, specialConditions: { __typename?: 'SpecialConditions', url: string }, pictures: Array<{ __typename?: 'HousePictureContext', _id: string, uri: string }>, admin?: { __typename?: 'AdminOutputDto', firstname?: string | null, label?: string | null, profilePicture?: string | null, email?: string | null } | null }> | null } };

export type HouseOwnerHouseFieldFragment = { __typename?: 'HouseContext', _id: string, readableId?: string | null, title: string, pathname?: string | null, taxIdentifier: TaxIdentifierEnum, priceType: HousePriceTypeEnum, residentialBookingType: HouseBookingTypeEnum, singleDayBookingType: HouseBookingTypeEnum, status: HouseStatus, ownerSpaceMode?: OwnerSpaceModeEnum | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> }, specialConditions: { __typename?: 'SpecialConditions', url: string }, pictures: Array<{ __typename?: 'HousePictureContext', _id: string, uri: string }>, admin?: { __typename?: 'AdminOutputDto', firstname?: string | null, label?: string | null, profilePicture?: string | null, email?: string | null } | null };

export type HouseOwnerLightContextFieldFragment = { __typename?: 'HouseOwnerOutputDto', _id: string, email?: string | null, firstname?: string | null, lastname?: string | null, status?: HouseOwnerStatusEnum | null, notifications?: number | null, hasPassword?: boolean | null, houses?: Array<{ __typename?: 'HouseContext', _id: string, readableId?: string | null, title: string, pathname?: string | null, taxIdentifier: TaxIdentifierEnum, priceType: HousePriceTypeEnum, residentialBookingType: HouseBookingTypeEnum, singleDayBookingType: HouseBookingTypeEnum, status: HouseStatus, ownerSpaceMode?: OwnerSpaceModeEnum | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> }, specialConditions: { __typename?: 'SpecialConditions', url: string }, pictures: Array<{ __typename?: 'HousePictureContext', _id: string, uri: string }>, admin?: { __typename?: 'AdminOutputDto', firstname?: string | null, label?: string | null, profilePicture?: string | null, email?: string | null } | null }> | null };

export type GetMeOwnerMutationVariables = Exact<{ [key: string]: never; }>;


export type GetMeOwnerMutation = { __typename?: 'Mutation', owner?: { __typename?: 'HouseOwnerOutputDto', _id: string, email?: string | null, firstname?: string | null, lastname?: string | null, status?: HouseOwnerStatusEnum | null, notifications?: number | null, hasPassword?: boolean | null, houses?: Array<{ __typename?: 'HouseContext', _id: string, readableId?: string | null, title: string, pathname?: string | null, taxIdentifier: TaxIdentifierEnum, priceType: HousePriceTypeEnum, residentialBookingType: HouseBookingTypeEnum, singleDayBookingType: HouseBookingTypeEnum, status: HouseStatus, ownerSpaceMode?: OwnerSpaceModeEnum | null, currencyArea: { __typename?: 'CurrencyAreaOutputDto', currency: CurrencyEnum, vatRates: Array<number> }, specialConditions: { __typename?: 'SpecialConditions', url: string }, pictures: Array<{ __typename?: 'HousePictureContext', _id: string, uri: string }>, admin?: { __typename?: 'AdminOutputDto', firstname?: string | null, label?: string | null, profilePicture?: string | null, email?: string | null } | null }> | null } | null };

export const ComputedPriceFragmentDoc = `
    fragment ComputedPrice on ComputedPrice {
  priceWithoutVat
  vat
  priceWithVat
  vatRate
}
    `;
export const PriceOptionFragmentDoc = `
    fragment PriceOption on PriceObjectOutputDto {
  basePrice {
    ...ComputedPrice
  }
}
    `;
export const ClientRequestDepositOwnerFragmentDoc = `
    fragment ClientRequestDepositOwner on ClientRequestPaymentOutputDto {
  price {
    totalUser {
      ...PriceOption
    }
  }
  depositRate
  status
}
    `;
export const UnitPriceObjectWithDiscountFragmentDoc = `
    fragment UnitPriceObjectWithDiscount on PriceObjectOutputDto {
  basePrice {
    ...ComputedPrice
  }
  discountPrice {
    basePrice {
      ...ComputedPrice
    }
  }
  priceWithDiscount {
    ...ComputedPrice
  }
}
    `;
export const TotalPriceObjectWithDiscountFragmentDoc = `
    fragment TotalPriceObjectWithDiscount on PriceObjectOutputDto {
  basePrice {
    ...ComputedPrice
  }
  priceWithDiscount {
    ...ComputedPrice
  }
  priceWithUserFees {
    ...ComputedPrice
  }
  priceWithDiscountAndFees {
    ...ComputedPrice
  }
  priceWithOwnerFees {
    ...ComputedPrice
  }
}
    `;
export const ClientPricingItemWithDiscountFragmentDoc = `
    fragment ClientPricingItemWithDiscount on ClientPricingItemOutputDto {
  adjustmentStatus
  option {
    objectId
    priceId
  }
  priceOption {
    quantity
    fees {
      userFeesRate
      ownerFeesRate
    }
    discountRate
  }
  unitPrice {
    ...UnitPriceObjectWithDiscount
  }
  totalPrice {
    ...TotalPriceObjectWithDiscount
  }
}
    `;
export const BookingPricePriceItemsFragmentDoc = `
    fragment BookingPricePriceItems on ClientPricingItemOutputDto {
  _id
  type
  category
  ...ClientPricingItemWithDiscount
  objectData {
    description
    label
    prices {
      _id
      maxAdults
      minAdults
      price {
        basePrice {
          ...ComputedPrice
        }
      }
      unit
    }
  }
}
    `;
export const ClientProposalPermissionsFragmentDoc = `
    fragment ClientProposalPermissions on ClientProposalPermissionsOutputDto {
  canCancelStepSeven
  canEditPricingItems
  canOverrideUserFeesVatRate
  canReadBriefOwner
  canUpdateProposal
  canValidateStepFiveWithoutBalancePayment
  canValidateStepThreeWithoutDepositPayment
  canCancelUserConfirmedBooking
}
    `;
export const CorporateEveningGlobalFragmentDoc = `
    fragment CorporateEveningGlobal on HouseCorporateEveningGlobal {
  isEnabled
  options {
    capacity {
      max
      min
    }
    hours {
      endAt
      overStayMaxAt
      startAt
    }
    seasonalPrices {
      endAt
      overStayMax {
        highPrice
        lowPrice
        mediumPrice
      }
      regular {
        highPrice
        lowPrice
        mediumPrice
      }
      startAt
    }
    vatRate
  }
}
    `;
export const NightlyTripGlobalFragmentDoc = `
    fragment NightlyTripGlobal on HouseNightlyTripGlobal {
  isEnabled
  options {
    flexibleSchedule {
      earlyCheckinPrice
      lateCheckoutPrice
      vatRate
    }
    houseHold {
      cleaningPrice
      laundryPrice
      vatRate
    }
    touristTaxPrice
    seasonalPrices {
      endAt
      startAt
      weekDay {
        highPrice
        lowPrice
        mediumPrice
      }
      weekEnd {
        highPrice
        lowPrice
        mediumPrice
      }
    }
    vatRate
  }
}
    `;
export const StudyDayGlobalFragmentDoc = `
    fragment StudyDayGlobal on HouseStudyDayGlobal {
  isEnabled
  options {
    capacity {
      max
      min
    }
    seasonalPrices {
      endAt
      highPrice
      lowPrice
      mediumPrice
      startAt
    }
    vatRate
  }
}
    `;
export const SeasonalBusynessCalendarFragmentDoc = `
    fragment SeasonalBusynessCalendar on HouseSeasonalBusynessCalendar {
  endAt
  months {
    april {
      firstHalf
      secondHalf
    }
    october {
      firstHalf
      secondHalf
    }
    september {
      firstHalf
      secondHalf
    }
    august {
      firstHalf
      secondHalf
    }
    december {
      firstHalf
      secondHalf
    }
    february {
      firstHalf
      secondHalf
    }
    january {
      firstHalf
      secondHalf
    }
    july {
      firstHalf
      secondHalf
    }
    june {
      firstHalf
      secondHalf
    }
    march {
      firstHalf
      secondHalf
    }
    may {
      firstHalf
      secondHalf
    }
    november {
      firstHalf
      secondHalf
    }
  }
  startAt
}
    `;
export const HouseOptionsGlobalFragmentDoc = `
    fragment HouseOptionsGlobal on HouseOptionsGlobal {
  __typename
  corporateEvening {
    ...CorporateEveningGlobal
  }
  nightlyTrip {
    ...NightlyTripGlobal
  }
  studyDay {
    ...StudyDayGlobal
  }
  seasonalBusynessCalendar {
    ...SeasonalBusynessCalendar
  }
}
    `;
export const CorporateEveningIndividualFragmentDoc = `
    fragment CorporateEveningIndividual on HouseCorporateEveningIndividual {
  isEnabled
  options {
    capacity {
      max
      min
    }
    hours {
      endAt
      overStayMaxAt
      startAt
    }
    seasonalPrices {
      endAt
      overStayMax {
        highPrice
        lowPrice
        mediumPrice
      }
      regular {
        highPrice
        lowPrice
        mediumPrice
      }
      startAt
    }
    vatRate
  }
}
    `;
export const NightlyTripIndividualFragmentDoc = `
    fragment NightlyTripIndividual on HouseNightlyTripIndividual {
  isEnabled
  options {
    touristTaxPrice
    seasonalPrices {
      endAt
      sharedBedroom {
        highPrice
        lowPrice
        mediumPrice
      }
      singleBedroom {
        highPrice
        lowPrice
        mediumPrice
      }
      startAt
    }
    vatRate
  }
}
    `;
export const StudyDayIndividualFragmentDoc = `
    fragment StudyDayIndividual on HouseStudyDayIndividual {
  isEnabled
  options {
    capacity {
      max
      min
    }
    seasonalPrices {
      endAt
      fullDay {
        highPrice
        lowPrice
        mediumPrice
      }
      halfDay {
        highPrice
        lowPrice
        mediumPrice
      }
      residential {
        highPrice
        lowPrice
        mediumPrice
      }
      startAt
    }
    vatRate
  }
}
    `;
export const HouseOptionsIndividualFragmentDoc = `
    fragment HouseOptionsIndividual on HouseOptionsIndividual {
  __typename
  corporateEvening {
    ...CorporateEveningIndividual
  }
  nightlyTrip {
    ...NightlyTripIndividual
  }
  studyDay {
    ...StudyDayIndividual
  }
  seasonalBusynessCalendar {
    ...SeasonalBusynessCalendar
  }
}
    `;
export const HouseOptionsFragmentDoc = `
    fragment HouseOptions on HouseOptions {
  ... on HouseOptionsGlobal {
    ...HouseOptionsGlobal
  }
  ... on HouseOptionsIndividual {
    ...HouseOptionsIndividual
  }
}
    `;
export const PriceFeesFragmentDoc = `
    fragment PriceFees on PriceObjectOutputDto {
  fees {
    ownerFeesPrice {
      ...ComputedPrice
    }
  }
  feesWithDiscount {
    ownerFeesPrice {
      ...ComputedPrice
    }
  }
}
    `;
export const PriceWithOwnerFeesFragmentDoc = `
    fragment PriceWithOwnerFees on PriceObjectOutputDto {
  priceWithOwnerFees {
    ...ComputedPrice
  }
}
    `;
export const PriceWithDiscountFragmentDoc = `
    fragment PriceWithDiscount on PriceObjectOutputDto {
  priceWithDiscount {
    ...ComputedPrice
  }
}
    `;
export const PriceWithDiscountAndOwnerFeesFragmentDoc = `
    fragment PriceWithDiscountAndOwnerFees on PriceObjectOutputDto {
  priceWithDiscountAndOwnerFees {
    ...ComputedPrice
  }
}
    `;
export const VatPricesFragmentDoc = `
    fragment VatPrices on PriceObjectOutputDto {
  vatPrices {
    ...ComputedPrice
  }
}
    `;
export const NestedItemObjectDataFragmentDoc = `
    fragment NestedItemObjectData on NestedItemObjectDataOutputDto {
  label
  description
  type
  unit
  quantity
  objectId
  serviceProvisionType
}
    `;
export const ClientPricingItemObjectDataFragmentDoc = `
    fragment ClientPricingItemObjectData on ClientPricingItemObjectDataOutputDto {
  label
  description
  prices {
    _id
    price {
      basePrice {
        ...ComputedPrice
      }
      discountPrice {
        basePrice {
          ...ComputedPrice
        }
        feesByDiscountPrice {
          ...ComputedPrice
        }
        ownerFeesByDiscountPrice {
          ...ComputedPrice
        }
      }
      fees {
        userFeesPrice {
          ...ComputedPrice
        }
        ownerFeesPrice {
          ...ComputedPrice
        }
      }
    }
    unit
    minAdults
    maxAdults
    vatPrices {
      ...ComputedPrice
    }
  }
  serviceProvisionType
  nestedItemsObjectData {
    ...NestedItemObjectData
  }
  serviceOwnerId
  taxIdentifier
  currencyArea {
    currency
    vatRates
  }
}
    `;
export const ClientPricingItemFragmentDoc = `
    fragment ClientPricingItem on ClientPricingItemOutputDto {
  _id
  type
  category
  season
  priceUnit
  objectData {
    ...ClientPricingItemObjectData
  }
  ...ClientPricingItemWithDiscount
  position
}
    `;
export const ClientCarbonFootprintFragmentDoc = `
    fragment ClientCarbonFootprint on ClientCarbonFootprintOutputDto {
  departureCity {
    description
    distanceInMeters
    placeId
  }
  transport
  lastKmsTransport
  mealsType
  carbonEmissions {
    accommodationEmissionsCount
    activitiesEmissionsCount
    cateringEmissionsCount
    totalEmissionsCount
    transportEmissionsCount
  }
}
    `;
export const ClientProposalFragmentDoc = `
    fragment ClientProposal on ClientProposalOutputDto {
  _id
  type
  permissions {
    ...ClientProposalPermissions
  }
  houseBookingType
  briefOwner
  clientRequestId
  privatizationStatus
  houseId
  house {
    _id
    fees {
      userFeesRate
      ownerFeesRate
    }
    taxIdentifier
    currencyArea {
      currency
      vatRates
      multiVatRates
    }
    title
    priceType
    address {
      country
      city
      street
      postalCode
    }
    owner {
      firstname
      lastname
      vatNumber
      siret
      email
      address {
        street
        city
        postalCode
      }
    }
    title
    bedrooms {
      capacity
    }
    _id
    specialConditions {
      url
    }
    taxIdentifier
    currencyArea {
      currency
      vatRates
    }
    taxIdentifier
    options {
      ...HouseOptions
    }
    departure
  }
  startDate
  endDate
  arrivalHour
  departureHour
  adults
  price {
    priceItems {
      _id
      type
      ...ClientPricingItemWithDiscount
    }
    totalUser {
      basePrice {
        ...ComputedPrice
      }
      ...PriceFees
      ...PriceWithOwnerFees
      ...PriceWithDiscount
      ...PriceWithDiscountAndOwnerFees
      ...VatPrices
    }
    totalPerVatRates {
      ...PriceWithDiscount
    }
  }
  clientPricingItems {
    ...ClientPricingItem
  }
  adjustmentPrices {
    adjustmentStatus
    ...ClientPricingItem
  }
  planning(serviceOwnerId: $serviceOwnerId) {
    date
    planningItems {
      _id
      clientPricingItemId
      date
      position
      quantity
      clientPricingItem {
        ...ClientPricingItem
      }
    }
  }
  isDeclinedByOwner
  carbonFootprint {
    ...ClientCarbonFootprint
  }
  state {
    ownerAction
  }
  userCurrentAction
  ownerCurrentAction
  userPaidDepositAt
  adminSkippedDepositPaymentAt
  hidePrices
  ownerAskedAdjustmentsModificationAt
  quotationConfirmedAt
  ownerUploadedQuotation {
    at
    quotationFileHistory {
      url
    }
  }
}
    `;
export const ClientRequestStepFragmentDoc = `
    fragment ClientRequestStep on ClientRequestStepOutputDto {
  stepNumber
  stepState
  stepsUpdatedAt {
    stepNumber
    date
  }
}
    `;
export const ClientRequestContactOwnerFragmentDoc = `
    fragment ClientRequestContactOwner on ClientRequestContactOutputDto {
  firstname
  lastname
  mail
  phone
}
    `;
export const ClientRequestStepOwnerFragmentDoc = `
    fragment ClientRequestStepOwner on ClientRequestOutputDto {
  _id
  readableId
  status
  gbv
  company(clientProposalId: $clientProposalId) {
    name
    logoURL
  }
  adminSales {
    _id
    firstname
    lastname
    email
    profilePicture
  }
  adminCsm {
    _id
    firstname
    lastname
    email
    profilePicture
  }
  createdAt
  updatedAt
  selectedProposalId
  selectedProposal {
    ...ClientProposal
  }
  stepUser {
    ...ClientRequestStep
  }
  stepOwner {
    ...ClientRequestStep
  }
  contact(clientProposalId: $clientProposalId) {
    ...ClientRequestContactOwner
  }
  clientProposal(clientProposalId: $clientProposalId) {
    ...ClientProposal
  }
  briefOwner
  pdfOwnerDocumentType(clientProposalId: $clientProposalId)
  shouldGenerateDocuments
  confirmationData {
    isConfirmed
    confirmationDate
    confirmedByOwner
    confirmedByUser
  }
  deposit {
    status
  }
  balance {
    status
  }
  balancePostFinal {
    status
  }
  currentUserIsContact
  permissions {
    canEdit
  }
  type
}
    `;
export const HouseAvailabilityGlobalFragmentDoc = `
    fragment HouseAvailabilityGlobal on HouseAvailabilityGlobalOutputDto {
  __typename
  _id
  corporateEvening {
    state
    isEnabled
  }
  date
  houseId
  nightlyTrip {
    state
    isEnabled
    options {
      price
    }
  }
  studyDay {
    state
    isEnabled
    options {
      price
    }
  }
}
    `;
export const HouseAvailabilityIndividualFragmentDoc = `
    fragment HouseAvailabilityIndividual on HouseAvailabilityIndividualOutputDto {
  __typename
  _id
  corporateEvening {
    isEnabled
  }
  date
  houseId
  nightlyTrip {
    isEnabled
    options {
      sharedBedroomPrice
      singleBedroomPrice
    }
  }
  studyDay {
    isEnabled
    options {
      fullDayPrice
      halfDayPrice
      residentialPrice
    }
  }
}
    `;
export const HouseAvailabilityICalendarFragmentDoc = `
    fragment HouseAvailabilityICalendar on HouseAvailabilityICalendarOutputDto {
  __typename
  _id
  date
  houseId
}
    `;
export const HouseAvailabilityFragmentDoc = `
    fragment HouseAvailability on HouseAvailabilityUnionOutputDto {
  ... on HouseAvailabilityGlobalOutputDto {
    ...HouseAvailabilityGlobal
  }
  ... on HouseAvailabilityIndividualOutputDto {
    ...HouseAvailabilityIndividual
  }
  ... on HouseAvailabilityICalendarOutputDto {
    ...HouseAvailabilityICalendar
  }
}
    `;
export const HouseContextOwnerFragmentDoc = `
    fragment HouseContextOwner on HouseContext {
  _id
  priceType
  residentialBookingType
  singleDayBookingType
  options {
    ...HouseOptions
  }
  taxIdentifier
  currencyArea {
    currency
    vatRates
  }
  availabilities {
    ...HouseAvailability
  }
  iCalURL
  iCalendars {
    urls
  }
}
    `;
export const AddressFragmentDoc = `
    fragment Address on AddressContext {
  street
  city
  latitude
  longitude
  postalCode
  department
  region
  country
  placeId
}
    `;
export const IntlLocalesFragmentDoc = `
    fragment IntlLocales on IntlLocalesOutputDto {
  deDE
  enGB
  esES
  frBE
  frFR
  itIT
  nlBE
  nlNL
}
    `;
export const IntlFragmentDoc = `
    fragment Intl on IntlOutputDto {
  label
  labelIntl {
    ...IntlLocales
  }
}
    `;
export const HouseOwnerHouseFieldFragmentDoc = `
    fragment HouseOwnerHouseField on HouseContext {
  _id
  readableId
  title
  pathname
  taxIdentifier
  currencyArea {
    currency
    vatRates
  }
  specialConditions {
    url
  }
  pictures {
    _id
    uri
  }
  priceType
  residentialBookingType
  singleDayBookingType
  status
  admin {
    firstname
    label
    profilePicture
    email
  }
  ownerSpaceMode
}
    `;
export const HouseOwnerLightContextFieldFragmentDoc = `
    fragment HouseOwnerLightContextField on HouseOwnerOutputDto {
  _id
  email
  firstname
  lastname
  status
  notifications
  hasPassword
  houses {
    ...HouseOwnerHouseField
  }
}
    `;
export const LoginDocument = `
    mutation Login($inputs: AuthDto!) {
  loginOwner(inputs: $inputs) {
    ...HouseOwnerLightContextField
  }
}
    ${HouseOwnerLightContextFieldFragmentDoc}
${HouseOwnerHouseFieldFragmentDoc}`;
export const useLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LoginMutation, TError, LoginMutationVariables, TContext>) =>
    useMutation<LoginMutation, TError, LoginMutationVariables, TContext>(
      ['Login'],
      (variables?: LoginMutationVariables) => fetcher<LoginMutation, LoginMutationVariables>(LoginDocument, variables)(),
      options
    );
export const LoginOwnerByTokenDocument = `
    mutation LoginOwnerByToken($token: String!) {
  loginOwnerByToken(token: $token) {
    owner {
      ...HouseOwnerLightContextField
    }
    isAuthenticateTokenExpired
  }
}
    ${HouseOwnerLightContextFieldFragmentDoc}
${HouseOwnerHouseFieldFragmentDoc}`;
export const useLoginOwnerByTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LoginOwnerByTokenMutation, TError, LoginOwnerByTokenMutationVariables, TContext>) =>
    useMutation<LoginOwnerByTokenMutation, TError, LoginOwnerByTokenMutationVariables, TContext>(
      ['LoginOwnerByToken'],
      (variables?: LoginOwnerByTokenMutationVariables) => fetcher<LoginOwnerByTokenMutation, LoginOwnerByTokenMutationVariables>(LoginOwnerByTokenDocument, variables)(),
      options
    );
export const LogoutDocument = `
    mutation Logout {
  logoutHouseOwner {
    success
  }
}
    `;
export const useLogoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LogoutMutation, TError, LogoutMutationVariables, TContext>) =>
    useMutation<LogoutMutation, TError, LogoutMutationVariables, TContext>(
      ['Logout'],
      (variables?: LogoutMutationVariables) => fetcher<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables)(),
      options
    );
export const GetHouseOwnerByTokenDocument = `
    query GetHouseOwnerByToken($token: String!) {
  getHouseOwnerByToken(token: $token) {
    email
    token {
      token
      type
    }
  }
}
    `;
export const useGetHouseOwnerByTokenQuery = <
      TData = GetHouseOwnerByTokenQuery,
      TError = unknown
    >(
      variables: GetHouseOwnerByTokenQueryVariables,
      options?: UseQueryOptions<GetHouseOwnerByTokenQuery, TError, TData>
    ) =>
    useQuery<GetHouseOwnerByTokenQuery, TError, TData>(
      ['GetHouseOwnerByToken', variables],
      fetcher<GetHouseOwnerByTokenQuery, GetHouseOwnerByTokenQueryVariables>(GetHouseOwnerByTokenDocument, variables),
      options
    );
export const useInfiniteGetHouseOwnerByTokenQuery = <
      TData = GetHouseOwnerByTokenQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetHouseOwnerByTokenQueryVariables,
      variables: GetHouseOwnerByTokenQueryVariables,
      options?: UseInfiniteQueryOptions<GetHouseOwnerByTokenQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetHouseOwnerByTokenQuery, TError, TData>(
      ['GetHouseOwnerByToken.infinite', variables],
      (metaData) => fetcher<GetHouseOwnerByTokenQuery, GetHouseOwnerByTokenQueryVariables>(GetHouseOwnerByTokenDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ValidateAccountHouseOwnerDocument = `
    mutation ValidateAccountHouseOwner($dto: ValidateAccountDto!) {
  validateAccountHouseOwner(dto: $dto) {
    email
  }
}
    `;
export const useValidateAccountHouseOwnerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateAccountHouseOwnerMutation, TError, ValidateAccountHouseOwnerMutationVariables, TContext>) =>
    useMutation<ValidateAccountHouseOwnerMutation, TError, ValidateAccountHouseOwnerMutationVariables, TContext>(
      ['ValidateAccountHouseOwner'],
      (variables?: ValidateAccountHouseOwnerMutationVariables) => fetcher<ValidateAccountHouseOwnerMutation, ValidateAccountHouseOwnerMutationVariables>(ValidateAccountHouseOwnerDocument, variables)(),
      options
    );
export const CreateHouseOwnerPasswordDocument = `
    mutation CreateHouseOwnerPassword($dto: createPasswordInputDto!) {
  createHouseOwnerPassword(dto: $dto) {
    error
    success
  }
}
    `;
export const useCreateHouseOwnerPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateHouseOwnerPasswordMutation, TError, CreateHouseOwnerPasswordMutationVariables, TContext>) =>
    useMutation<CreateHouseOwnerPasswordMutation, TError, CreateHouseOwnerPasswordMutationVariables, TContext>(
      ['CreateHouseOwnerPassword'],
      (variables?: CreateHouseOwnerPasswordMutationVariables) => fetcher<CreateHouseOwnerPasswordMutation, CreateHouseOwnerPasswordMutationVariables>(CreateHouseOwnerPasswordDocument, variables)(),
      options
    );
export const ForgotPasswordHouseOwnerDocument = `
    mutation ForgotPasswordHouseOwner($dto: ForgotPasswordDto!) {
  forgotPasswordHouseOwner(dto: $dto)
}
    `;
export const useForgotPasswordHouseOwnerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ForgotPasswordHouseOwnerMutation, TError, ForgotPasswordHouseOwnerMutationVariables, TContext>) =>
    useMutation<ForgotPasswordHouseOwnerMutation, TError, ForgotPasswordHouseOwnerMutationVariables, TContext>(
      ['ForgotPasswordHouseOwner'],
      (variables?: ForgotPasswordHouseOwnerMutationVariables) => fetcher<ForgotPasswordHouseOwnerMutation, ForgotPasswordHouseOwnerMutationVariables>(ForgotPasswordHouseOwnerDocument, variables)(),
      options
    );
export const ResetPasswordHouseOwnerDocument = `
    mutation ResetPasswordHouseOwner($dto: ResetPasswordDto!) {
  resetPasswordHouseOwner(dto: $dto) {
    email
  }
}
    `;
export const useResetPasswordHouseOwnerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResetPasswordHouseOwnerMutation, TError, ResetPasswordHouseOwnerMutationVariables, TContext>) =>
    useMutation<ResetPasswordHouseOwnerMutation, TError, ResetPasswordHouseOwnerMutationVariables, TContext>(
      ['ResetPasswordHouseOwner'],
      (variables?: ResetPasswordHouseOwnerMutationVariables) => fetcher<ResetPasswordHouseOwnerMutation, ResetPasswordHouseOwnerMutationVariables>(ResetPasswordHouseOwnerDocument, variables)(),
      options
    );
export const RegenerateAuthenticateTokenDocument = `
    mutation RegenerateAuthenticateToken($url: String!) {
  regenerateAuthenticateToken(url: $url) {
    error
    success
  }
}
    `;
export const useRegenerateAuthenticateTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RegenerateAuthenticateTokenMutation, TError, RegenerateAuthenticateTokenMutationVariables, TContext>) =>
    useMutation<RegenerateAuthenticateTokenMutation, TError, RegenerateAuthenticateTokenMutationVariables, TContext>(
      ['RegenerateAuthenticateToken'],
      (variables?: RegenerateAuthenticateTokenMutationVariables) => fetcher<RegenerateAuthenticateTokenMutation, RegenerateAuthenticateTokenMutationVariables>(RegenerateAuthenticateTokenDocument, variables)(),
      options
    );
export const GetPdfsByClientRequestIdDocument = `
    mutation GetPdfsByClientRequestId($clientRequestId: String!, $pdfTypes: [PdfTypeEnum!]!, $clientProposalId: String, $regenerate: Boolean) {
  getPdfsByClientRequestId(
    clientRequestId: $clientRequestId
    pdfTypes: $pdfTypes
    clientProposalId: $clientProposalId
    regenerate: $regenerate
  ) {
    filename
    url
  }
}
    `;
export const useGetPdfsByClientRequestIdMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetPdfsByClientRequestIdMutation, TError, GetPdfsByClientRequestIdMutationVariables, TContext>) =>
    useMutation<GetPdfsByClientRequestIdMutation, TError, GetPdfsByClientRequestIdMutationVariables, TContext>(
      ['GetPdfsByClientRequestId'],
      (variables?: GetPdfsByClientRequestIdMutationVariables) => fetcher<GetPdfsByClientRequestIdMutation, GetPdfsByClientRequestIdMutationVariables>(GetPdfsByClientRequestIdDocument, variables)(),
      options
    );
export const GenerateClientRequestDocumentsDocument = `
    mutation GenerateClientRequestDocuments($clientRequestId: String!, $clientProposalId: String, $pdfs: [PdfTypeEnum!]!) {
  generateClientRequestDocuments(
    clientRequestId: $clientRequestId
    clientProposalId: $clientProposalId
    pdfs: $pdfs
  ) {
    url
  }
}
    `;
export const useGenerateClientRequestDocumentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateClientRequestDocumentsMutation, TError, GenerateClientRequestDocumentsMutationVariables, TContext>) =>
    useMutation<GenerateClientRequestDocumentsMutation, TError, GenerateClientRequestDocumentsMutationVariables, TContext>(
      ['GenerateClientRequestDocuments'],
      (variables?: GenerateClientRequestDocumentsMutationVariables) => fetcher<GenerateClientRequestDocumentsMutation, GenerateClientRequestDocumentsMutationVariables>(GenerateClientRequestDocumentsDocument, variables)(),
      options
    );
export const GetClientRequestByProposalIdDocument = `
    query GetClientRequestByProposalId($clientProposalId: String!, $serviceOwnerId: String = "houseOwner") {
  getClientRequestByProposalId(clientProposalId: $clientProposalId) {
    ...ClientRequestStepOwner
  }
}
    ${ClientRequestStepOwnerFragmentDoc}
${ClientProposalFragmentDoc}
${ClientProposalPermissionsFragmentDoc}
${HouseOptionsFragmentDoc}
${HouseOptionsGlobalFragmentDoc}
${CorporateEveningGlobalFragmentDoc}
${NightlyTripGlobalFragmentDoc}
${StudyDayGlobalFragmentDoc}
${SeasonalBusynessCalendarFragmentDoc}
${HouseOptionsIndividualFragmentDoc}
${CorporateEveningIndividualFragmentDoc}
${NightlyTripIndividualFragmentDoc}
${StudyDayIndividualFragmentDoc}
${ClientPricingItemWithDiscountFragmentDoc}
${UnitPriceObjectWithDiscountFragmentDoc}
${ComputedPriceFragmentDoc}
${TotalPriceObjectWithDiscountFragmentDoc}
${PriceFeesFragmentDoc}
${PriceWithOwnerFeesFragmentDoc}
${PriceWithDiscountFragmentDoc}
${PriceWithDiscountAndOwnerFeesFragmentDoc}
${VatPricesFragmentDoc}
${ClientPricingItemFragmentDoc}
${ClientPricingItemObjectDataFragmentDoc}
${NestedItemObjectDataFragmentDoc}
${ClientCarbonFootprintFragmentDoc}
${ClientRequestStepFragmentDoc}
${ClientRequestContactOwnerFragmentDoc}`;
export const useGetClientRequestByProposalIdQuery = <
      TData = GetClientRequestByProposalIdQuery,
      TError = unknown
    >(
      variables: GetClientRequestByProposalIdQueryVariables,
      options?: UseQueryOptions<GetClientRequestByProposalIdQuery, TError, TData>
    ) =>
    useQuery<GetClientRequestByProposalIdQuery, TError, TData>(
      ['GetClientRequestByProposalId', variables],
      fetcher<GetClientRequestByProposalIdQuery, GetClientRequestByProposalIdQueryVariables>(GetClientRequestByProposalIdDocument, variables),
      options
    );
export const useInfiniteGetClientRequestByProposalIdQuery = <
      TData = GetClientRequestByProposalIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetClientRequestByProposalIdQueryVariables,
      variables: GetClientRequestByProposalIdQueryVariables,
      options?: UseInfiniteQueryOptions<GetClientRequestByProposalIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetClientRequestByProposalIdQuery, TError, TData>(
      ['GetClientRequestByProposalId.infinite', variables],
      (metaData) => fetcher<GetClientRequestByProposalIdQuery, GetClientRequestByProposalIdQueryVariables>(GetClientRequestByProposalIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetPdfsByClientProposalIdDocument = `
    query getPdfsByClientProposalId($pdfTypes: [PdfTypeEnum!]!, $clientRequestId: String!, $clientProposalId: String!) {
  getPdfsByClientProposalId(
    pdfTypes: $pdfTypes
    clientRequestId: $clientRequestId
    clientProposalId: $clientProposalId
  ) {
    url
    pdfType
    filename
  }
}
    `;
export const useGetPdfsByClientProposalIdQuery = <
      TData = GetPdfsByClientProposalIdQuery,
      TError = unknown
    >(
      variables: GetPdfsByClientProposalIdQueryVariables,
      options?: UseQueryOptions<GetPdfsByClientProposalIdQuery, TError, TData>
    ) =>
    useQuery<GetPdfsByClientProposalIdQuery, TError, TData>(
      ['getPdfsByClientProposalId', variables],
      fetcher<GetPdfsByClientProposalIdQuery, GetPdfsByClientProposalIdQueryVariables>(GetPdfsByClientProposalIdDocument, variables),
      options
    );
export const useInfiniteGetPdfsByClientProposalIdQuery = <
      TData = GetPdfsByClientProposalIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetPdfsByClientProposalIdQueryVariables,
      variables: GetPdfsByClientProposalIdQueryVariables,
      options?: UseInfiniteQueryOptions<GetPdfsByClientProposalIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetPdfsByClientProposalIdQuery, TError, TData>(
      ['getPdfsByClientProposalId.infinite', variables],
      (metaData) => fetcher<GetPdfsByClientProposalIdQuery, GetPdfsByClientProposalIdQueryVariables>(GetPdfsByClientProposalIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetClientRequestsVisibleByOwnerByHouseIdDocument = `
    query getClientRequestsVisibleByOwnerByHouseId($houseId: String!, $skip: Int, $filters: ClientProposalOwnerListInputDto!) {
  getClientRequestsVisibleByOwnerByHouseId(
    houseId: $houseId
    pagination: {skip: $skip}
    filters: $filters
  ) {
    _id
    company {
      name
      logoURL
    }
    readableId
    createdAt
    adminSales {
      name
    }
    adminCsm {
      name
    }
    stepOwner {
      stepNumber
    }
    clientProposal {
      type
      _id
      startDate
      endDate
      arrivalHour
      departureHour
      adults
      readByOwner
      state {
        ownerStatus
        ownerAction
      }
    }
  }
}
    `;
export const useGetClientRequestsVisibleByOwnerByHouseIdQuery = <
      TData = GetClientRequestsVisibleByOwnerByHouseIdQuery,
      TError = unknown
    >(
      variables: GetClientRequestsVisibleByOwnerByHouseIdQueryVariables,
      options?: UseQueryOptions<GetClientRequestsVisibleByOwnerByHouseIdQuery, TError, TData>
    ) =>
    useQuery<GetClientRequestsVisibleByOwnerByHouseIdQuery, TError, TData>(
      ['getClientRequestsVisibleByOwnerByHouseId', variables],
      fetcher<GetClientRequestsVisibleByOwnerByHouseIdQuery, GetClientRequestsVisibleByOwnerByHouseIdQueryVariables>(GetClientRequestsVisibleByOwnerByHouseIdDocument, variables),
      options
    );
export const useInfiniteGetClientRequestsVisibleByOwnerByHouseIdQuery = <
      TData = GetClientRequestsVisibleByOwnerByHouseIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetClientRequestsVisibleByOwnerByHouseIdQueryVariables,
      variables: GetClientRequestsVisibleByOwnerByHouseIdQueryVariables,
      options?: UseInfiniteQueryOptions<GetClientRequestsVisibleByOwnerByHouseIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetClientRequestsVisibleByOwnerByHouseIdQuery, TError, TData>(
      ['getClientRequestsVisibleByOwnerByHouseId.infinite', variables],
      (metaData) => fetcher<GetClientRequestsVisibleByOwnerByHouseIdQuery, GetClientRequestsVisibleByOwnerByHouseIdQueryVariables>(GetClientRequestsVisibleByOwnerByHouseIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const OwnerUploadedQuotationDocument = `
    mutation OwnerUploadedQuotation($clientProposalId: String!, $ownerUploadedQuotationInputs: ClientProposalOwnerUploadedQuotationInputDto!) {
  ownerUploadedQuotation(
    clientProposalId: $clientProposalId
    ownerUploadedQuotationInputs: $ownerUploadedQuotationInputs
  ) {
    success
  }
}
    `;
export const useOwnerUploadedQuotationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerUploadedQuotationMutation, TError, OwnerUploadedQuotationMutationVariables, TContext>) =>
    useMutation<OwnerUploadedQuotationMutation, TError, OwnerUploadedQuotationMutationVariables, TContext>(
      ['OwnerUploadedQuotation'],
      (variables?: OwnerUploadedQuotationMutationVariables) => fetcher<OwnerUploadedQuotationMutation, OwnerUploadedQuotationMutationVariables>(OwnerUploadedQuotationDocument, variables)(),
      options
    );
export const OwnerConfirmedQuotationDocument = `
    mutation OwnerConfirmedQuotation($clientProposalId: String!, $ownerConfirmedQuotationInputs: ClientProposalOwnerConfirmedQuotationInputDto!) {
  ownerConfirmedQuotation(
    clientProposalId: $clientProposalId
    ownerConfirmedQuotationInputs: $ownerConfirmedQuotationInputs
  ) {
    success
  }
}
    `;
export const useOwnerConfirmedQuotationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerConfirmedQuotationMutation, TError, OwnerConfirmedQuotationMutationVariables, TContext>) =>
    useMutation<OwnerConfirmedQuotationMutation, TError, OwnerConfirmedQuotationMutationVariables, TContext>(
      ['OwnerConfirmedQuotation'],
      (variables?: OwnerConfirmedQuotationMutationVariables) => fetcher<OwnerConfirmedQuotationMutation, OwnerConfirmedQuotationMutationVariables>(OwnerConfirmedQuotationDocument, variables)(),
      options
    );
export const OwnerDeclinedQuotationDocument = `
    mutation OwnerDeclinedQuotation($clientProposalId: String!) {
  ownerDeclinedQuotation(clientProposalId: $clientProposalId) {
    success
  }
}
    `;
export const useOwnerDeclinedQuotationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerDeclinedQuotationMutation, TError, OwnerDeclinedQuotationMutationVariables, TContext>) =>
    useMutation<OwnerDeclinedQuotationMutation, TError, OwnerDeclinedQuotationMutationVariables, TContext>(
      ['OwnerDeclinedQuotation'],
      (variables?: OwnerDeclinedQuotationMutationVariables) => fetcher<OwnerDeclinedQuotationMutation, OwnerDeclinedQuotationMutationVariables>(OwnerDeclinedQuotationDocument, variables)(),
      options
    );
export const OwnerDeclinedBookingDocument = `
    mutation OwnerDeclinedBooking($clientProposalId: String!) {
  ownerDeclinedBooking(clientProposalId: $clientProposalId) {
    success
  }
}
    `;
export const useOwnerDeclinedBookingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerDeclinedBookingMutation, TError, OwnerDeclinedBookingMutationVariables, TContext>) =>
    useMutation<OwnerDeclinedBookingMutation, TError, OwnerDeclinedBookingMutationVariables, TContext>(
      ['OwnerDeclinedBooking'],
      (variables?: OwnerDeclinedBookingMutationVariables) => fetcher<OwnerDeclinedBookingMutation, OwnerDeclinedBookingMutationVariables>(OwnerDeclinedBookingDocument, variables)(),
      options
    );
export const OwnerConfirmedBookingDocument = `
    mutation OwnerConfirmedBooking($clientProposalId: String!, $depositRate: Float!) {
  ownerConfirmedBooking(
    clientProposalId: $clientProposalId
    depositRate: $depositRate
  )
}
    `;
export const useOwnerConfirmedBookingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerConfirmedBookingMutation, TError, OwnerConfirmedBookingMutationVariables, TContext>) =>
    useMutation<OwnerConfirmedBookingMutation, TError, OwnerConfirmedBookingMutationVariables, TContext>(
      ['OwnerConfirmedBooking'],
      (variables?: OwnerConfirmedBookingMutationVariables) => fetcher<OwnerConfirmedBookingMutation, OwnerConfirmedBookingMutationVariables>(OwnerConfirmedBookingDocument, variables)(),
      options
    );
export const OwnerConfirmedAdjustmentsDocument = `
    mutation OwnerConfirmedAdjustments($clientProposalId: String!) {
  ownerConfirmedAdjustments(clientProposalId: $clientProposalId)
}
    `;
export const useOwnerConfirmedAdjustmentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerConfirmedAdjustmentsMutation, TError, OwnerConfirmedAdjustmentsMutationVariables, TContext>) =>
    useMutation<OwnerConfirmedAdjustmentsMutation, TError, OwnerConfirmedAdjustmentsMutationVariables, TContext>(
      ['OwnerConfirmedAdjustments'],
      (variables?: OwnerConfirmedAdjustmentsMutationVariables) => fetcher<OwnerConfirmedAdjustmentsMutation, OwnerConfirmedAdjustmentsMutationVariables>(OwnerConfirmedAdjustmentsDocument, variables)(),
      options
    );
export const OwnerAskedAdjustmentsModificationDocument = `
    mutation OwnerAskedAdjustmentsModification($clientProposalId: String!, $message: String!) {
  ownerAskedAdjustmentsModification(
    clientProposalId: $clientProposalId
    message: $message
  ) {
    success
  }
}
    `;
export const useOwnerAskedAdjustmentsModificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerAskedAdjustmentsModificationMutation, TError, OwnerAskedAdjustmentsModificationMutationVariables, TContext>) =>
    useMutation<OwnerAskedAdjustmentsModificationMutation, TError, OwnerAskedAdjustmentsModificationMutationVariables, TContext>(
      ['OwnerAskedAdjustmentsModification'],
      (variables?: OwnerAskedAdjustmentsModificationMutationVariables) => fetcher<OwnerAskedAdjustmentsModificationMutation, OwnerAskedAdjustmentsModificationMutationVariables>(OwnerAskedAdjustmentsModificationDocument, variables)(),
      options
    );
export const OwnerCreatedQuoteProvisionDocument = `
    mutation OwnerCreatedQuoteProvision($clientProposalId: String!, $quoteProvisionInputs: ClientProposalCreateQuoteProvisionInputDto!) {
  ownerCreatedQuoteProvision(
    clientProposalId: $clientProposalId
    quoteProvisionInputs: $quoteProvisionInputs
  ) {
    success
    error
  }
}
    `;
export const useOwnerCreatedQuoteProvisionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerCreatedQuoteProvisionMutation, TError, OwnerCreatedQuoteProvisionMutationVariables, TContext>) =>
    useMutation<OwnerCreatedQuoteProvisionMutation, TError, OwnerCreatedQuoteProvisionMutationVariables, TContext>(
      ['OwnerCreatedQuoteProvision'],
      (variables?: OwnerCreatedQuoteProvisionMutationVariables) => fetcher<OwnerCreatedQuoteProvisionMutation, OwnerCreatedQuoteProvisionMutationVariables>(OwnerCreatedQuoteProvisionDocument, variables)(),
      options
    );
export const OwnerUpdatedQuoteProvisionDocument = `
    mutation OwnerUpdatedQuoteProvision($clientProposalId: String!, $quoteProvisionInputs: ClientProposalUpdateQuoteProvisionInputDto!) {
  ownerUpdatedQuoteProvision(
    clientProposalId: $clientProposalId
    quoteProvisionInputs: $quoteProvisionInputs
  ) {
    success
  }
}
    `;
export const useOwnerUpdatedQuoteProvisionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerUpdatedQuoteProvisionMutation, TError, OwnerUpdatedQuoteProvisionMutationVariables, TContext>) =>
    useMutation<OwnerUpdatedQuoteProvisionMutation, TError, OwnerUpdatedQuoteProvisionMutationVariables, TContext>(
      ['OwnerUpdatedQuoteProvision'],
      (variables?: OwnerUpdatedQuoteProvisionMutationVariables) => fetcher<OwnerUpdatedQuoteProvisionMutation, OwnerUpdatedQuoteProvisionMutationVariables>(OwnerUpdatedQuoteProvisionDocument, variables)(),
      options
    );
export const OwnerDeletedQuoteProvisionDocument = `
    mutation OwnerDeletedQuoteProvision($clientPricingItemId: String!, $clientProposalId: String!) {
  ownerDeletedQuoteProvision(
    clientPricingItemId: $clientPricingItemId
    clientProposalId: $clientProposalId
  ) {
    success
  }
}
    `;
export const useOwnerDeletedQuoteProvisionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerDeletedQuoteProvisionMutation, TError, OwnerDeletedQuoteProvisionMutationVariables, TContext>) =>
    useMutation<OwnerDeletedQuoteProvisionMutation, TError, OwnerDeletedQuoteProvisionMutationVariables, TContext>(
      ['OwnerDeletedQuoteProvision'],
      (variables?: OwnerDeletedQuoteProvisionMutationVariables) => fetcher<OwnerDeletedQuoteProvisionMutation, OwnerDeletedQuoteProvisionMutationVariables>(OwnerDeletedQuoteProvisionDocument, variables)(),
      options
    );
export const OwnerCanceledQuoteProvisionSuppressionDocument = `
    mutation OwnerCanceledQuoteProvisionSuppression($clientPricingItemId: String!, $clientProposalId: String!) {
  ownerCanceledQuoteProvisionSuppression(
    clientPricingItemId: $clientPricingItemId
    clientProposalId: $clientProposalId
  ) {
    success
  }
}
    `;
export const useOwnerCanceledQuoteProvisionSuppressionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerCanceledQuoteProvisionSuppressionMutation, TError, OwnerCanceledQuoteProvisionSuppressionMutationVariables, TContext>) =>
    useMutation<OwnerCanceledQuoteProvisionSuppressionMutation, TError, OwnerCanceledQuoteProvisionSuppressionMutationVariables, TContext>(
      ['OwnerCanceledQuoteProvisionSuppression'],
      (variables?: OwnerCanceledQuoteProvisionSuppressionMutationVariables) => fetcher<OwnerCanceledQuoteProvisionSuppressionMutation, OwnerCanceledQuoteProvisionSuppressionMutationVariables>(OwnerCanceledQuoteProvisionSuppressionDocument, variables)(),
      options
    );
export const CheckMultiVatRatesValidityDocument = `
    query CheckMultiVatRatesValidity($clientProposalId: String!, $quoteProvisionInputs: ClientProposalCheckMultiVatRatesValidityInputDto!) {
  checkMultiVatRatesValidity(
    clientProposalId: $clientProposalId
    quoteProvisionInputs: $quoteProvisionInputs
  )
}
    `;
export const useCheckMultiVatRatesValidityQuery = <
      TData = CheckMultiVatRatesValidityQuery,
      TError = unknown
    >(
      variables: CheckMultiVatRatesValidityQueryVariables,
      options?: UseQueryOptions<CheckMultiVatRatesValidityQuery, TError, TData>
    ) =>
    useQuery<CheckMultiVatRatesValidityQuery, TError, TData>(
      ['CheckMultiVatRatesValidity', variables],
      fetcher<CheckMultiVatRatesValidityQuery, CheckMultiVatRatesValidityQueryVariables>(CheckMultiVatRatesValidityDocument, variables),
      options
    );
export const useInfiniteCheckMultiVatRatesValidityQuery = <
      TData = CheckMultiVatRatesValidityQuery,
      TError = unknown
    >(
      pageParamKey: keyof CheckMultiVatRatesValidityQueryVariables,
      variables: CheckMultiVatRatesValidityQueryVariables,
      options?: UseInfiniteQueryOptions<CheckMultiVatRatesValidityQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CheckMultiVatRatesValidityQuery, TError, TData>(
      ['CheckMultiVatRatesValidity.infinite', variables],
      (metaData) => fetcher<CheckMultiVatRatesValidityQuery, CheckMultiVatRatesValidityQueryVariables>(CheckMultiVatRatesValidityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const OwnerUpdatedQuoteProvisionsPositionsDocument = `
    mutation ownerUpdatedQuoteProvisionsPositions($clientPricingItemsIds: [String!]!, $clientProposalId: String!) {
  ownerUpdatedQuoteProvisionsPositions(
    clientPricingItemsIds: $clientPricingItemsIds
    clientProposalId: $clientProposalId
  ) {
    success
  }
}
    `;
export const useOwnerUpdatedQuoteProvisionsPositionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerUpdatedQuoteProvisionsPositionsMutation, TError, OwnerUpdatedQuoteProvisionsPositionsMutationVariables, TContext>) =>
    useMutation<OwnerUpdatedQuoteProvisionsPositionsMutation, TError, OwnerUpdatedQuoteProvisionsPositionsMutationVariables, TContext>(
      ['ownerUpdatedQuoteProvisionsPositions'],
      (variables?: OwnerUpdatedQuoteProvisionsPositionsMutationVariables) => fetcher<OwnerUpdatedQuoteProvisionsPositionsMutation, OwnerUpdatedQuoteProvisionsPositionsMutationVariables>(OwnerUpdatedQuoteProvisionsPositionsDocument, variables)(),
      options
    );
export const GetBookingPriceDocument = `
    query GetBookingPrice($clientPricingItems: [ClientPricingItemInputDto!]!, $houseId: String) {
  getBookingPrice(clientPricingItems: $clientPricingItems, houseId: $houseId) {
    priceItems {
      ...BookingPricePriceItems
    }
    totalUser {
      priceWithUserFees {
        ...ComputedPrice
      }
      basePrice {
        ...ComputedPrice
      }
      priceWithDiscountAndFees {
        ...ComputedPrice
      }
      priceWithDiscount {
        ...ComputedPrice
      }
      feesWithDiscount {
        ownerFeesPrice {
          ...ComputedPrice
        }
      }
      priceWithDiscountAndOwnerFees {
        ...ComputedPrice
      }
    }
  }
}
    ${BookingPricePriceItemsFragmentDoc}
${ClientPricingItemWithDiscountFragmentDoc}
${UnitPriceObjectWithDiscountFragmentDoc}
${ComputedPriceFragmentDoc}
${TotalPriceObjectWithDiscountFragmentDoc}`;
export const useGetBookingPriceQuery = <
      TData = GetBookingPriceQuery,
      TError = unknown
    >(
      variables: GetBookingPriceQueryVariables,
      options?: UseQueryOptions<GetBookingPriceQuery, TError, TData>
    ) =>
    useQuery<GetBookingPriceQuery, TError, TData>(
      ['GetBookingPrice', variables],
      fetcher<GetBookingPriceQuery, GetBookingPriceQueryVariables>(GetBookingPriceDocument, variables),
      options
    );
export const useInfiniteGetBookingPriceQuery = <
      TData = GetBookingPriceQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetBookingPriceQueryVariables,
      variables: GetBookingPriceQueryVariables,
      options?: UseInfiniteQueryOptions<GetBookingPriceQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetBookingPriceQuery, TError, TData>(
      ['GetBookingPrice.infinite', variables],
      (metaData) => fetcher<GetBookingPriceQuery, GetBookingPriceQueryVariables>(GetBookingPriceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CreateTokenOwnerAccessDocument = `
    mutation CreateTokenOwnerAccess {
  createTokenOwnerAccess
}
    `;
export const useCreateTokenOwnerAccessMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTokenOwnerAccessMutation, TError, CreateTokenOwnerAccessMutationVariables, TContext>) =>
    useMutation<CreateTokenOwnerAccessMutation, TError, CreateTokenOwnerAccessMutationVariables, TContext>(
      ['CreateTokenOwnerAccess'],
      (variables?: CreateTokenOwnerAccessMutationVariables) => fetcher<CreateTokenOwnerAccessMutation, CreateTokenOwnerAccessMutationVariables>(CreateTokenOwnerAccessDocument, variables)(),
      options
    );
export const GetHouseOwnerClientPricingItemsDocument = `
    query GetHouseOwnerClientPricingItems($houseId: String!) {
  getHouseOwnerClientPricingItems(houseId: $houseId) {
    ...ClientPricingItem
  }
}
    ${ClientPricingItemFragmentDoc}
${ClientPricingItemObjectDataFragmentDoc}
${ComputedPriceFragmentDoc}
${NestedItemObjectDataFragmentDoc}
${ClientPricingItemWithDiscountFragmentDoc}
${UnitPriceObjectWithDiscountFragmentDoc}
${TotalPriceObjectWithDiscountFragmentDoc}`;
export const useGetHouseOwnerClientPricingItemsQuery = <
      TData = GetHouseOwnerClientPricingItemsQuery,
      TError = unknown
    >(
      variables: GetHouseOwnerClientPricingItemsQueryVariables,
      options?: UseQueryOptions<GetHouseOwnerClientPricingItemsQuery, TError, TData>
    ) =>
    useQuery<GetHouseOwnerClientPricingItemsQuery, TError, TData>(
      ['GetHouseOwnerClientPricingItems', variables],
      fetcher<GetHouseOwnerClientPricingItemsQuery, GetHouseOwnerClientPricingItemsQueryVariables>(GetHouseOwnerClientPricingItemsDocument, variables),
      options
    );
export const useInfiniteGetHouseOwnerClientPricingItemsQuery = <
      TData = GetHouseOwnerClientPricingItemsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetHouseOwnerClientPricingItemsQueryVariables,
      variables: GetHouseOwnerClientPricingItemsQueryVariables,
      options?: UseInfiniteQueryOptions<GetHouseOwnerClientPricingItemsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetHouseOwnerClientPricingItemsQuery, TError, TData>(
      ['GetHouseOwnerClientPricingItems.infinite', variables],
      (metaData) => fetcher<GetHouseOwnerClientPricingItemsQuery, GetHouseOwnerClientPricingItemsQueryVariables>(GetHouseOwnerClientPricingItemsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const OwnerAddICalendarUrlsDocument = `
    mutation ownerAddICalendarUrls($houseId: String!, $inputDto: HouseICalendarUrlsInputDto!) {
  ownerAddICalendarUrls(houseId: $houseId, inputDto: $inputDto) {
    error
    success
  }
}
    `;
export const useOwnerAddICalendarUrlsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerAddICalendarUrlsMutation, TError, OwnerAddICalendarUrlsMutationVariables, TContext>) =>
    useMutation<OwnerAddICalendarUrlsMutation, TError, OwnerAddICalendarUrlsMutationVariables, TContext>(
      ['ownerAddICalendarUrls'],
      (variables?: OwnerAddICalendarUrlsMutationVariables) => fetcher<OwnerAddICalendarUrlsMutation, OwnerAddICalendarUrlsMutationVariables>(OwnerAddICalendarUrlsDocument, variables)(),
      options
    );
export const OwnerGetHouseWithAvailabilitiesDocument = `
    query OwnerGetHouseWithAvailabilities($houseId: String!) {
  ownerGetHouseWithAvailabilities(houseId: $houseId) {
    ...HouseContextOwner
  }
}
    ${HouseContextOwnerFragmentDoc}
${HouseOptionsFragmentDoc}
${HouseOptionsGlobalFragmentDoc}
${CorporateEveningGlobalFragmentDoc}
${NightlyTripGlobalFragmentDoc}
${StudyDayGlobalFragmentDoc}
${SeasonalBusynessCalendarFragmentDoc}
${HouseOptionsIndividualFragmentDoc}
${CorporateEveningIndividualFragmentDoc}
${NightlyTripIndividualFragmentDoc}
${StudyDayIndividualFragmentDoc}
${HouseAvailabilityFragmentDoc}
${HouseAvailabilityGlobalFragmentDoc}
${HouseAvailabilityIndividualFragmentDoc}
${HouseAvailabilityICalendarFragmentDoc}`;
export const useOwnerGetHouseWithAvailabilitiesQuery = <
      TData = OwnerGetHouseWithAvailabilitiesQuery,
      TError = unknown
    >(
      variables: OwnerGetHouseWithAvailabilitiesQueryVariables,
      options?: UseQueryOptions<OwnerGetHouseWithAvailabilitiesQuery, TError, TData>
    ) =>
    useQuery<OwnerGetHouseWithAvailabilitiesQuery, TError, TData>(
      ['OwnerGetHouseWithAvailabilities', variables],
      fetcher<OwnerGetHouseWithAvailabilitiesQuery, OwnerGetHouseWithAvailabilitiesQueryVariables>(OwnerGetHouseWithAvailabilitiesDocument, variables),
      options
    );
export const useInfiniteOwnerGetHouseWithAvailabilitiesQuery = <
      TData = OwnerGetHouseWithAvailabilitiesQuery,
      TError = unknown
    >(
      pageParamKey: keyof OwnerGetHouseWithAvailabilitiesQueryVariables,
      variables: OwnerGetHouseWithAvailabilitiesQueryVariables,
      options?: UseInfiniteQueryOptions<OwnerGetHouseWithAvailabilitiesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<OwnerGetHouseWithAvailabilitiesQuery, TError, TData>(
      ['OwnerGetHouseWithAvailabilities.infinite', variables],
      (metaData) => fetcher<OwnerGetHouseWithAvailabilitiesQuery, OwnerGetHouseWithAvailabilitiesQueryVariables>(OwnerGetHouseWithAvailabilitiesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const OwnerUpdateHouseCorporateEveningDocument = `
    mutation OwnerUpdateHouseCorporateEvening($houseId: String!, $dto: HouseCorporateEveningDto!) {
  ownerUpdateHouseCorporateEvening(houseId: $houseId, dto: $dto) {
    success
    error
  }
}
    `;
export const useOwnerUpdateHouseCorporateEveningMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerUpdateHouseCorporateEveningMutation, TError, OwnerUpdateHouseCorporateEveningMutationVariables, TContext>) =>
    useMutation<OwnerUpdateHouseCorporateEveningMutation, TError, OwnerUpdateHouseCorporateEveningMutationVariables, TContext>(
      ['OwnerUpdateHouseCorporateEvening'],
      (variables?: OwnerUpdateHouseCorporateEveningMutationVariables) => fetcher<OwnerUpdateHouseCorporateEveningMutation, OwnerUpdateHouseCorporateEveningMutationVariables>(OwnerUpdateHouseCorporateEveningDocument, variables)(),
      options
    );
export const OwnerUpdateHouseNightlyTripDocument = `
    mutation OwnerUpdateHouseNightlyTrip($houseId: String!, $dto: HouseNightlyTripDto!) {
  ownerUpdateHouseNightlyTrip(houseId: $houseId, dto: $dto) {
    success
    error
  }
}
    `;
export const useOwnerUpdateHouseNightlyTripMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerUpdateHouseNightlyTripMutation, TError, OwnerUpdateHouseNightlyTripMutationVariables, TContext>) =>
    useMutation<OwnerUpdateHouseNightlyTripMutation, TError, OwnerUpdateHouseNightlyTripMutationVariables, TContext>(
      ['OwnerUpdateHouseNightlyTrip'],
      (variables?: OwnerUpdateHouseNightlyTripMutationVariables) => fetcher<OwnerUpdateHouseNightlyTripMutation, OwnerUpdateHouseNightlyTripMutationVariables>(OwnerUpdateHouseNightlyTripDocument, variables)(),
      options
    );
export const OwnerUpdateHouseSeasonalBusynessCalendarDocument = `
    mutation OwnerUpdateHouseSeasonalBusynessCalendar($houseId: String!, $dto: [HouseSeasonalBusynessCalendarDto!]!) {
  ownerUpdateHouseSeasonalBusynessCalendar(houseId: $houseId, dto: $dto) {
    success
    error
  }
}
    `;
export const useOwnerUpdateHouseSeasonalBusynessCalendarMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerUpdateHouseSeasonalBusynessCalendarMutation, TError, OwnerUpdateHouseSeasonalBusynessCalendarMutationVariables, TContext>) =>
    useMutation<OwnerUpdateHouseSeasonalBusynessCalendarMutation, TError, OwnerUpdateHouseSeasonalBusynessCalendarMutationVariables, TContext>(
      ['OwnerUpdateHouseSeasonalBusynessCalendar'],
      (variables?: OwnerUpdateHouseSeasonalBusynessCalendarMutationVariables) => fetcher<OwnerUpdateHouseSeasonalBusynessCalendarMutation, OwnerUpdateHouseSeasonalBusynessCalendarMutationVariables>(OwnerUpdateHouseSeasonalBusynessCalendarDocument, variables)(),
      options
    );
export const OwnerUpdateHouseStudyDayDocument = `
    mutation OwnerUpdateHouseStudyDay($houseId: String!, $dto: HouseStudyDayDto!) {
  ownerUpdateHouseStudyDay(houseId: $houseId, dto: $dto) {
    success
    error
  }
}
    `;
export const useOwnerUpdateHouseStudyDayMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerUpdateHouseStudyDayMutation, TError, OwnerUpdateHouseStudyDayMutationVariables, TContext>) =>
    useMutation<OwnerUpdateHouseStudyDayMutation, TError, OwnerUpdateHouseStudyDayMutationVariables, TContext>(
      ['OwnerUpdateHouseStudyDay'],
      (variables?: OwnerUpdateHouseStudyDayMutationVariables) => fetcher<OwnerUpdateHouseStudyDayMutation, OwnerUpdateHouseStudyDayMutationVariables>(OwnerUpdateHouseStudyDayDocument, variables)(),
      options
    );
export const OwnerUpsertHouseAvailabilityDocument = `
    mutation OwnerUpsertHouseAvailability($houseId: String!, $inputDto: HouseAvailabilityGlobalOrIndividualDto!) {
  ownerUpsertHouseAvailability(houseId: $houseId, inputDto: $inputDto) {
    error
    success
  }
}
    `;
export const useOwnerUpsertHouseAvailabilityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerUpsertHouseAvailabilityMutation, TError, OwnerUpsertHouseAvailabilityMutationVariables, TContext>) =>
    useMutation<OwnerUpsertHouseAvailabilityMutation, TError, OwnerUpsertHouseAvailabilityMutationVariables, TContext>(
      ['OwnerUpsertHouseAvailability'],
      (variables?: OwnerUpsertHouseAvailabilityMutationVariables) => fetcher<OwnerUpsertHouseAvailabilityMutation, OwnerUpsertHouseAvailabilityMutationVariables>(OwnerUpsertHouseAvailabilityDocument, variables)(),
      options
    );
export const OwnerUpsertManyHouseAvailabilitiesDocument = `
    mutation OwnerUpsertManyHouseAvailabilities($houseId: String!, $inputDtos: HouseAvailabilityGlobalOrIndividualManyDto!) {
  ownerUpsertManyHouseAvailabilities(houseId: $houseId, inputDtos: $inputDtos) {
    error
    success
  }
}
    `;
export const useOwnerUpsertManyHouseAvailabilitiesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerUpsertManyHouseAvailabilitiesMutation, TError, OwnerUpsertManyHouseAvailabilitiesMutationVariables, TContext>) =>
    useMutation<OwnerUpsertManyHouseAvailabilitiesMutation, TError, OwnerUpsertManyHouseAvailabilitiesMutationVariables, TContext>(
      ['OwnerUpsertManyHouseAvailabilities'],
      (variables?: OwnerUpsertManyHouseAvailabilitiesMutationVariables) => fetcher<OwnerUpsertManyHouseAvailabilitiesMutation, OwnerUpsertManyHouseAvailabilitiesMutationVariables>(OwnerUpsertManyHouseAvailabilitiesDocument, variables)(),
      options
    );
export const OwnerKeepICalendarUpToDateDocument = `
    mutation OwnerKeepICalendarUpToDate($houseId: String!) {
  ownerKeepICalendarUpToDate(houseId: $houseId) {
    error
    success
  }
}
    `;
export const useOwnerKeepICalendarUpToDateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<OwnerKeepICalendarUpToDateMutation, TError, OwnerKeepICalendarUpToDateMutationVariables, TContext>) =>
    useMutation<OwnerKeepICalendarUpToDateMutation, TError, OwnerKeepICalendarUpToDateMutationVariables, TContext>(
      ['OwnerKeepICalendarUpToDate'],
      (variables?: OwnerKeepICalendarUpToDateMutationVariables) => fetcher<OwnerKeepICalendarUpToDateMutation, OwnerKeepICalendarUpToDateMutationVariables>(OwnerKeepICalendarUpToDateDocument, variables)(),
      options
    );
export const PublicGetHouseAvailabilitiesFromToDocument = `
    query PublicGetHouseAvailabilitiesFromTo($inputDto: HouseAvailabilityGetFromToInputDto!) {
  publicGetHouseAvailabilitiesFromTo(inputDto: $inputDto) {
    ... on HouseAvailabilityGlobalOutputDto {
      ...HouseAvailabilityGlobal
    }
    ... on HouseAvailabilityICalendarOutputDto {
      ...HouseAvailabilityICalendar
    }
    ... on HouseAvailabilityIndividualOutputDto {
      ...HouseAvailabilityIndividual
    }
  }
}
    ${HouseAvailabilityGlobalFragmentDoc}
${HouseAvailabilityICalendarFragmentDoc}
${HouseAvailabilityIndividualFragmentDoc}`;
export const usePublicGetHouseAvailabilitiesFromToQuery = <
      TData = PublicGetHouseAvailabilitiesFromToQuery,
      TError = unknown
    >(
      variables: PublicGetHouseAvailabilitiesFromToQueryVariables,
      options?: UseQueryOptions<PublicGetHouseAvailabilitiesFromToQuery, TError, TData>
    ) =>
    useQuery<PublicGetHouseAvailabilitiesFromToQuery, TError, TData>(
      ['PublicGetHouseAvailabilitiesFromTo', variables],
      fetcher<PublicGetHouseAvailabilitiesFromToQuery, PublicGetHouseAvailabilitiesFromToQueryVariables>(PublicGetHouseAvailabilitiesFromToDocument, variables),
      options
    );
export const useInfinitePublicGetHouseAvailabilitiesFromToQuery = <
      TData = PublicGetHouseAvailabilitiesFromToQuery,
      TError = unknown
    >(
      pageParamKey: keyof PublicGetHouseAvailabilitiesFromToQueryVariables,
      variables: PublicGetHouseAvailabilitiesFromToQueryVariables,
      options?: UseInfiniteQueryOptions<PublicGetHouseAvailabilitiesFromToQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PublicGetHouseAvailabilitiesFromToQuery, TError, TData>(
      ['PublicGetHouseAvailabilitiesFromTo.infinite', variables],
      (metaData) => fetcher<PublicGetHouseAvailabilitiesFromToQuery, PublicGetHouseAvailabilitiesFromToQueryVariables>(PublicGetHouseAvailabilitiesFromToDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const UpdateUserTravelCityDocument = `
    mutation UpdateUserTravelCity($input: FilterLocationDto!) {
  updateUserTravelCity(input: $input) {
    success
  }
}
    `;
export const useUpdateUserTravelCityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserTravelCityMutation, TError, UpdateUserTravelCityMutationVariables, TContext>) =>
    useMutation<UpdateUserTravelCityMutation, TError, UpdateUserTravelCityMutationVariables, TContext>(
      ['UpdateUserTravelCity'],
      (variables?: UpdateUserTravelCityMutationVariables) => fetcher<UpdateUserTravelCityMutation, UpdateUserTravelCityMutationVariables>(UpdateUserTravelCityDocument, variables)(),
      options
    );
export const GetUserContextDocument = `
    query GetUserContext {
  getHouseOwnerContext {
    _id
    email
    firstname
    lastname
    notifications
    houses {
      _id
      readableId
      title
      pathname
      specialConditions {
        url
      }
      pictures {
        _id
        uri
      }
      priceType
      status
      admin {
        firstname
        label
        profilePicture
        email
      }
    }
  }
}
    `;
export const useGetUserContextQuery = <
      TData = GetUserContextQuery,
      TError = unknown
    >(
      variables?: GetUserContextQueryVariables,
      options?: UseQueryOptions<GetUserContextQuery, TError, TData>
    ) =>
    useQuery<GetUserContextQuery, TError, TData>(
      variables === undefined ? ['GetUserContext'] : ['GetUserContext', variables],
      fetcher<GetUserContextQuery, GetUserContextQueryVariables>(GetUserContextDocument, variables),
      options
    );
export const useInfiniteGetUserContextQuery = <
      TData = GetUserContextQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetUserContextQueryVariables,
      variables?: GetUserContextQueryVariables,
      options?: UseInfiniteQueryOptions<GetUserContextQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetUserContextQuery, TError, TData>(
      variables === undefined ? ['GetUserContext.infinite'] : ['GetUserContext.infinite', variables],
      (metaData) => fetcher<GetUserContextQuery, GetUserContextQueryVariables>(GetUserContextDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetMeOwnerDocument = `
    mutation GetMeOwner {
  owner {
    ...HouseOwnerLightContextField
  }
}
    ${HouseOwnerLightContextFieldFragmentDoc}
${HouseOwnerHouseFieldFragmentDoc}`;
export const useGetMeOwnerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetMeOwnerMutation, TError, GetMeOwnerMutationVariables, TContext>) =>
    useMutation<GetMeOwnerMutation, TError, GetMeOwnerMutationVariables, TContext>(
      ['GetMeOwner'],
      (variables?: GetMeOwnerMutationVariables) => fetcher<GetMeOwnerMutation, GetMeOwnerMutationVariables>(GetMeOwnerDocument, variables)(),
      options
    );